export const plLangDashboard = {
  headerSearch: {
    placeholder: 'Szukaj produktów',
    cancel: 'Anuluj',
    empty: 'Nie znaleziono produktów',
    noShop: 'Brak produktów do wyszukania',
  },
  adminUi: {
    podcastEnterShowTitle: 'Wpisz tytuł audycji',
    podcastMaximum: 'Maksymalnie',
    podcastCharacters: 'znaków',
    podcastShowTitleExists: 'Audycja o tej nazwie już istnieje',
    podcastEditShow: 'Edytuj audycję',
    podcastNewShow: 'Nowa audycja',
    podcastCover: 'Okładka',
    podcastTitle: 'Tytuł',
    podcastShowTitlePlaceholder: 'Tytuł audycji',
    podcastCategory: 'Kategoria',
    podcastCategoryPlaceholder: 'np. Kryminał',
    podcastDescription: 'Opis',
    podcastDescriptionPlaceholder: 'O czym jest ta audycja…',
    podcastSubscribeButtons: 'Przyciski „Subskrybuj”',
    podcastAddPlatform: 'Dodaj platformę',
    podcastSave: 'Zapisz',
    podcastCreate: 'Utwórz',
    episodeOne: 'odcinek',
    episodeFew: 'odcinki',
    episodeMany: 'odcinków',
    edit: 'Edytuj',
    delete: 'usuń',
    addShow: 'Dodaj audycję',
    importFromRss: 'Importuj z RSS',
    importFromRssFeed: 'Importuj z kanału RSS',
    importFromRssHint: 'Wklej link RSS podcastu — odcinki zostaną automatycznie pobrane do nowej audycji.',
    import: 'Importuj',
    trackWordOne: 'utwór',
    trackWordFew: 'utwory',
    trackWordMany: 'utworów',
    albumLabel: 'Album',
    pause: 'Pauza',
    play: 'Odtwórz',
    emptyTracks: 'Brak utworów w tym albumie',
    untitled: 'Bez tytułu',
    show: 'Audycja',
    audioFileNotAttached: 'Nie dołączono pliku audio',
    paypalConnectionTitle: 'Wybierz metodę połączenia z PayPal',
    paypalConnectionSubtitle: 'Wybierz najwygodniejszą dla Ciebie metodę połączenia',
    paypalRecommendedBadge: 'Polecane',
    paypalPartnerTitle: 'Przez partnera PayPal',
    paypalPartnerFeatureQuickConnect: 'Szybkie połączenie w 1 kliknięcie',
    paypalPartnerFeatureAutoTokens: 'Automatyczne odświeżanie tokenów',
    paypalPartnerFeatureMostSecure: 'Najbezpieczniejsza metoda',
    paypalPartnerFeatureNoApiKeys: 'Bez kopiowania kluczy API',
    paypalPartnerButton: 'Połącz przez partnera',
    paypalDirectTitle: 'Bezpośrednio (dane API)',
    paypalDirectFeatureClientIdSecret: 'Wymaga Client ID i Secret',
    paypalDirectFeatureManualSetup: 'Konfiguracja ręczna',
    paypalDirectFeatureFullControl: 'Pełna kontrola nad API',
    paypalDirectFeatureAdvancedUsers: 'Dla zaawansowanych',
    paypalDirectButton: 'Połącz bezpośrednio',
    clientIdRequired: 'Client ID jest wymagane',
    clientSecretRequired: 'Client Secret jest wymagane',
    invalidPaypalCredentials: 'Nieprawidłowe dane PayPal',
    connectPaypalDirectly: 'Połącz PayPal bezpośrednio',
    paypalConnectedSuccessfully: 'PayPal połączony pomyślnie!',
    yourPaypalClientId: 'Twój Client ID PayPal z panelu',
    yourPaypalClientSecret: 'Twój Client Secret PayPal z panelu',
    chooseOperatingMode: 'Wybierz tryb działania',
    sandboxTest: 'Sandbox (testowy)',
    liveProduction: 'Live (produkcyjny)',
    whereToFindCredentials: '💡 Gdzie znaleźć dane?',
    goTo: 'Przejdź do',
    createOrSelectApp: 'Utwórz nową aplikację lub wybierz istniejącą',
    copyClientIdAndSecret: 'Skopiuj Client ID i Secret',
    cancel: 'Anuluj',
    connected: 'Połączono!',
    connect: 'Połącz',
    monobankTokenTooltip: 'Token z Monobank Business Acquiring',
    monobankTokenPlaceholder: 'Wpisz token Monobank',
    whereToGetToken: 'Gdzie zdobyć token?',
    statusChangedTo: 'Status zmieniony na',
    all: 'Wszystkie',
    loading: 'Ładowanie...',
    noBookingsYet: 'Brak rezerwacji',
    noBookingsWithStatus: 'Brak rezerwacji o tym statusie',
    nightsAbbr: 'noce',
    uah: 'UAH',
    oneNightDeposit: 'Zadatek za jedną noc',
    fullPrepayment: 'Pełna przedpłata',
    online: 'Online',
    confirm: 'Potwierdź',
    complete: 'Zakończ',
    restore: 'Przywróć',
    bookingCalendarBooked: 'Zarezerwowane',
    bookingCalendarBlockedManually: 'Zablokowane ręcznie',
    bookingCalendarAvailable: 'Dostępne',
    bookingCalendarNoSettings: 'Brak ustawień',
    bookingCalendarSaveItemFirst: 'Najpierw zapisz element',
    bookingCalendarLoading: 'Ładowanie...',
    bookingCalendarBlocked: 'Zablokowane',
    bookingCalendarSelected: 'Wybrane',
    bookingCalendarSelectedDates: 'Wybrane daty',
    bookingCalendarPricePerDay: 'Cena/dzień',
    bookingCalendarOpen: 'Otwórz',
    bookingCalendarBlock: 'Zablokuj',
    bookingCalendarCancel: 'Anuluj',
    responseDeleted: 'Odpowiedź usunięta',
    deleteAllConfirm: 'Usunąć wszystkie odpowiedzi? Tej czynności nie można cofnąć.',
    allResponsesDeleted: 'Wszystkie odpowiedzi usunięte',
    responseOne: 'odpowiedź',
    responseFew: 'odpowiedzi',
    responseMany: 'odpowiedzi',
    deleteAll: 'Usuń wszystkie',
    allForms: 'Wszystkie formularze',
    noResponsesYet: 'Brak odpowiedzi',
    fieldName: 'Imię',
    fieldPhone: 'Telefon',
    fieldAddress: 'Adres',
    fieldComment: 'Komentarz',
    customFields: 'Dodatkowe pola',
    more: 'Więcej',
    view: 'Podgląd',
    track: 'Utwór',
    showing: 'Wyświetlanie',
    of: 'z',
    ordersLower: 'zamówienia',
    ordersEmpty: 'Brak wpisów',
    ordersCountLabel: 'wpisów',
    ordersName: 'Imię',
    ordersPhone: 'Telefon',
    ordersLoading: 'Ładowanie...',
    ordersComment: 'Komentarz',
    ordersPayment: 'Płatność',
    ordersPrev: 'Poprzednia',
    ordersNext: 'Następna',
    revokeAccessConfirm: 'Odebrać dostęp?',
    accessRevoked: 'Dostęp odebrany',
    activeGrants: 'aktywne uprawnienia',
    noActiveGrants: 'Brak aktywnych uprawnień',
    type: 'Typ',
    grantedBy: 'Nadane przez',
    started: 'Rozpoczęto',
    until: 'Do',
    revoke: 'Odbierz',
    deleted: 'Usunięto',
    subscribers: 'subskrybentów',
    noSubscribersYet: 'Brak subskrybentów',
    phone: 'Telefon',
    name: 'Imię',
    step: 'Krok',
    done: 'gotowe',
    stepFailedSingular: 'krok nieudany',
    stepFailedPlural: 'kroki nieudane',
    done2: 'Gotowe.',
    actionFailed: 'Nie udało się wykonać akcji.',
    starterCoffeeSite: 'Zrób stronę dla kawiarni',
    starterFaq: 'Dodaj blok FAQ z 5 pytaniami',
    starterTranslate: 'Przetłumacz całą stronę na angielski',
    starterBrandColors: 'Dobierz kolory pasujące do mojej marki',
    stopped: 'Zatrzymano.',
    scopeSite: 'Strona',
    scopePage: 'Podstrona',
    followUpAddPhoto: 'Dodaj jeszcze jedno zdjęcie',
    followUpAddQuestion: 'Dodaj kolejne pytanie',
    followUpAddPlan: 'Dodaj kolejny plan cenowy',
    followUpAddService: 'Dodaj kolejną usługę',
    followUpAddBlock: 'Dodaj jeszcze jeden blok',
    followUpMakeBetter: 'Zrób to jeszcze lepiej',
    followUpTweakColors: 'Dostosuj kolory do mojej marki',
    followUpChangeColors: 'Zmień kolory',
    followUpTranslateEnglish: 'Przetłumacz na angielski',
    undoneDeletedPrefix: 'Cofnięto — usunięto',
    undoneOf: 'z',
    undoneCreatedBlocks: 'utworzonych bloków',
    planAnalyzing: 'Analiza zapytania',
    planCheckingSite: 'Sprawdzanie stanu strony',
    planChoosingBlocks: 'Wybieranie bloków',
    planPreparing: 'Przygotowywanie planu',
    hideDetails: 'Ukryj szczegóły',
    details: 'Szczegóły',
    emptyStateTitle: 'Jak mogę pomóc?',
    emptyStateSubtitle: 'Opisz, co zrobić — lub wybierz przykład poniżej',
    undoing: 'Cofanie…',
    undo: 'Cofnij',
    blockSingular: 'blok',
    blockPlural: 'bloki',
    usageCostTitle: 'Koszt tego zapytania',
    tokens: 'tokeny',
    stop: 'Zatrzymaj',
    scopeSiteTitle: 'Zmiany na całej stronie',
    scopePageTitle: 'Zmiany tylko na bieżącej podstronie',
    customDesign: 'Własny design',
    appointmentEmbedTitle: 'Osadzony URL',
    appointmentEmbedSubtitle: 'Osadź Calendly jako iframe',
    appointmentEmbedCaption: 'URL Calendly',
    appointmentEmbedTooltip: 'Wklej URL wydarzenia Calendly (np. https://calendly.com/ty/30min)',
    appointmentEmbedInvalid: 'Wpisz prawidłowy URL Calendly (np. https://calendly.com/ty/30min)',
  },
  ama: {
    questions: 'pytania',
    all: 'Wszystkie',
    unanswered: 'Bez odpowiedzi',
    answered: 'Z odpowiedzią',
    loading: 'Ładowanie...',
    noQuestions: 'Brak pytań',
    anonymous: 'Anonimowo',
    noName: 'Brak imienia',
    yourAnswer: 'Twoja odpowiedź',
    edit: 'Edytuj',
    delete: 'Usuń',
    cancel: 'Anuluj',
    enterAnswer: 'Wpisz odpowiedź...',
    saveAnswer: 'Zapisz odpowiedź',
    confirmDelete: 'Usunąć to pytanie?',
    answerSaved: 'Odpowiedź zapisana',
    deleted: 'Usunięto',
  },
  adsManager: {
    estimatedAudience: 'Szacowana wielkość odbiorców',
    audienceTooLarge: 'Twoi odbiorcy są bardzo szeroko zdefiniowani — rozważ ich zawężenie.',
    audienceTooNarrow: 'Twoi odbiorcy są bardzo wąsko zdefiniowani — rozważ ich poszerzenie.',
    audience: 'Odbiorcy',
    suggestedAudience: 'Użyj sugerowanych odbiorców',
    suggestedAudienceHint: 'Szerokie targetowanie, najlepsze dla zasięgu',
    buildYourOwn: 'Zbuduj własnych',
    buildYourOwnHint: 'Ustaw wiek, płeć i kraje',
    expectedViewers: 'Oczekiwana liczba odbiorców reklamy',
    totalBudget: 'Całkowity budżet kampanii',
    duration: 'Czas trwania',
    days: 'dni',
    advancedSchedule: 'Zaawansowany harmonogram',
    hideAdvanced: 'Ukryj zaawansowany harmonogram',
    adPreview: 'Podgląd reklamy',
    sponsored: 'Sponsorowane',
    seeMore: 'Zobacz więcej',
    learnMore: 'Dowiedz się więcej',
    yourPage: 'Twoja strona',
  },
  pinnedDock: {
    title: 'Przypięte bloki',
    label: 'PRZYPIĘTE',
    expand: 'Rozwiń przypięte bloki',
    collapse: 'Zwiń przypięte bloki',
  },
  reviewButton: {
    title: 'Przycisk „Zostaw opinię”',
    desc: 'Pokaż przycisk pod opiniami, który kieruje odwiedzających tam, gdzie mogą zostawić opinię.',
    buttonText: 'Tekst przycisku',
    link: 'Link',
    leaveReview: 'Zostaw opinię',
    googleHint: 'Pozostaw puste, aby użyć strony opinii Google.',
    design: 'Design przycisku',
    background: 'Tło',
    textColor: 'Tekst',
  },
  common: {
    you: 'Ty',
    post: 'Post',
    article: 'Artykuł',
    create: 'Utwórz',
    message: 'Wiadomość',
    popular: 'Popularne',
    emptyIntegrations: 'Musisz najpierw dodać integracje',
    categories: 'Kategorie',
    edit: 'Edytuj',
    share: 'Udostępnij',
    plan: 'Plan',
    sort: 'Sortuj',
    addArticle: 'Dodaj artykuł',
    articles: 'Artykuły',
    users: 'użytkowników',
    scans: 'skanów',
    clicks: 'kliknięć',
    copy: 'Kopiuj',
    customize: 'Dostosuj',
    link: 'link',
    save: 'Zapisz',
    uploadFile: 'Prześlij plik',
    customImage: 'Własny obraz',
    customImageTooltip: 'Prześlij własny obraz',
    size: 'Rozmiar',
    sizeTooltip: 'Przeciągnij suwak, aby ustawić rozmiar',
    auto: 'Automatycznie',
    rectangle: 'Prostokąt',
    custom: 'Własny',
    clean: 'Wyczyść',
    cleaning: 'Czyszczenie',
    download: 'Pobierz',
    downloading: 'Pobieranie',
    preview: 'PODGLĄD',
    cover: 'Okładka',
    coverTooltip: 'Prześlij zdjęcie okładki',
    title: 'Tytuł',
    new: 'Nowe',
    pro: 'Pro',
    free: 'Darmowy',
    limit: 'Limit',
    websites: 'stron',
    site: 'Strona',
    apiKey: 'Klucz API',
    name: 'Nazwa',
    passwordChange: 'Zmiana hasła',
    draft: 'Szkic',
    page: 'Podstrona',
    areYouSure: 'Czy na pewno?',
    drop: 'Upuść',
    video: 'wideo',
    image: 'obraz',
    chooseFile: 'Wybierz plik',
    nothingFound: 'Nic nie znaleziono',
    enterCorrectLink: 'Wpisz poprawny link',
    off: 'Wyłączone',
    disconnect: 'ROZŁĄCZ',
    connect: 'POŁĄCZ',
    copied: 'Skopiowano',
    saved: 'Zapisano',
    lostConnection: 'Utracono połączenie',
    addedCategory: 'Dodano kategorię',
    none: 'Brak',
    left: 'Lewo',
    right: 'Prawo',
    thin: 'Cienka',
    solid: 'Ciągła',
    double: 'Podwójna',
    welcome: 'Witaj',
    category: 'Kategoria',
    product: 'Produkt',
    website: 'Strona',
    items: 'Elementy',
    square: 'Kwadrat',
    round: 'Okrągły',
    border: 'Obramowanie',
    shadow: 'Cień',
    subtle: 'Subtelny',
    soft: 'Miękki',
    hard: 'Ostry',
    block: 'Blok',
    primary: 'Główny',
    additional: 'Dodatkowy',
    normal: 'Normalny',
    bold: 'Pogrubiony',
    uploadVideo: 'Prześlij wideo',
    compact: 'Kompaktowy',
    card: 'Karta',
    top: 'Góra',
    center: 'Środek',
    bottom: 'Dół',
    button: 'Przycisk',
    addNewItem: 'Dodaj nowy element',
    blockEmptyTitle: 'Jeszcze nic tu nie ma',
    blockEmptyText: 'Ten blok nie ma jeszcze żadnych elementów. Dodaj jeden, aby pojawił się na Twojej stronie.',
    noItemsTitle: 'Nie masz jeszcze żadnych elementów',
    noItemsText: 'Dodaj pierwszy element, aby wypełnić ten blok.',
    price: 'Cena',
    priceCaption: 'Dodaj cenę produktu',
    oldPrice: 'Stara cena',
    oldPriceCaption: 'Stara cena będzie przekreślona',
    areYouSureDeleteItem: 'Czy na pewno chcesz usunąć ten element?',
    add: 'Dodaj',
    active: 'Aktywny',
    isActive: 'jest aktywny',
    isDisabled: 'jest wyłączony',
    uploadImage: 'Prześlij obraz',
    design: 'Design',
    addAccount: 'Dodaj konto',
    hey: 'Cześć',
    activeBackground: 'Aktywne tło',
    activeText: 'Aktywny tekst',
    connectDomain: 'Połącz domenę',
    shortLink: 'Krótki link',
    appearanceSaved: 'Wygląd zapisany!',
    blockAdded: 'Blok dodany!',
    comingSoon: 'Wkrótce',
    easyMoney: 'Łatwe pieniądze',
    content: 'Treść',
    audience: 'Odbiorcy',
    view: 'Podgląd',
    delete: 'Usuń',
    file: 'Plik',
    type: 'Typ',
    from: 'Od',
    to: 'Do',
    fullName: 'Imię i nazwisko',
    lastTimeUsed: 'Ostatnio używane',
    noMediaFiles: 'Brak plików multimedialnych...',
    withdraw: 'Wypłać',
    congrats: 'Gratulacje!',
    makeMoneyOnline: 'Zarabiaj online!',
  },
  sort: {
    title: 'Sortuj',
    search: 'Szukaj',
    default: 'Sortowanie domyślne',
    dateNew: 'Data: od najnowszych',
    dateOld: 'Data: od najstarszych',
    priceLow: 'Cena: od najniższej',
    priceHigh: 'Cena: od najwyższej',
    nameA: 'Nazwa: A do Z',
    nameZ: 'Nazwa: Z do A',
    popular: 'Najpopularniejsze',
  },
  emailMenu: {
    broadcasts: 'Wysyłki',
    automations: 'Automatyzacje',
    templates: 'Szablony',
    settings: 'Ustawienia',
    noEmails: 'Brak e-maili',
    newBroadcast: 'Nowe wysyłki',
  },
  aiContent: {
    title: 'Utwórz swoją pierwszą treść AI!',
    text: 'Planuj i publikuj treści na wszystkich mediach społecznościowych naraz!',
    create: 'Utwórz treść AI',
  },
  pageDesign: {
    page: 'Design strony',
    image: 'Obraz',
  },
  toolsMenu: {
    title: 'Narzędzia',
    account: 'Konto',
    instantPages: 'Strony błyskawiczne',
    instantPagesText: 'Szybko ładujące się samodzielne strony',
    agents: 'Agenci',
    agentsText: 'Asystenci AI zarządzający Twoim profilem',
    socialPlanner: 'Planer social media',
    socialPlannerText: 'Planowanie treści i inspiracje',
    emailMarketing: 'E-mail marketing',
    emailMarketingText: 'Rozwijaj listę kontaktów',
    smartReply: 'Odpowiedzi na Instagramie',
    smartReplyText: 'Wysyłaj automatyczne komentarze i wiadomości',
    linkShortener: 'Krótkie linki',
    linkShortenerText: 'Skracaj długie adresy URL',
    posts: 'Posty',
    postsText: 'Twórz i zarządzaj postami',
    blog: 'Blog',
    blogText: 'Twórz i zarządzaj artykułami na blogu',
  },
  insideMenu: {
    planner: 'Planer',
    aiContent: 'Treść AI',
    aiPosts: 'Posty AI',
    postIdeas: 'Pomysły na posty',
    contentPlanner: 'Planer treści',
    aiImages: 'Obrazy AI',
    adBuilder: 'Kreator reklam',
    brandProjects: 'Brand DNA',
    aiVideo: 'Wideo AI',
    integrations: 'Integracje',
    products: 'Produkty',
    orders: 'Zamówienia',
    payments: 'Płatności',
    links: 'Linki',
    qrCodes: 'Kody QR',
  },
  orders: {
    title: 'Zamówienia',
    empty: 'Nie masz jeszcze żadnych zamówień',
    all: 'Wszystkie zamówienia',
    shop: 'Sklep',
    digital: 'Produkty cyfrowe',
    appointments: 'Wizyty',
    services: 'Usługi',
    donations: 'Darowizny',
  },
  discounts: {
    title: 'Rabaty',
    newDiscount: '+ Nowy rabat',
    code: 'Kod',
    titleCol: 'Nazwa',
    type: 'Typ',
    value: 'Wartość',
    status: 'Status',
    used: 'Wykorzystano',
    actions: 'Akcje',
    statusAll: 'Wszystkie statusy',
    statusActive: 'Aktywny',
    statusExpired: 'Wygasł',
    statusScheduled: 'Zaplanowany',
    statusInactive: 'Nieaktywny',
    searchPlaceholder: 'Szukaj po kodzie lub nazwie...',
    clearFilters: 'Wyczyść filtry',
    emptyTitle: 'Brak rabatów',
    emptySubtitle: 'Utwórz pierwszy kod promocyjny, aby oferować rabaty na swoje produkty',
    createDiscount: 'Utwórz rabat',
    createTitle: 'Utwórz rabat',
    editTitle: 'Edytuj rabat',
    fieldTitle: 'Nazwa',
    fieldTitlePlaceholder: 'np. Wiosenna wyprzedaż',
    fieldCode: 'Kod',
    fieldCodePlaceholder: 'np. RABAT20',
    generate: 'Generuj',
    sectionDiscount: 'Rabat',
    fieldTrigger: 'Sposób naliczania',
    triggerCode: 'Kod rabatowy',
    triggerAutomatic: 'Automatyczny (bez kodu)',
    triggerAutomaticHint: 'Naliczany automatycznie przy kasie po spełnieniu warunków — bez kodu. Ustaw poniżej minimalną kwotę zamówienia dla rabatu od wartości.',
    automaticBadge: 'Automatyczny',
    fieldType: 'Typ',
    typePercentage: 'Procentowy',
    typeFixed: 'Kwota stała',
    typeFreeShipping: 'Darmowa dostawa',
    fieldValue: 'Wartość',
    sectionConditions: 'Warunki (opcjonalnie)',
    appliesTo: 'Dotyczy',
    appliesToAll: 'Wszystkie produkty',
    appliesToShop: 'Sklep',
    appliesToDigital: 'Cyfrowe',
    appliesToCourses: 'Kursy',
    appliesToServices: 'Usługi',
    appliesToEvents: 'Wydarzenia',
    minOrderAmount: 'Min. kwota zamówienia ($)',
    maxDiscountAmount: 'Maks. kwota rabatu ($) — 0 = bez limitu',
    minItemCount: 'Min. liczba produktów w zamówieniu — 0 = brak wymogu',
    specificProducts: 'Konkretne produkty — puste = wszystkie kwalifikujące się',
    specificProductsPlaceholder: 'Szukaj produktów...',
    noProductsFound: 'Nie znaleziono produktów',
    sectionLimits: 'Limity',
    usageLimit: 'Łączny limit użycia — 0 = bez limitu',
    usageLimitPerUser: 'Limit na klienta — 0 = bez limitu',
    sectionSchedule: 'Harmonogram',
    startDate: 'Data rozpoczęcia — puste = zaczyna się teraz',
    endDate: 'Data zakończenia — puste = bez terminu ważności',
    active: 'Aktywny',
    cancel: 'Anuluj',
    save: 'Zapisz rabat',
    createdSuccess: 'Rabat utworzony',
    updatedSuccess: 'Rabat zaktualizowany',
    deletedSuccess: 'Rabat usunięty',
    loadError: 'Nie udało się załadować rabatów',
    saveError: 'Nie udało się zapisać rabatu',
    deleteError: 'Nie udało się usunąć rabatu',
  },
  donation: {
    chooseSmiles: 'Wybierz uśmiechy',
    item: 'Element',
    itemTitle: 'Tytuł elementu darowizny',
    price: 'Cena',
    thanksMessagePlaceholder: 'Dziękuję bardzo',
    thanksMessage: 'Wiadomość z podziękowaniem',
    thanksMessageCaption: 'Wiadomość z podziękowaniem pojawi się Twoim fanom po darowiźnie',
    addDonation: 'Dodaj darowiznę',
    addAmount: '+ Dodaj kwotę',
    buttonTitle: 'Tytuł przycisku',
    buttonTitleCaption: 'Tytuł przycisku darowizny',
    acceptDonations: 'Przyjmuj darowizny',
    donationsType: 'Darowizny',
    tips: 'Napiwki',
    type: 'Typ',
    addAnotherAmount: '+ Dodaj kolejną kwotę',
  },
  blog: {
    empty: 'Nie masz jeszcze bloga',
  },
  apps: {
    empty: 'Nie masz jeszcze aplikacji',
  },
  payments: {
    title: 'Płatności',
    text: 'Nie masz jeszcze żadnych transakcji',
    single: 'Płatności jednorazowe',
    subscriptions: 'Subskrypcje',
    wallet: 'Portfel',
    connectPromo: 'Połącz konto Stripe lub PayPal ze swoją stroną UniLink i otrzymuj wszystkie płatności na swój portfel.',
    connectSystem: 'Połącz system płatności',
    manageCards: 'Zarządzaj kartami',
    addNewCard: 'Dodaj nową kartę',
    editCard: 'Edytuj dane karty',
    addCard: 'Dodaj dane karty',
    cardHolder: 'Imię i nazwisko posiadacza karty',
    cardHolderNecessary: 'To pole jest wymagane',
    withdrawalSuccess: 'Twoja wypłata została pomyślnie zgłoszona!',
    withdrawalError: 'Coś poszło nie tak, spróbuj ponownie później.',
    change: 'Zmień',
  },
  store: {
    emptyTitle: 'Nie masz jeszcze żadnych produktów',
    emptyText: 'Zacznij od dodania pierwszego produktu',
    emptyButton: 'Dodaj produkt',
    createFirstProduct: 'Utwórz swój pierwszy produkt',
    startAdding: 'Zacznij od dodania ulubionych produktów, towarów cyfrowych lub usług. Miejsce, w którym możesz sprzedawać i promować wszystko, co oferujesz.',
    activate: 'Aktywuj sklep',
    empty: 'Nie masz jeszcze produktów',
    products: 'Produkty',
    addProducts: 'Dodaj produkty',
    whatDoYouWant: 'Co chcesz sprzedawać?',
    externalProduct: 'Zewnętrzny URL produktu',
    createOwnProduct: 'Utwórz własny produkt',
    shop: 'Sklep',
    shopText: 'Sprzedawaj produkty fizyczne i cyfrowe',
    digital: 'Produkty cyfrowe',
    digitalText: 'Sprzedaj plik do pobrania',
    course: 'Kurs lub poradnik',
    courseText: 'Dodaj kurs lub poradnik do strony',
    service: 'Usługi',
    serviceText: 'Dodaj usługi od swoich klientów',
    appointment: 'Wizyty',
    appointmentText: 'Pozwól odwiedzającym rezerwować termin w Twoim kalendarzu',
    event: 'Wydarzenia lub bilety',
    eventText: 'Utwórz wydarzenie i zaproś odbiorców',
    tips: 'Napiwki',
    tipsText: 'Zostaw napiwek dla ulubionych twórców',
    donation: 'Darowizny',
    donationText: 'Przekaż darowiznę',
    membership: 'Członkostwo',
    membershipText: 'Dodaj członkostwo do strony',
    links: 'Link zewnętrzny',
    linksText: 'Dodaj link zewnętrzny do dowolnej strony',
    coupon: 'Kupon',
    couponText: 'Dodaj kupon dla swojej strony',
    singleProduct: 'Pojedynczy produkt',
    singleProductText: 'Sprzedaj pojedynczy produkt z prostym checkoutem',
    booking: 'Rezerwacja',
    bookingText: 'Pozwól odwiedzającym rezerwować przestrzenie lub nieruchomości',
    rental: 'Wynajem',
    rentalText: 'Wypisz przedmioty do wynajęcia z dostępnością i cenami',
    add: 'Dodaj',
    manageStore: 'Zarządzaj sklepem',
    displayLast: 'Pokaż ostatni produkt',
  },
  products: {
    info: 'Informacje',
    uploadCover: 'Prześlij zdjęcie okładki, a następnie podaj tytuł i opis',
    thumbnail: 'Miniatura',
    thumbnailError: 'Dodaj miniaturę',
    title: 'Tytuł',
    titleTooltip: 'Wpisz nazwę produktu',
    shortDescription: 'Krótki opis',
    shortDescriptionTooltip: 'Wpisz krótki opis produktu',
    description: 'Opis',
    descriptionTooltip: 'Wpisz opis produktu',
    descriptionTooltipExtra: 'Opcjonalny opis cech produktu, typów, kolorów, rozmiarów itp.',
    price: 'Cena',
    priceTooltip: 'Wpisz cenę produktu',
    oldPrice: 'Stara cena',
    oldPriceTooltip: 'Stara cena będzie przekreślona',
    category: 'Kategoria',
    categoryTooltip: 'Wybierz kategorię produktu',
    image: 'Obraz',
    imageTooltip: 'Prześlij obraz produktu',
    groups: 'Grupy',
    rate: 'Ocena',
    rateTooltip: 'Wpisz ocenę produktu',
    buttonTitle: 'Tytuł przycisku',
    buttonTitleTooltip: 'Wpisz tytuł przycisku produktu',
    features: 'Cechy',
    featuresTooltip: 'Lista zalet wyświetlana w widoku karty Showcase',
    featurePlaceholder: 'Zaleta',
    addFeature: 'Dodaj cechę',
    limitQuantity: 'Ogranicz ilość',
    itemsLeft: 'Pozostało sztuk',
    itemsLeftTooltip: 'Sztuki Twojego produktu',
    trackStock: 'Śledź ilość',
    stockQuantity: 'Stan magazynowy',
    stockQuantityTooltip: 'Aktualna liczba sztuk w magazynie. Zmniejsza się automatycznie po każdym opłaconym zamówieniu; przy 0 produktu nie można już kupić.',
    lowStockThreshold: 'Alert niskiego stanu',
    lowStockThresholdTooltip: 'Otrzymuj powiadomienie, gdy stan spadnie do tej liczby lub poniżej.',
    maxOrderQuantity: 'Maksymalna ilość w zamówieniu',
    maxOrderQuantityTooltip: 'Maksymalna liczba sztuk, którą klient może kupić w jednym zamówieniu. Zostaw puste, aby nie ustawiać limitu.',
    minOrderQuantity: 'Minimalna ilość w zamówieniu',
    minOrderQuantityTooltip: 'Minimalna liczba sztuk, którą klient musi kupić w jednym zamówieniu. Zostaw puste, aby nie ustawiać limitu.',
    pendingReviews: {
      title: 'Opinie do zatwierdzenia',
      subtitle: 'Zatwierdź lub ukryj opinie kupujących, zanim pojawią się publicznie',
      empty: 'Brak opinii oczekujących na moderację.',
      approve: 'Zatwierdź',
      hide: 'Ukryj',
    },
    attachments: 'Załączniki',
    addAttachments: 'Dodaj załączniki do swoich produktów',
    addNewAttachment: 'Dodaj nowy element',
    file: 'Plik',
    uploadFile: 'Prześlij plik',
    uploadCoverTitle: 'Prześlij okładkę',
    optionalDescription: 'Opcjonalny opis cech produktu, typów, kolorów, rozmiarów itp.',
    customReviews: 'Własne opinie',
    addCustomReviews: 'Dodaj opinie do swoich produktów',
    name: 'Imię',
    nameTooltip: 'Wpisz imię klienta',
    comment: 'Komentarz',
    commentTooltip: 'Wpisz komentarz klienta',
    rateTooltipCustomer: 'Ocena klienta',
    imageTooltipCustomer: 'Prześlij zdjęcie klienta',
    displayPriceOnPreview: 'Pokaż cenę w podglądzie',
    displayDetailsOnPreview: 'Pokaż szczegóły w podglądzie',
    postOnSocials: 'Publikuj w social media',
    sendAnEmail: 'Wyślij e-mail',
    highlights: 'Wyróżnienia',
    listProductSetup: 'Wypisz produkt i skonfiguruj blok sklepu',
    whereToSell: 'Gdzie chcesz sprzedawać ten produkt?',
    youHaveProducts: 'Masz {count} produktów',
    shareThisProduct: 'Udostępnij ten produkt',
    shareAProduct: 'Udostępnij produkt',
    monetizeWays: 'Różne sposoby zarabiania na Unilink',
    addProductToProfile: 'Dodaj {title} do swojego profilu',
    productPage: 'Strona produktu',
    setUpPayments: 'Skonfiguruj płatności',
    connectPaymentMethods: 'Połącz metody płatności, aby zacząć zarabiać na Unilink',
    addPaymentMethod: 'Dodaj metodę płatności {type}, aby otrzymywać wpłaty od obserwujących',
    withdrawAttempt: 'To jest próba odzyskania należności i wszelkie informacje zostaną wykorzystane w tym celu.',
    withdrawSuccess: 'Twoja wypłata została pomyślnie zgłoszona!',
    yourVisitorsPay: 'Twoi odwiedzający najpierw zapłacą, a następnie zostaną przekierowani do {method}',
    emailAddress: 'adres e-mail',
    calendlyLink: 'Link Calendly',
  },
  posts: {
    posts: 'Posty',
    title: 'Utwórz swój pierwszy post',
    description: 'Posty to miejsce, w którym tworzysz automatyzacje czatu w łatwym i wizualnym formacie. Wypróbuj automatyzacje, które polecamy na podstawie Twoich celów',
    activate: 'Aktywuj posty',
    managePosts: 'Zarządzaj postami',
    postsTab: 'Zakładka postów',
    displayLast: 'Pokaż ostatnie posty',
    tabNavigation: 'Ustawienia nawigacji zakładek',
    createFirstPost: 'Utwórz swój pierwszy post!',
    autoPostsText: 'Planuj i publikuj treści na wszystkich mediach społecznościowych naraz!',
    createPost: 'Utwórz post',
  },
  messages: {
    title: 'Wiadomości',
    empty: 'Brak wiadomości',
    addText: 'Dodaj przycisk wiadomości do bloku nagłówka, aby użytkownicy mogli łatwo wysłać Ci wiadomość.',
    addButton: 'Dodaj przycisk wiadomości',
  },
  smartReply: {
    title: 'Odpowiedzi na Instagramie',
    clicks: 'kliknięcia',
    createTitle: 'Utwórz swoją pierwszą odpowiedź na Instagramie!',
    text: 'Używaj automatycznych DM na Instagramie, aby automatycznie udostępniać linki swoim odbiorcom!',
    createButton: 'Utwórz automatyczne DM',
    subtitleComment: 'Automatyczne DM z linkiem w odpowiedzi na komentarz',
    subtitleDm: 'Automatyczne DM w odpowiedzi na wiadomość lub Story',
    ready: 'gotowe',
    edit: 'Edytuj',
    stepContentTitle: 'Treść IG',
    stepContentSub: 'Wybierz post lub Reel',
    storiesAndDmsSub: 'Automatyczne DM, gdy ktoś odpowie na Story lub napisze do Twojej skrzynki',
    stepTriggerTitle: 'Wyzwalacz',
    stepTriggerSub: 'Słowa kluczowe w komentarzach',
    stepTriggerSubDm: 'Słowa kluczowe w wiadomościach',
    stepDmTitle: 'DM',
    stepDmSub: 'Wiadomość wysyłana automatycznie',
    dmSummary: 'Wiadomość ustawiona',
    activatesNow: 'Automatyczna odpowiedź aktywuje się od razu',
    saveAutomation: 'Zapisz automatyczną odpowiedź',
    savedToast: 'Automatyczna odpowiedź utworzona',
    linkLabel: 'Wybierz cel linku',
    selectDestination: 'Wybierz link, produkt lub artykuł',
    change: 'Zmień',
    choose: 'Wybierz',
    remove: 'Usuń',
    optional: 'opcjonalnie',
    buttonText: 'Tekst przycisku',
    addLink: 'Dodaj link',
    attachLink: 'Dołącz link',
    noLinks: 'Brak linków — najpierw dodaj link w Link in Bio.',
    tabLinks: 'Linki',
    tabProducts: 'Produkty',
    noProducts: 'Brak produktów — najpierw utwórz produkt w sklepie.',
    tabArticles: 'Artykuły',
    noArticles: 'Brak artykułów — najpierw utwórz artykuł.',
    choosePost: 'Wybierz post lub Reel',
    searchPosts: 'Szukaj wśród swoich postów',
    loadingPosts: 'Ładowanie postów…',
    done: 'Gotowe',
    oneSelected: 'Wybrano 1 post',
    postSelected: 'Post wybrany',
    noPosts: 'Brak postów — opublikuj post lub Reel na Instagramie.',
    postsError: 'Nie udało się załadować postów. Spróbuj ponownie.',
    reauthTitle: 'Niektóre DM mogą nie zostać dostarczone.',
    reauthText: 'Instagram wymaga ponownej autoryzacji konta.',
    reconnect: 'Połącz ponownie',
    statActive: 'Aktywne automatyzacje',
    statDmSent: 'Wysłane DM · 30 dni',
    statClicks: 'Kliknięcia linków',
    activeReplies: 'Aktywne automatyczne odpowiedzi',
    filterAll: 'Wszystkie',
    filterActive: 'Aktywne',
    filterOff: 'Wyłączone',
  },
  virtualBackgrounds: {
    title: 'Wirtualne tła',
    canvasSize: 'Rozmiar płótna',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: 'Kwadrat',
    fmtClassic: 'Klasyczny',
    background: 'Tło',
    bg_color: 'Kolor',
    bg_gradient: 'Gradient',
    bg_photo: 'Zdjęcie',
    bg_pattern: 'Wzór',
    from: 'Od',
    to: 'Do',
    angle: 'Kąt',
    ink: 'Atrament',
    paper: 'Papier',
    blur: 'Rozmycie',
    darken: 'Przyciemnienie',
    presets: 'Gotowe zestawy',
    uploadImage: 'Prześlij obraz',
    removeImage: 'Usuń obraz',
    replace: 'Zastąp',
    remove: 'Usuń',
    photoPlaceholder: 'Prześlij obraz z panelu',
    overlay: 'Nakładka',
    showName: 'Pokaż imię',
    namePlaceholder: 'Twoje imię',
    subtitlePlaceholder: 'Podtytuł / login',
    typeface: 'Krój pisma',
    textColour: 'Kolor tekstu',
    nameSizeLabel: 'Rozmiar imienia',
    position: 'Pozycja',
    showQr: 'Pokaż kod QR',
    qrPlaceholder: 'https://link',
    style: 'Styl',
    qrCard: 'Karta',
    qrBrand: 'Marka',
    qrLight: 'Jasny',
    qrSolid: 'Pełny',
    qrSizeLabel: 'Rozmiar kodu QR',
    logo: 'Logo / awatar',
    uploadLogo: 'Prześlij logo (PNG)',
    logoSizeLabel: 'Rozmiar logo',
    finishing: 'Wykończenie',
    vignette: 'Winieta',
    vignetteHint: 'Miękkie ciemne krawędzie dla głębi',
    shuffle: 'Losuj',
    reset: 'Resetuj',
    dragHint: 'Przeciągnij imię, kod QR lub logo na płótnie, aby zmienić pozycję',
    preparing: 'Przygotowywanie…',
    download: 'Pobierz',
    sizeHint: 'Zapisano jako JPG 1920 × 1080',
  },
  emailSignatures: {
    title: 'Podpisy e-mail',
    details: 'Szczegóły',
    name: 'Imię',
    jobTitle: 'Stanowisko',
    company: 'Firma',
    email: 'E-mail',
    phone: 'Telefon',
    website: 'Strona',
    style: 'Styl',
    styleModern: 'Nowoczesny',
    styleClassic: 'Klasyczny',
    styleMinimal: 'Minimalistyczny',
    styleBold: 'Wyrazisty',
    styleCard: 'Karta',
    accent: 'Kolor akcentu',
    showAvatar: 'Pokaż zdjęcie',
    showQr: 'Pokaż kod QR',
    preview: 'Podgląd',
    copySignature: 'Kopiuj podpis',
    copyHtml: 'Kopiuj HTML',
    copied: 'Podpis skopiowany',
    copiedHtml: 'HTML skopiowany',
    instructions: {
      gmail: 'Gmail: Ustawienia → Zobacz wszystkie ustawienia → Ogólne → Podpis → Utwórz nowy, następnie wklej (Ctrl/Cmd+V) i zapisz zmiany.',
      outlook: 'Outlook: Plik → Opcje → Poczta → Podpisy → Nowy, następnie wklej. Nowy Outlook / web: Ustawienia → Poczta → Tworzenie i odpowiadanie → wklej w polu podpisu.',
      apple: 'Apple Mail: Poczta → Ustawienia → Podpisy → dodaj podpis, następnie wklej go. Odznacz „Zawsze dopasuj do domyślnej czcionki wiadomości”.',
    },
  },
  businessCards: {
    title: 'Wizytówki',
    emptyTitle: 'Utwórz swoją cyfrową wizytówkę',
    emptySubtitle: 'Dodaj swoje dane kontaktowe, aby każdy mógł zapisać je w telefonie jednym dotknięciem — a następnie udostępnij kodem QR lub plikiem .vcf.',
    createButton: 'Utwórz wizytówkę',
    sectionButton: 'Przycisk zapisu kontaktu',
    sectionButtonSubtitle: 'Jak wygląda przycisk „Zapisz kontakt” i gdzie pojawia się na Twoim profilu.',
    showButton: 'Pokaż na moim profilu',
    showButtonSubtitle: 'Wyświetl przycisk „Zapisz kontakt” na swojej publicznej stronie.',
    placement: 'Umiejscowienie przycisku',
    placementSubtitle: 'Wybierz, gdzie pojawia się przycisk.',
    showInHeader: 'Pokaż w nagłówku',
    placementHeader: 'Nagłówek profilu',
    placementHeaderHint: 'Wyświetla się tuż pod imieniem i awatarem.',
    placementContact: 'Sekcja kontaktów',
    placementContactHint: 'Pojawia się w wyskakującym oknie kontaktów.',
    placementBottom: 'Pływający przycisk',
    placementBottomHint: 'Przykleja się do dołu strony podczas przewijania.',
    none: 'Brak',
    buttonLabel: 'Etykieta przycisku',
    buttonLabelSubtitle: 'Tekst wyświetlany na przycisku.',
    saveContact: 'Zapisz kontakt',
    sectionDetails: 'Dane kontaktowe',
    sectionDetailsSubtitle: 'Te dane są zapisywane w karcie kontaktu.',
    leadCapture: 'Zbieraj kontakty',
    leadCaptureSubtitle: 'Pozwól osobom otrzymującym Twoją wizytówkę udostępnić swoje dane — trafiają one prosto do Twoich odbiorców.',
    leadCaptureToggle: 'Włącz „Udostępnij swoje dane”',
    leadCaptureToggleHint: 'Wyświetla formularz kontaktowy na Twojej publicznej wizytówce.',
    leadTag: 'Otaguj nowe kontakty',
    leadTagSubtitle: 'Każdy pozyskany kontakt jest oznaczany tym tagiem (np. nazwa wydarzenia lub kampanii).',
    leadTagPlaceholder: 'np. Konferencja 2026',
    delete: 'Usuń wizytówkę',
    previewHint: 'Tak Twoja wizytówka wygląda dla odwiedzających.',
    share: 'Udostępnij i kod QR',
    shareSubtitle: 'Zeskanuj kod lub udostępnij link, aby otworzyć profil.',
    download: 'Pobierz .vcf',
    copyLink: 'Kopiuj link',
    copied: 'Link skopiowany!',
    renewLink: 'Odnów link',
    renewing: 'Odnawianie…',
    renewConfirm: 'Odnowić link wizytówki? Twój obecny kod QR i udostępnione linki przestaną działać.',
    linkRenewed: 'Link wizytówki odnowiony',
    scans: '{count} skanów',
    digitalCard: 'Karta cyfrowa',
    physicalCard: 'Karta fizyczna',
    cardStyle: 'Styl karty',
    cardStyleSubtitle: 'Ustaw wyświetlaną nazwę, wybierz kolor tła i dodaj kartę do portfela.',
    displayName: 'Wyświetlana nazwa',
    backgroundColour: 'Kolor tła',
    addAppleWallet: 'Dodaj do Apple Wallet',
    addGoogleWallet: 'Dodaj do Google Wallet',
    nameLabel: 'Imię',
    urlLabel: 'URL',
    walletScanTitle: 'Zeskanuj kod QR, aby zapisać w portfelu',
    walletScanSubtitle: 'Zostanie zapisane w cyfrowym portfelu Twojego telefonu.',
    walletUseLink: 'Lub użyj tego linku',
    walletComingSoonTitle: 'Już prawie',
    walletComingSoon: 'Karty do portfela wkrótce się pojawią.',
    done: 'Gotowe',
    physicalTitle: 'Zamów kartę fizyczną',
    physicalSubtitle: 'Wizytówki NFC wkrótce się pojawią.',
  },
  shortLinks: {
    title: 'Krótkie linki',
    addLink: 'Dodaj link',
    name: 'Nazwa',
    slug: 'Slug',
    slugTooltip: 'Możesz zmienić slug, klikając przycisk edycji',
    destinationUrl: 'Docelowy URL',
    metadata: 'Metadane',
    utmTags: 'Tagi UTM',
    customizeMetadata: 'Dostosuj metadane linku',
    metaTitle: 'Tytuł',
    metaDescription: 'Opis',
    favicon: 'Favicon',
    imagePreview: 'Podgląd obrazu',
    addUtm: 'Dodaj tagi UTM do linku (opcjonalnie)',
    utmCampaign: 'Kampania UTM',
    utmMedium: 'Medium UTM',
    utmSource: 'Źródło UTM',
    utmTerm: 'Termin UTM',
    utmContent: 'Treść UTM',
    utmId: 'ID UTM',
    utmPlacement: 'Umiejscowienie UTM',
    utmCreative: 'Kreacja UTM',
    pasteLink: 'Wklej tu długi link',
    shorten: 'Skróć link',
    edit: 'Edytuj szczegóły elementu',
  },
  audience: {
    title: 'Odbiorcy',
    total: 'Łącznie',
    totalMembers: 'Łączna liczba odbiorców',
    totalContacts: 'Łączna liczba kontaktów',
    forms: 'Formularze',
    subscribers: 'Subskrybenci',
    customers: 'Klienci',
    noAudienceMembers: 'Brak kontaktów',
    emptyAudienceMembers: 'Dodaj nowe kontakty, klikając przycisk',
    addAudienceMember: 'Dodaj kontakt',
    noSubscribers: 'Brak subskrybentów',
    emptySubscribers: 'Dodaj nowych subskrybentów, dodając bloki do Link in Bio',
    addDataCollect: 'Dodaj blok zbierania danych',
    noResponses: 'Brak odpowiedzi',
    emptyResponses: 'Dodaj nowe odpowiedzi, dodając bloki do Link in Bio',
    addFormBlock: 'Dodaj blok formularza',
    noCustomers: 'Brak klientów',
    emptyCustomers: 'Dodaj nowych klientów, dodając produkt do Link in Bio',
    addProduct: 'Dodaj produkt',
    addContactModal: {
      title: 'Dodaj nowy kontakt',
      name: 'Imię',
      nameTooltip: 'Wpisz imię kontaktu',
      email: 'E-mail',
      emailTooltip: 'Wpisz adres e-mail kontaktu',
      phone: 'Telefon',
      phoneTooltip: 'Wpisz numer telefonu kontaktu',
      telegram: 'Telegram',
      telegramTooltip: 'Wpisz nazwę użytkownika lub URL Telegrama kontaktu',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Wpisz numer WhatsApp kontaktu',
      instagram: 'Instagram',
      instagramTooltip: 'Wpisz nazwę użytkownika lub URL Instagrama kontaktu',
      messenger: 'Messenger',
      messengerTooltip: 'Wpisz nazwę użytkownika lub URL Messengera kontaktu',
      viber: 'Viber',
      viberTooltip: 'Wpisz numer Viber kontaktu',
      address: 'Adres',
      addressTooltip: 'Wpisz adres kontaktu',
      add: 'Dodaj',
    },
    search: {
      search: 'Szukaj',
      error: 'Wpisano nieprawidłowy znak w polu wyszukiwania',
      notFound: 'Nie znaleziono wyników',
    },
  },
  auth: {
    logIn: 'Zaloguj się',
    logInWith: 'Zaloguj się przez',
    signIn: 'Zaloguj się',
    signInWith: 'Zarejestruj się przez',
    email: 'E-mail',
    password: 'Hasło',
    notHaveAccount: 'Nie masz konta?',
    createAccount: 'Utwórz nowe konto',
    createYourAccount: 'Utwórz swoje konto',
    signUp: 'Zarejestruj się',
    haveAccount: 'Jeśli masz już konto',
    or: 'lub',
    reset: 'Resetuj',
    resetPassword: 'Resetuj hasło',
    resetTitle: 'Link do odzyskiwania hasła został wysłany na Twój e-mail',
    goToHome: 'Przejdź do strony głównej',
    byClicking: 'Klikając',
    youAreAgree: 'zgadzasz się z',
    terms: 'Warunkami korzystania z usługi UniLink',
    andConfirm: 'oraz naszą',
    usagePolicy: 'Polityką użytkowania',
    signInGoogle: 'Zaloguj się przez Google',
    forgotPassword: 'Zapomniałeś hasła?',
  },
  menu: {
    moreApps: 'Więcej aplikacji',
    account: 'Konto',
    more: 'Więcej',
    storyWidget: 'Osadź Stories',
    integrations: 'Integracje',
    socialAccounts: 'Konta społecznościowe',
    aiContent: 'Treść AI',
    aiPosts: 'Posty AI',
    postIdeas: 'Pomysły na posty',
    contentPlanner: 'Planer treści',
    aiImages: 'Obrazy AI',
    adBuilder: 'Kreator reklam',
    aiVideo: 'Wideo AI',
    planner: 'Planer',
    customers: 'Klienci',
    subscribers: 'Subskrybenci',
    forms: 'Formularze',
    allAudience: 'Wszyscy odbiorcy',
    payments: 'Płatności',
    orders: 'Zamówienia',
    products: 'Produkty',
    events: 'Wydarzenia',
    appointments: 'Wizyty',
    discounts: 'Rabaty',
    affiliates: 'Partnerzy',
    instantPages: 'Strony błyskawiczne',
    openInNewTab: 'Otwórz w nowej karcie',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'Strona',
    store: 'Sklep',
    audience: 'Odbiorcy',
    emailMarketing: 'E-mail marketing',
    postPlaner: 'Planer postów',
    posts: 'Posty',
    agents: 'Agenci',
    community: 'Społeczność',
    profileHealth: 'Kondycja profilu',
    socialPlanner: 'Planer social media',
    shortLinks: 'Krótkie linki',
    businessCards: 'Wizytówki',
    emailSignatures: 'Podpisy e-mail',
    virtualBackgrounds: 'Wirtualne tła',
    adsCampaigns: 'Menedżer reklam',
    views: 'Wyświetlenia',
    clicks: 'Kliknięcia',
    allWebsites: 'Wszystkie strony',
    createNewAccount: 'Utwórz nowe konto',
    createNewWebsite: 'Utwórz nowy profil',
    tools: 'Narzędzia',
    borderGenerator: 'Generator obramowań',
    yourPlan: 'Twój plan:',
    upgrade: 'Ulepsz',
    accountSettings: 'Ustawienia konta',
    manageWebsites: 'Zarządzaj profilami',
    updates: 'Aktualizacje',
    autoUpdate: 'Aktualizuj automatycznie',
    logOut: 'Wyloguj się',
    myPages: 'Moje strony',
    design: 'Design',
    heading: 'Nagłówek',
    analytics: 'Analityka',
    settings: 'Ustawienia',
    open: 'Otwórz',
    language: 'Język',
    siteLanguage: 'Język publicznej strony',
    dashboardLanguage: 'Język panelu',
    movePage: 'Przenieś podstronę',
    editBlock: 'Edytuj blok',
    renameBlock: 'Zmień nazwę bloku',
    rename: 'Zmień nazwę',
    deleteBlock: 'Usuń blok',
    archiveBlock: 'Zarchiwizuj blok',
    archive: 'Archiwizuj',
    scheduleBlock: 'Zaplanuj blok',
    copyBlock: 'Kopiuj blok',
    dublicateBlock: 'Duplikuj blok',
    content: 'Treść',
    preview: 'Podgląd',
    thumbnail: 'Miniatura',
    copy: 'Kopiuj',
    moveBlock: 'Przenieś blok',
    move: 'Przenieś',
    edit: 'Edytuj',
    delete: 'Usuń',
    schedule: 'Zaplanuj',
    dublicate: 'Duplikuj',
    smartReply: 'Odpowiedzi na Instagramie',
    marketing: 'Marketing',
    selectBlocks: 'Wybierz bloki',
    selectAll: 'Zaznacz wszystkie',
    cancelSelection: 'Anuluj',
    blocksSelected: 'wybrano',
    moveToPage: 'Przenieś na podstronę',
    newPage: 'Nowa podstrona',
    openPage: 'Otwórz podstronę',
    pageSettings: 'Ustawienia podstrony',
    deletePage: 'Usuń podstronę',
    appInBio: 'App in Bio',
    blog: 'Blog',
    buildFromReference: 'Zbuduj na podstawie wzoru',
    publish: 'Publikuj',
    creatorHub: 'Creator Hub',
    qrCodes: 'Kody QR',
    apps: 'Aplikacje',
    automations: 'Automatyzacje',
    messages: 'Skrzynka',
    form: 'Osadzone formularze',
    embedTools: 'Narzędzia osadzania',
  },
  modal: {
    addInstagram: 'Dodaj Instagram',
    addYourInstagram: 'Dodaj swoje konto Instagram',
    cropYourAvatar: 'Przytnij swój awatar',
    removeSite: 'Czy na pewno chcesz usunąć stronę?',
    areYouSure: 'Czy na pewno chcesz',
    areYouSureDelete: 'Czy na pewno chcesz usunąć tę sekcję?',
    areYouSureArchive: 'Czy na pewno chcesz zarchiwizować ten blok?',
    areYouSurePermanentDelete: 'Czy na pewno chcesz trwale usunąć ten blok? Tej czynności nie można cofnąć.',
    remove: 'usunąć',
    site: 'stronę',
    removeAccountText: 'usunąć swoje konto',
    moveBlock: 'Przenieś blok na inną podstronę',
    moveBlockText: 'To przeniesie blok na dół innej podstrony. Następnie możesz zmienić jego pozycję na nowej podstronie',
    profileTitle: 'Zmień zdjęcie profilowe',
    profileText: 'Wybierz obraz lub GIF ze swojego urządzenia.',
    profileAvatar: 'Awatar profilu',
    addProfilePicture: 'Dodaj zdjęcie profilowe',
    storiesTitle: 'Stories',
    storiesText: 'Udostępnij codzienne chwile.',
    thoughtsTitle: 'Myśli',
    thoughtsText: 'Udostępnij swoje myśli.',
    accountPageDescription: 'To Twoja strona konta, na której możesz dostosować wygląd strony, dodawać różne bloki funkcji i wiele więcej.',
  },
  modalSubscribe: {
    plan: 'Plan',
    usdMonth: 'USD/miesiąc',
    sites: 'Strony',
    sitesMuch: 'Strony',
    notification: 'Powiadomienia',
    noNotification: 'Brak powiadomień',
    inCategory: 'Brak elementów w kategorii',
    categoryYet: 'jeszcze.',
    externalPixels: 'Zewnętrzne piksele',
    parameters: 'parametry',
    analyticsReports: 'Analityka i raporty',
    noUniLinkLogo: 'Bez logo UniLink',
    inProfile: 'w profilu',
    verifiedBadge: 'Odznaka weryfikacji',
    your: 'Twoja',
    customDomain: 'własna domena',
    emailMarketing: 'E-mail marketing',
    liveSupport: 'Wsparcie na żywo',
    dataSecured: 'Dane są zabezpieczone zgodnie ze standardem PCI DSS',
    thankYou: 'Dziękujemy za zainteresowanie. Skontaktujemy się z Tobą wkrótce.',
    socialMediaScheduler: 'Planer social media',
    featureRequest: 'Propozycja funkcji',
    markAllRead: 'Oznacz wszystkie jako przeczytane',
    currentPlan: 'Obecny plan',
    features: 'Funkcje',
  },
  buttons: {
    upgrade: 'Ulepsz plan',
    buyProPlan: 'Kup plan Pro',
    continue: 'Kontynuuj',
    skip: 'Pomiń',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
    back: 'Wstecz',
    save: 'Zapisz',
    add: 'Dodaj',
    added: 'Dodano',
    done: 'Gotowe',
    ok: 'OK',
    edit: 'Edytuj',
    delete: 'Usuń',
    remove: 'Usuń',
    setAsDefault: 'Ustaw jako domyślny',
    subscribeNow: 'Subskrybuj teraz',
    yes: 'Tak',
    preview: 'Podgląd',
    generate: 'Generuj',
    changePassword: 'Zmień hasło',
    deleteAccount: 'Usuń konto',
    removeAccount: 'Usuń konto',
    deleteProfile: 'Usuń profil',
    addBlock: 'Dodaj blok',
    copyLink: 'Kopiuj link',
    active: 'Aktywny',
    update: 'Aktualizuj',
    updatePro: 'Ulepsz plan',
    prev: 'Wstecz',
    next: 'Dalej',
    uploadImage: 'Prześlij obraz',
    uploadVideo: 'Prześlij wideo',
    loadMore: 'Załaduj więcej',
    uploadProductImage: 'Prześlij obraz produktu',
    claim: 'Odbierz',
    removeSite: 'Usuń stronę',
    move: 'Przenieś',
    addButton: 'Dodaj przycisk',
    actionButton: 'Przycisk akcji',
    directMessage: 'Wiadomość bezpośrednia',
    subscribe: 'Subskrybuj',
    button: 'Przycisk',
    generateWithAI: 'Generuj z AI',
    cta: 'CTA',
    cart: 'Koszyk',
    direct: 'Bezpośrednio',
    follow: 'Obserwuj',
    addNewItem: 'Dodaj nowy element',
  },
  support: {
    liveSupport: 'Wsparcie na żywo',
    response: 'Zazwyczaj odpowiadamy w ciągu 1 minuty w godzinach pracy (8:00 - 22:00) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Założyciel i CEO UniLink',
  },
  wizard: {
    createNewProfile: 'Utwórz nowy profil',
    createProfile: 'Utwórz profil',
    continue: 'Kontynuuj',
    tellUs: 'Opowiedz nam o sobie',
    addSocialLinks: 'Dodaj wszystkie sieci społecznościowe, a pokażemy je w Twojej bazie danych',
    addMoreLinks: 'Dodaj więcej linków',
    addLink: 'Dodaj link',
    selectCategory: 'Wybierz jedną kategorię, która najlepiej Cię opisuje:',
    chooseTemplate: 'Wybierz szablon',
    skip: 'Pomiń',
    step: 'Krok',
    of: 'z',
    yourName: 'Twoje imię',
    search: 'Szukaj',
    blog: 'Blog',
    creator: 'Twórca',
    music: 'Muzyka',
    events: 'Wydarzenia',
    esoteric: 'Ezoteryka',
    fashion: 'Moda',
    influencer: 'Influencer',
    food: 'Jedzenie',
    smallBusiness: 'Mała firma',
    marketing: 'Marketing',
    education: 'Edukacja',
    socialMedia: 'Media społecznościowe',
    coaching: 'Coaching',
    ecommerce: 'E-commerce',
    healthAndFitness: 'Zdrowie i fitness',
    beautyWellness: 'Uroda i wellness',
  },
  billing: {
    back: 'Wstecz',
    findPlan: 'Znajdź plan dla siebie',
    changeAnytime: 'Możesz zmienić w każdej chwili.',
    subtitle: 'Ulepsz, obniż lub anuluj w każdej chwili.',
    currentPlan: 'Obecny plan',
    mostPopular: 'Najpopularniejszy',
    upgradeTo: 'Ulepsz do {plan}',
    includes: 'Zawiera:',
    everythingIn: 'Wszystko z {plan}, plus:',
    secure: 'Płatności są zabezpieczone zgodnie ze standardem PCI DSS.',
  },
  field: {
    fullName: 'Imię i nazwisko',
    username: 'nazwa użytkownika',
    addValue: 'Dodaj wartość',
    newValue: 'Nowa wartość',
    placeholderDefault: 'Tekst, liczby, symbole itp.',
    addInstagramUsername: 'Dodaj nazwę użytkownika Instagram',
    nameDefault: 'Jan',
    enterYourLink: 'Wpisz swój link',
    searchImage: 'Szukaj obrazu',
    pasteLink: 'Wklej link',
    pasteLinkTip: 'Dodaj link do dowolnej strony internetowej',
    searchGIFs: 'Szukaj GIF-ów',
    searchIcons: 'Szukaj ikon',
    searchVideo: 'Szukaj wideo',
    search: 'Szukaj',
    insertURL: 'Wstaw URL',
    writeYourDescription: 'Napisz swój opis',
    headerCTAbutton: 'Nagłówek, przycisk CTA',
    enterTitle: 'Wpisz tytuł',
    enterDescription: 'Wpisz opis',
    enterURL: 'Wpisz kanoniczny URL',
  },
  tooltip: {
    addImage: 'Dodaj obraz',
    labelModalTitle: 'Ustawienia etykiety',
    addLabel: '+ Dodaj etykietę',
    label: 'Etykieta',
    labelCaption: 'Wpisz etykietę',
    labelText: 'Tekst etykiety',
    labelTextCaption: 'Wpisz tekst etykiety',
    labelTextPlaceholder: 'Etykieta',
    labelUrl: 'URL etykiety',
    labelUrlCaption: 'Wpisz URL etykiety',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Bez etykiety',
    colorFrom: 'Kolor od',
    colorTo: 'Kolor do',
    highlight: 'Wyróżnienie',
    firstName: 'Imię',
    firstNameCaption: 'Wpisz swoje imię',
    lastName: 'Nazwisko',
    lastNameCaption: 'Wpisz swoje nazwisko',
    jobTitle: 'Stanowisko',
    jobTitleCaption: 'Wpisz swoje stanowisko',
    organization: 'Organizacja',
    organizationCaption: 'Wpisz swoją organizację',
    email: 'E-mail',
    emailCaption: 'Wpisz swój e-mail',
    workPhone: 'Telefon służbowy',
    workPhoneCaption: 'Wpisz swój telefon służbowy',
    mobilePhone: 'Telefon komórkowy',
    mobilePhoneCaption: 'Wpisz swój telefon komórkowy',
    website: 'Strona',
    websiteCaption: 'Wpisz swoją stronę',
    information: 'Informacje',
    informationCaption: 'Wpisz swoje informacje',
    streetAddress: 'Adres',
    streetAddressCaption: 'Wpisz swój adres',
    city: 'Miasto',
    cityCaption: 'Wpisz swoje miasto',
    state: 'Województwo',
    stateCaption: 'Wpisz swoje województwo',
    postalCode: 'Kod pocztowy',
    postalCodeCaption: 'Wpisz swój kod pocztowy',
    country: 'Kraj',
    countryCaption: 'Wpisz swój kraj',
    titleColor: 'Kolor tytułu',
    titleColorCaption: 'Możesz zmienić kolor tytułu',
    fontFamily: 'Krój czcionki',
    fontFamilyCaption: 'Możesz zmienić krój czcionki',
    fontSize: 'Rozmiar czcionki',
    fontSizeLabel: 'Rozmiar czcionki etykiety',
    fontSizeCaption: 'Możesz zmienić rozmiar czcionki',
    fontSelect: 'Czcionka',
    fontSelectCaption: 'Wybierz czcionkę',
    imageMargin: 'Margines obrazu',
    profilePicture: 'Zdjęcie profilowe',
    profilePictureCaption: 'Zmień zdjęcie profilowe',
    pictureSize: 'Rozmiar zdjęcia',
    pictureSizeCaption: 'Możesz zmienić rozmiar zdjęcia',
    title: 'Tytuł',
    titleCaption: 'Wpisz tytuł',
    blockCaption: 'Wpisz tytuł swojego bloku',
    titlePageCaption: 'Wpisz tytuł swojej podstrony',
    templates: 'Szablony',
    templatesCaption: 'Wybierz szablon dla swojej podstrony',
    myTemplates: 'Moje szablony',
    myTemplatesEmpty: 'Brak szablonów. Zapisz obecny design podstrony, aby użyć go później.',
    saveAsTemplate: 'Zapisz jako szablon',
    saveCurrentAsTemplate: 'Zapisz obecny jako szablon',
    templateSaved: 'Szablon zapisany',
    templateApplied: 'Szablon zastosowany',
    buildFromReference: 'Utwórz z referencji',
    templateAppliedCount: 'Szablon zastosowany — dodano {n} bloków',
    searchTemplates: 'Szukaj szablonów…',
    favorites: 'Ulubione',
    previewLive: 'Podgląd na żywo',
    previewingTemplate: 'Podgląd',
    exitPreview: 'Wyjdź',
    templateKind: 'Co ma być zawarte',
    publish: 'Publikuj',
    unpublish: 'Cofnij publikację',
    templatePublished: 'Szablon opublikowany',
    templateUnpublished: 'Publikacja szablonu cofnięta',
    discoverTemplates: 'Odkryj społeczność',
    discoverSubtitle: 'Darmowe szablony opublikowane przez innych twórców w UniLink.',
    discoverEmpty: 'Brak jeszcze publicznych szablonów — bądź pierwszy, który opublikuje.',
    pricing: 'Cennik',
    background: 'Tło',
    backgroundColor: 'Kolor tła',
    textBackground: 'Tło tekstu',
    textBackgroundCaption: 'Wybierz kolor tła tekstu',
    textColor: 'Kolor tekstu',
    textColorCaption: 'Wybierz kolor tekstu',
    gradientBackground: 'Tło gradientowe',
    gradientColor: 'Kolor gradientu',
    BackgroundType: 'Typ',
    backgroundSource: 'Źródło tła',
    backgroundSourceCaption: 'Wybierz źródło tła',
    backgroundStyle: 'Styl tła',
    backgroundStyleCaption: 'Wybierz styl tła',
    backgroundStylesNormal: 'Zwykłe',
    backgroundStylesGlass: 'Szkło',
    backgroundStylesOutline: 'Kontur',
    backgroundTypeCaption: 'Wybierz typ tła',
    color: 'Kolor',
    colorTooltip: 'Możesz zmienić kolor',
    backgroundOpacityTooltip: 'Przeciągnij suwak, aby ustawić przezroczystość tła',
    backgroundBlur: 'Rozmycie tła',
    backgroundBlurCaption: 'Przeciągnij suwak, aby rozmyć tło',
    backgroundBrightness: 'Jasność tła',
    backgroundBrightnessCaption: 'Przeciągnij suwak, aby zmienić jasność tła',
    backgroundContrast: 'Kontrast tła',
    backgroundContrastCaption: 'Przeciągnij suwak, aby zmienić kontrast tła',
    color1: 'Kolor 1',
    color2: 'Kolor 2',
    colorCaption: 'Wpisz kolor swojej podstrony',
    gradient: 'Gradient',
    image: 'Obraz',
    photo: 'Zdjęcie',
    gif: 'GIF',
    animation: 'Animacja',
    video: 'Wideo',
    hexColor: 'Kolor hex',
    direction: 'Kierunek',
    gradientDirection: 'Kierunek gradientu',
    directionCaption: 'Przeciągnij suwak, aby ustawić kierunek gradientu',
    offset: 'Przesunięcie',
    gradientOffset: 'Przesunięcie gradientu',
    offsetCaption: 'Przeciągnij suwak, aby ustawić przesunięcie gradientu',
    backgroundDarkness: 'Przyciemnienie tła',
    backgroundDarknessCaption: 'Przeciągnij suwak, aby przyciemnić obraz tła',
    uploadVideo: 'Prześlij wideo',
    uploadFile: 'Prześlij plik',
    uploadVideoCaption: 'Wideo dla tła Twojej podstrony',
    linkToVideo: 'Link do wideo',
    linkToVideoCaption: 'Dodaj link do wideo',
    videoWithSound: 'Wideo z dźwiękiem',
    videoWithSoundCaption: 'Odtwarzaj wideo z dźwiękiem',
    fonts: 'Czcionki',
    fontRoles: {
      heading: 'Nagłówek',
      subtitle: 'Podtytuł',
      body: 'Globalna',
    },
    fontWeight: 'Grubość czcionki',
    fontWeightCaption: 'Kliknij, aby wybrać swoje przeznaczenie',
    preloader: 'Ekran ładowania',
    preview: 'Podgląd',
    hideLogo: 'Ukryj logo UniLink',
    cover: 'Okładka',
    coverCaption: 'Zmień okładkę',
    coverCaptionHeader: 'Dodaj obraz lub wideo do okładki nagłówka',
    pageNavigation: 'Nawigacja podstrony',
    websiteNavigation: 'Nawigacja zakładek',
    backgroundOpacity: 'Przezroczystość tła',
    backgroundOpacityCaption: 'Przeciągnij suwak, aby ustawić przezroczystość tła przycisku',
    borderRadius: 'Promień obramowania',
    borderRadiusCaption: 'Przeciągnij suwak, aby ustawić promień obramowania',
    heightTabs: 'Wysokość zakładek',
    heightTabsCaption: 'Przeciągnij suwak, aby ustawić wysokość zakładek',
    backgroundShadow: 'Cień tła',
    backgroundShape: 'Kształt tła',
    backgroundBorder: 'Obramowanie tła',
    opacity: 'Przezroczystość',
    opacityCaption: 'Przeciągnij suwak, aby ustawić przezroczystość',
    shape: 'Kształt',
    shapeCaption: 'Ustaw kształt',
    text: 'Tekst',
    textCaption: 'Wpisz tekst',
    textSize: 'Rozmiar tekstu',
    textSizeCaption: 'Przeciągnij suwak, aby ustawić rozmiar tekstu',
    additionalText: 'Dodatkowy tekst',
    username: 'Nazwa użytkownika',
    currency: 'Waluta',
    language: 'Język',
    timeZone: 'Strefa czasowa',
    websiteNiche: 'Nisza strony',
    websiteNicheCaption: 'Wpisz niszę swojej strony',
    renameCaption: 'Zmień tytuł bloku',
    description: 'Opis',
    descriptionCaption: 'Wpisz opis',
    actionButton: 'Przycisk akcji',
    actionButtonCaption: 'Przycisk wezwania do działania motywuje odwiedzających do podjęcia działania',
    animationDirection: 'Kierunek animacji',
    animationDirectionCaption: 'Wybierz kierunek animacji',
    buttonTitle: 'Tytuł przycisku',
    buttonTitleCaption: 'Wpisz tytuł przycisku',
    buttonUrl: 'URL przycisku',
    buttonUrlCaption: 'URL otworzy się w nowym oknie',
    imageSize: 'Rozmiar obrazu',
    imageSizeCaption: 'Przeciągnij suwak, aby ustawić rozmiar obrazu',
    view: 'Widok',
    viewCaption: 'Wybierz widok',
    margin: 'Margines',
    marginCaption: 'Przeciągnij suwak, aby dodać margines nad i pod elementem',
    separateTopBottom: 'Góra / Dół',
    padding: 'Wypełnienie',
    paddingCaption: 'Przeciągnij suwak, aby dodać wypełnienie nad i pod elementem',
    fullWidth: 'Pełna szerokość',
    lineHeight: 'Interlinia',
    lineHeightCaption: 'Możesz zmienić interlinię',
    button: 'Przycisk',
    titleSize: 'Rozmiar tytułu',
    titleSizeCaption: 'Możesz zmienić rozmiar tytułu',
    titleLineHeight: 'Interlinia tytułu',
    titleLineHeightCaption: 'Dostosuj interlinię tytułu, aby uzyskać ciekawsze rozwiązania projektowe tekstu',
    layout: 'Układ',
    layoutCaption: 'Stwórz taki układ nagłówka, jaki chcesz',
    layoutAlign: 'Wyrównanie układu',
    alignText: 'Wyrównaj tekst',
    align: 'Wyrównanie',
    alignCaption: 'Wybierz wyrównanie',
    position: 'Pozycja',
    positionCaption: 'Wybierz pozycję',
    width: 'Szerokość',
    widthCaption: 'Wybierz szerokość banera',
    nameHeader: 'Imię',
    nameCaption: 'Wpisz nazwę swojego konta',
    shortBio: 'Krótkie bio',
    shortBioCaption: 'Wpisz krótkie bio swojego konta',
    externalLink: 'Link zewnętrzny',
    externalLinkCaption: 'Wpisz link zewnętrzny do swojego konta',
    location: 'Lokalizacja',
    locationCaption: 'Wpisz swoją lokalizację',
    locationMap: 'Mapa lokalizacji',
    locationMapCaption: 'Wpisz URL swojej lokalizacji',
    rightIcon: 'Prawa ikona',
    rightIconCaption: 'Ta ikona pojawi się po prawej stronie przycisku',
    buttons: 'Przyciski',
    buttonsCaption: 'Dodaj przyciski akcji',
    nameLogo: 'Logo imienia',
    nameLogoCaption: 'Prześlij logo dla swojego imienia',
    buttonText: 'Tekst przycisku',
    buttonTextCaption: 'Wpisz nazwę przycisku',
    buttonColor: 'Kolor przycisku',
    buttonColorCaption: 'Wybierz kolory przycisku',
    buttonColorCTACaption: 'Wybierz kolor tła przycisku CTA',
    cartColor: 'Kolor koszyka',
    cartColorCaption: 'Wybierz kolor tła koszyka',
    ctaButton: 'Przycisk CTA',
    ctaButtonCaption: 'Ta ikona pojawi się po prawej stronie przycisku',
    style: 'Styl',
    socialIconsStyleCaption: 'Możesz wybrać styl ikon społecznościowych',
    socialIconsShape: 'Kształt ikon społecznościowych',
    socialIconsShapeCaption: 'Możesz wybrać kształt ikon społecznościowych',
    headerTextColorCaption: 'Możesz wybrać kolor tekstu nagłówka',
    pictureShape: 'Kształt zdjęcia',
    pictureShapeCaption: 'Możesz wybrać kształt zdjęcia profilowego',
    socialLinks: 'Linki społecznościowe',
    socialLinksCaption: 'Dodaj przyciski linków społecznościowych dla szybkiego kontaktu z klientami jednym kliknięciem',
    URL: 'URL',
    URLCaption: 'Wpisz adres URL',
    heading: 'Nagłówek',
    headingTitle: 'Tytuł nagłówka',
    headingTitleCaption: 'Wpisz tytuł nagłówka',
    headingDescription: 'Opis nagłówka',
    headingDescriptionCaption: 'Wpisz opis nagłówka',
    headingImage: 'Obraz nagłówka',
    headingImageCaption: 'Prześlij obraz dla nagłówka',
    headingPosition: 'Pozycja nagłówka',
    headingInsideBlock: 'Wewnątrz bloku',
    headingOutsideBlock: 'Poza blokiem',
    headingDivider: 'Separator nagłówka',
    canonicalURL: 'Kanoniczny URL',
    seo: 'SEO',
    seoCaption: 'Dostosuj produkt za pomocą tagów meta SEO',
    themes: 'Motywy',
    brandColors: 'Brand Kit',
    applyBrandColors: 'Zastosuj do profilu',
    syncBlocks: 'Synchronizuj wszystkie bloki',
    brandColorsApplied: 'Kolory marki zastosowane',
    generatedPalette: 'Wygenerowana paleta',
    applying: 'Stosowanie...',
    syncing: 'Synchronizowanie...',
    backgroundType: 'Typ tła',
    palettes: 'Palety',
    previewTitle: 'Tytuł',
    previewTitleCaption: 'Wpisz tytuł podglądu',
    previewDescription: 'Opis',
    previewDescriptionCaption: 'Wpisz opis podglądu',
    previewButton: 'Tekst przycisku',
    previewButtonCaption: 'Wpisz tekst przycisku podglądu',
    previewLabel: 'Tekst etykiety',
    previewLabelCaption: 'Wpisz tekst etykiety podglądu',
    previewThumbnail: 'Miniatura',
    previewThumbnailCaption: 'Prześlij miniaturę podglądu',
  },
  table: {
    clicks: 'Kliknięcia',
    signups: 'Rejestracje',
    views: 'Wyświetlenia',
    orderNumber: 'Numer zamówienia',
    amount: 'Kwota',
    credits: 'Kredyty',
    invoice: 'Faktura',
    email: 'E-mail',
    card: 'Karta',
    currency: 'Waluta',
    name: 'Imię',
    contact: 'Kontakt',
    optIn: 'Zgoda',
    notes: 'Notatki',
    address: 'Adres',
    date: 'Data',
    action: 'Akcja',
    custom: 'Własne',
    status: 'Status',
    tags: 'Tagi',
    view: 'Podgląd',
    remove: 'Usuń',
    sendEmail: 'Wyślij e-mail',
    details: 'Szczegóły',
    purchases: 'Zakupy',
    order: 'Zamówienie',
    money: 'Kwota',
    type: 'Typ',
    orderCode: 'Kod zamówienia',
  },
  settings: {
    title: 'Ustawienia',
    settings: 'ustawienia',
    accountSettings: 'Ustawienia konta',
    email: 'E-mail',
    subscription: 'Subskrypcja',
    billingHistory: 'Historia rozliczeń',
    dueTo: 'Do',
    subscriptionDueTo: 'Subskrypcja ważna do',
    accountLabel: 'Konto',
    profileLabel: 'Profil',
    switchProfile: 'Przełącz profil',
    createNewProfile: 'Utwórz nowy profil',
    active: 'Aktywny',
    currentPlan: 'Obecny plan',
    freePlanHint: 'Ulepsz, aby odblokować funkcje Pro i usunąć limity.',
    to: 'do',
    renews: 'Odnawia się',
    passwordChangeDesc: 'Zmień hasło swojego konta',
    apiKeyDesc: 'Użyj tego klucza do uwierzytelniania żądań API',
    apiDocumentation: 'Dokumentacja API',
    dashboardLanguageDesc: 'Język interfejsu Twojego konta',
    cancelSubscription: 'Anuluj subskrypcję',
    cancelSubscriptionConfirm: 'Czy na pewno chcesz anulować subskrypcję?',
    subscriptionCancelled: 'Twoja subskrypcja została anulowana. Twój plan pozostaje aktywny do końca okresu rozliczeniowego.',
    subscriptionCancelError: 'Nie udało się anulować subskrypcji. Skontaktuj się z pomocą techniczną.',
    deleteFirst: 'Trwale usuń swój',
    deleteSecond: 'i wszystkie jego dane. Tej czynności nie można cofnąć.',
    account: {
      title: 'Konto',
      usernameNotAvailable: 'Nazwa użytkownika jest niedostępna',
      setupCustomDomain: 'Skonfiguruj własną domenę',
      subtitle: 'E-mail konta, rozliczenia, hasło i klucz API',
    },
    profile: {
      title: 'Profil',
      usernameNotAvailable: 'Nazwa użytkownika jest niedostępna',
      setupCustomDomain: 'Skonfiguruj własną domenę',
      subtitle: 'Zarządzaj nazwą użytkownika, językiem, walutą, strefą czasową',
      category: 'Kategoria',
      categoryCaption: 'Wpisz kategorię swojego profilu',
      usernameDesc: 'Twój publiczny identyfikator',
      currencyDesc: 'Używana do zarobków i wypłat',
      languageDesc: 'Język wyświetlany odwiedzającym',
      timeZoneDesc: 'Do planowania i analityki',
      categoryDesc: 'Najlepiej opisuje Twój profil',
      privateProfile: 'Profil prywatny',
      privateProfileDesc: 'Tylko zatwierdzeni obserwujący mogą wyświetlić Twój profil',
    },
    aiassistant: {
      title: 'Asystent AI',
      subtitle: 'Dostosuj swojego asystenta AI dla lepszych, bardziej spersonalizowanych odpowiedzi',
      titleText: 'Pomóż AI zrozumieć, kim jesteś, dla bardziej trafnych odpowiedzi',
      customAiTitle: 'Niestandardowe instrukcje',
      customAiPlaceholder: 'Dodaj konkretne instrukcje dla AI...',
      customAiDescription: 'Te instrukcje będą stosowane w każdej rozmowie z AI',
      nicknameTitle: 'Jak AI ma się do Ciebie zwracać?',
      nicknamePlaceholder: 'Pseudonim',
      titleBio: 'Bio / Opis',
      bioPlaceholder: 'Opowiedz nam trochę o sobie...',
      occupation: 'Czym się zajmujesz?',
      occupationPlaceholder: 'np. Student inżynierii na University of Waterloo',
      aboutYouTitle: 'O Tobie',
      aboutYouTooltip: 'Opowiedz swojemu asystentowi AI trochę o sobie',
      locationTitle: 'Lokalizacja',
      locationPlaceholder: 'np. Kijów, Ukraina',
      categoryTitle: 'Kategoria',
    },
    notifications: {
      title: 'Powiadomienia',
      subtitle: 'Skonfiguruj powiadomienia o nowych e-mailach odwiedzających i zamówieniach',
      text: 'Połącz komunikatory, aby otrzymywać powiadomienia o nowym e-mailu klienta i zamówieniu',
      setUpWebhooks: 'Skonfiguruj webhooki w sekcji Webhooki',
      save: 'Zapisz',
      connect: 'POŁĄCZ',
      disconnect: 'ROZŁĄCZ',
      webhook: 'Webhook',
      emailSubmit: 'Wysłanie zbierania danych',
      formSubmit: 'Wysłanie formularza',
      showSubmit: 'Wysłanie sklepu',
      digitalSubmit: 'Wysłanie produktu cyfrowego',
      appointmentSubmit: 'Wysłanie wizyty',
      requestSubmit: 'Wysłanie usługi',
      donationSubmit: 'Wysłanie darowizny',
      email: 'E-mail',
      settings: 'ustawienia',
      cartSubmit: 'Wysłanie koszyka',
      linkClick: 'Kliknięcie linku',
      contactClick: 'Kliknięcie kontaktu',
      all: 'Wszystkie',
      updates: 'Aktualizacje',
      messages: 'Wiadomości',
      opportunities: 'Możliwości',
      insights: 'Wnioski',
      activity: 'Aktywność',
      system: 'System',
      news: 'Nowości',
      more: 'Pokaż więcej',
      less: 'Pokaż mniej',
      connectedAccounts: 'Połączone konta',
      addEmailAccount: 'Dodaj konto e-mail',
    },
    paymentSystem: {
      title: 'System płatności',
      subtitle: 'Skonfiguruj wypłaty przez Stripe lub PayPal',
      text: 'Zobacz opłaty za przetwarzanie',
      connected: 'Połączono',
      active: 'Przyjmuj płatności na stronie',
      pending: 'Oczekujące',
      disconnect: 'Rozłącz',
      connect: 'Połącz',
      add: 'Dodaj',
      ofYourAccount: 'Twojego konta',
      save: 'Zapisz',
    },
    manualPayments: {
      title: 'Płatności ręczne / offline',
      hint: 'Klienci płacą offline (przelew bankowy, gotówka, QR). Ty ręcznie potwierdzasz zamówienie.',
      save: 'Zapisz',
      iban: 'IBAN',
      accountHolder: 'Imię i nazwisko posiadacza konta',
      bankName: 'Nazwa banku',
      phone: 'Telefon',
      payeeName: 'Nazwa odbiorcy',
      instruction: 'Instrukcja',
      instructionHint: 'Ozdób za pomocą **pogrubienia** ~przekreślenia~ _kursywy_',
      requireProof: 'Wymagaj dowodu płatności',
      requireProofHint: 'Aby sfinalizować zamówienie, klienci muszą przesłać zrzut ekranu (paragon, potwierdzenie przelewu lub inny dowód płatności).',
      markPaidOnConfirm: 'Oznacz jako opłacone po potwierdzeniu klienta',
      markPaidOnConfirmHint: 'Automatycznie aktualizuje status płatności na „Opłacone” po potwierdzeniu płatności przez klienta.',
      contactBeforePay: 'Włącz kontakt ze sprzedawcą przed płatnością',
      contactBeforePayHint: 'Pozwala klientom pominąć płatność, aby napisać do sprzedawcy — zwiększa liczbę zapytań, ale buduje zaufanie i zmniejsza liczbę anulowań.',
    },
    shop: {
      title: 'Sklep',
      subtitle: 'Ustawianie kategorii i właściwości',
      label: {
        title: 'Etykiety',
        subtitle: 'Dodaj etykiety do kart produktów',
        addValue: 'Dodaj wartość',
        save: 'Zapisz',
        value: 'Wartość',
        enterTitle: 'Wpisz tytuł',
        maximum: 'Maksymalna liczba wartości to 5',
        add: 'Dodaj',
        edit: 'Edytuj',
        labels: 'Etykiety',
      },
      category: {
        title: 'Kategorie',
        subtitle: 'Dodaj kategorię do swoich produktów',
        addCategory: 'Dodaj kategorię',
        save: 'Zapisz',
        maximum: 'Maksymalna liczba to',
        editTitle: 'Kategoria',
        name: 'Nazwa',
        namePlaceholder: 'Wpisz kategorię',
        visibility: 'Widoczność',
        visible: 'Widoczna',
        hidden: 'Ukryta',
        description: 'Opis',
        descriptionHint: 'Opis musi mieć mniej niż 100 znaków',
        descriptionPlaceholder: 'Dodaj krótki opis',
        cover: 'Okładka',
        view: 'Podgląd',
        share: 'Udostępnij',
        linkCopied: 'Link skopiowany',
        saveFirst: 'Najpierw zapisz kategorię',
        moveOut: 'Przenieś na zewnątrz',
      },
      property: {
        title: 'Właściwość',
        subtitle: 'Dodaj właściwość do swoich produktów',
        addProperties: 'Dodaj właściwości',
        properties: 'Właściwości',
        type: 'Typ',
        typeTooltip: 'Typ Twoich właściwości',
        titleModal: 'Tytuł',
        titleModalTooltip: 'Nazwa Twoich właściwości',
        enterTitle: 'Wpisz tytuł',
        value: 'Wartość',
        addValue: 'Dodaj wartość',
        maximum: 'Maksymalna liczba wartości to',
        save: 'Zapisz',
        cancel: 'Anuluj',
        remove: 'Usuń',
        addPropertyToItem: 'Dodaj właściwość do elementu',
        add: 'Dodaj',
        edit: 'Edytuj',
        propertiesSmall: 'właściwości',
        required: 'Wymagane',
        requiredTooltip: 'Ustaw wymagane właściwości do zakupu',
        selectAll: 'Zaznacz wszystkie',
      },
      preorderForm: {
        title: 'Formularz przedsprzedaży',
        subtitle: 'Skonfiguruj pola formularza przedsprzedaży',
        fields: 'Pola',
        fieldsTooltip: 'Dodaj pola do formularza',
        required: 'Wymagane',
        submitButton: 'Tytuł przycisku wysyłania',
        redirectUrl: 'URL przekierowania (opcjonalnie)',
        resultText: 'Tekst wyniku',
        save: 'Zapisz',
        name: 'Imię',
        emailAddress: 'Adres e-mail',
        phone: 'Telefon',
        address: 'Adres',
        comment: 'Komentarz',
      },
      shipping: {
        title: 'Dane klienta',
        subtitle: 'Pola zbierane od kupującego przy kasie',
        fields: 'Pola',
        fieldsTooltip: 'Dodaj pola do formularza kasy',
        required: 'Wymagane',
        save: 'Zapisz',
        name: 'Imię',
        emailAddress: 'Adres e-mail',
        phone: 'Telefon',
        address: 'Adres',
        comment: 'Komentarz',
        addCustomField: 'Dodaj niestandardowe pole',
        addFormInfo: 'Dodaj informacje formularza',
        editFormInfo: 'Edytuj informacje formularza',
        type: 'Typ',
        typeTooltip: 'Typ niestandardowego pola',
        fieldName: 'Nazwa pola',
        fieldNameTooltip: 'Nazwa niestandardowego pola',
        placeholder: 'Placeholder',
        placeholderTooltip: 'Placeholder niestandardowego pola',
        delete: 'Usuń',
        update: 'Aktualizuj',
        add: 'Dodaj',
      },
      delivery: {
        title: 'Metody dostawy',
        subtitle: 'Skonfiguruj wysyłkę, dostawę lokalną i odbiór osobisty dla swojego sklepu.',
        loading: 'Ładowanie…',
        inactive: 'nieaktywna',
        confirmDelete: 'Usunąć tę metodę dostawy?',
        category: {
          shipping: 'Wysyłka',
          localDelivery: 'Dostawa lokalna',
          selfPickup: 'Odbiór osobisty',
        },
        rateType: {
          free: 'Darmowa',
          conditionalFree: 'Warunkowo darmowa',
          flatRate: 'Stawka stała',
          customRates: 'Stawki niestandardowe',
          carrierApi: 'API przewoźnika',
        },
        carrier: {
          custom: 'Własny przewoźnik',
        },
        add: {
          shipping: 'Dodaj wysyłkę',
          localDelivery: 'Dodaj dostawę lokalną',
          selfPickup: 'Dodaj odbiór osobisty',
        },
        actions: {
          edit: 'Edytuj',
          delete: 'Usuń',
          save: 'Zapisz',
          cancel: 'Anuluj',
        },
        fields: {
          name: 'Nazwa',
          namePh: 'np. Wysyłka standardowa',
          description: 'Opis',
          isActive: 'Aktywna',
          estimatedDays: 'Szacowany czas (dni)',
          currency: 'Waluta',
          countryCodes: 'Kody krajów (CSV)',
          carrier: 'Przewoźnik',
          rateType: 'Typ stawki',
          flatPrice: 'Cena stała',
          freeThreshold: 'Darmowa powyżej (suma częściowa)',
          fallbackPrice: 'Cena zastępcza',
          customRates: 'Wiersze stawek niestandardowych',
          senderCity: 'Nazwa miasta nadawcy',
          senderCityRef: 'Ref. miasta nadawcy',
          pickupInstructions: 'Instrukcje odbioru',
          pickupCharge: 'Opłata za odbiór',
          askPickupDateTime: 'Pytaj o datę/godzinę odbioru przy kasie',
        },
        rateRow: {
          subtotal: 'Wg sumy częściowej',
          weight: 'Wg wagi (g)',
          min: 'Min',
          max: 'Maks',
          price: 'Cena',
          add: 'Dodaj wiersz',
        },
      },
      legal: {
        title: 'Dokumenty prawne',
        subtitle: 'Regulamin, Prywatność, Polityka zwrotów — wyświetlane klientom przy kasie.',
        loading: 'Ładowanie…',
        empty: 'Brak dokumentów prawnych.',
        inactive: 'nieaktywny',
        required: 'wymagany',
        confirmDelete: 'Usunąć ten dokument?',
        addNew: '+ Dodaj dokument',
        types: {
          terms: 'Regulamin',
          privacy: 'Polityka prywatności',
          returns: 'Polityka zwrotów / reklamacji',
          shipping: 'Polityka wysyłki',
          cookies: 'Polityka cookies',
          custom: 'Własny',
        },
        fields: {
          title: 'Tytuł',
          titlePh: 'np. Regulamin',
          type: 'Typ dokumentu',
          content: 'Treść',
          contentPh: 'Wpisz tutaj treść prawną…',
          isActive: 'Aktywny',
          requireAcceptance: 'Wymagaj akceptacji przy kasie',
        },
        actions: {
          edit: 'Edytuj',
          delete: 'Usuń',
          save: 'Zapisz',
          cancel: 'Anuluj',
        },
      },
      checkoutGroup: 'Kasa',
      serviceCharge: {
        title: 'Opłata serwisowa',
        subtitle: 'Dodaj opłatę serwisową lub napiwek do każdego zamówienia.',
        label: 'Opis',
        labelPh: 'np. Opłata serwisowa 5% i napiwek za dostawę $3',
        rate: 'Stawka',
        rateHint: 'Procent sumy częściowej zamówienia.',
        amount: 'Kwota',
        amountHint: 'Stała kwota dodawana dodatkowo.',
      },
      tip: {
        title: 'Napiwki',
        subtitle: 'Pozwól klientom dodać napiwek do zamówienia przy kasie.',
        enable: 'Włącz napiwki',
        presets: 'Gotowe kwoty napiwków (%)',
        noPresets: 'Brak gotowych kwot — dodaj jedną poniżej.',
        presetPh: 'np. 10',
        addPreset: '+ Dodaj gotową kwotę',
        presetsHint: 'Wyświetlane jako przyciski szybkiego wyboru przy kasie. Maksymalnie 6.',
        remove: 'Usuń',
        allowCustom: 'Zezwól na własną kwotę',
        label: 'Etykieta zachęty',
        labelPh: 'np. Dodaj napiwek za świetną obsługę',
        save: 'Zapisz',
        saving: 'Zapisywanie…',
      },
      orderNumber: {
        title: 'Numer zamówienia',
        subtitle: 'Dostosuj wygląd numerów zamówień.',
        next: 'Następny numer zamówienia',
        prefix: 'Prefiks',
        suffix: 'Sufiks',
        showInMessage: 'Pokaż na fakturze i w wiadomości zamówienia',
        reset: 'Zresetuj numer zamówienia',
      },
      orderMessage: {
        title: 'Wiadomość zamówienia',
        subtitle: 'Dostosuj potwierdzenie zamówienia wysyłane do klientów.',
        footer: 'Stopka wiadomości',
        footerPh: 'np. Dziękujemy za zamówienie! Śledź nas @twojamarka',
        footerHint: 'Dołączana do każdej wiadomości potwierdzającej zamówienie.',
        plain: 'Zwykła wiadomość',
        plainHint: 'Usuń całe formatowanie z wiadomości zamówienia.',
      },
      invoice: {
        title: 'Faktura',
        subtitle: 'Faktura z marką dołączana do opłaconych zamówień.',
        upgrade: 'Ulepsz',
        showLogo: 'Pokaż logo',
        header: 'Nagłówek',
        footer: 'Stopka',
        companyName: 'Nazwa firmy',
        companyEmail: 'E-mail firmy',
        companyPhone: 'Telefon firmy',
        companyAddress: 'Adres firmy',
        companyAddressPh: 'Wpisz adres',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Dostosuj swoją podstronę za pomocą tagów meta SEO',
      titleText: 'Tytuł',
      titlePlaceholder: 'Wpisz tytuł podstrony',
      description: 'Opis',
      descriptionPlaceholder: 'Wpisz opis podstrony',
      favicon: 'Favicon',
      uploadFavicon: 'Prześlij favicon',
      imagePreview: 'Podgląd obrazu',
      useCustom: 'Użyj własnego obrazu',
      save: 'Zapisz',
      visualise: 'Zobacz, jak podgląd Twojej strony będzie wyglądać w Google',
      inMessengers: 'W komunikatorach',
      inSocial: 'W mediach społecznościowych',
      searchEngine: 'Wyszukiwarka',
      googleIndexable: 'Indeksowalne przez Google',
      sitemap: {
        title: 'Mapa strony',
        entryHint: 'Zarządzaj, które podstrony i produkty mogą indeksować wyszukiwarki.',
        setupLink: 'dostosuj',
        mainEntry: 'Indeksuj stronę',
        subtitle: 'Wybierz, które podstrony powinny być indeksowane przez wyszukiwarki. Wyłączone podstrony otrzymują tag noindex i są usuwane z mapy strony.',
        mainPage: 'Główna podstrona profilu',
        pagesSection: 'Podstrony',
        pagesHint: 'Przełącz indeksowanie dla każdej dodatkowej podstrony Twojej witryny.',
        noPages: 'Brak dodatkowych podstron.',
        productsSection: 'Produkty',
        productsHint: 'Przełącz indeksowanie dla poszczególnych stron produktów.',
        noProducts: 'Brak produktów.',
        postsSection: 'Posty',
        postsHint: 'Przełącz indeksowanie dla poszczególnych postów.',
        noPosts: 'Brak postów.',
        blogSection: 'Artykuły na blogu',
        blogHint: 'Przełącz indeksowanie dla poszczególnych artykułów na blogu.',
        noArticles: 'Brak artykułów na blogu.',
        loadMore: 'Załaduj więcej',
        loading: 'Ładowanie…',
      },
    },
    analytics: {
      title: 'Analityka',
      subtitle: 'Zintegruj Facebook Pixel, Google Analytics i parametry UTM',
      facebookTooltip: 'Połącz Facebook, aby wyświetlić analitykę',
      googleAnalyticsTooltip: 'Google Analytics pozwala mierzyć ROI reklam oraz śledzić wszystkie linki.',
      googleTagManagerTooltip: 'Google Tag Manager pozwala konfigurować i natychmiast wdrażać tagi na Twojej stronie',
      tikTokPixelTooltip: 'TikTok Pixel to potężne narzędzie pomiarowe, które śledzi wpływ Twoich reklam TikTok na stronie',
      pinterestTag: 'Tag Pinterest',
      pinterestTagTooltip: 'Tag Pinterest to fragment kodu dodawany do strony, który pozwala Pinterest śledzić odwiedzających oraz ich działania po zobaczeniu reklamy Pinterest.',
      tag: 'tag',
      headerTagTooltip: 'Wklej tag pojawiający się w nagłówku strony',
      bodyTagTooltip: 'Wklej tag pojawiający się w treści strony',
      utmParameters: 'Parametry UTM',
      utmParametersTooltip: 'Zbieraj dane kampanii za pomocą niestandardowych adresów URL. Dodaj parametry do adresów URL, aby identyfikować kampanie kierujące ruch.',
      makeAnalytics: 'Spraw, aby Google Analytics pokazywał ruch z UniLink jako Społecznościowy',
      the: 'Parametr',
      campaign: 'kampanii',
      parameter: 'jest ustawiany dynamicznie na podstawie tytułu każdego posta lub linku',
      save: 'Zapisz',
    },
    customDomain: {
      title: 'Własna domena',
      subtitle: 'Dostosuj swoją podstronę za pomocą własnej domeny',
      titleTooltip: 'Dodaj własną domenę',
      save: 'Zapisz',
      connect: 'Połącz',
      connecting: 'Łączenie',
      instructions: 'Instrukcje',
      submit: 'Wyślij',
      submitting: 'Wysyłanie...',
      enterDomain: 'Wpisz swoją domenę',
      domainPlaceholder: 'twoja-domena.com',
      steps: {
        submitting: 'Wysyłanie żądania',
        validation: 'Walidacja domeny',
        certificate: 'Wystawianie certyfikatu',
        complete: 'Zakończono',
      },
      txtRecord: {
        title: 'Rekord TXT',
        description: 'Dodaj następujący rekord TXT do ustawień DNS:',
        verifyButton: 'Zweryfikuj rekord TXT',
        verifying: 'Weryfikowanie...',
        verified: 'Rekord TXT zweryfikowany',
      },
      cnameRecord: {
        title: 'Rekord CNAME',
        description: 'Dodaj następujący rekord CNAME do ustawień DNS:',
        verifyButton: 'Zweryfikuj rekord CNAME',
        verifying: 'Weryfikowanie...',
        verified: 'Rekord CNAME zweryfikowany',
      },
      dnsTable: {
        type: 'Typ',
        host: 'Host',
        value: 'Wartość',
        ttl: 'TTL',
        copy: 'Kopiuj',
        copied: 'Skopiowano!',
      },
      provisioning: {
        title: 'Certyfikat SSL jest wystawiany...',
        description: 'Może to potrwać kilka minut. Czekaj.',
        timeout: 'Wystawianie certyfikatu trwa dłużej niż oczekiwano. Sprawdź ponownie później.',
      },
      complete: {
        title: 'HTTPS zostało pomyślnie włączone na Twojej domenie.',
        connected: 'Połączono',
      },
      failed: {
        title: 'Połączenie z domeną nie powiodło się',
        tryAgain: 'Spróbuj ponownie',
      },
      rootDomainWarning: 'Domeny główne wymagają, aby Twój dostawca DNS obsługiwał spłaszczanie CNAME (np. Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Rozłącz domenę',
        message: 'Czy na pewno chcesz rozłączyć tę domenę? Twoja strona nie będzie już dostępna pod tą domeną.',
        confirm: 'Rozłącz',
        cancel: 'Anuluj',
      },
    },
    developerApi: {
      title: 'API dla deweloperów',
      subtitle: 'Twórz klucze API, aby uzyskać dostęp do zamówień, produktów i klientów przez endpointy /api/v2.',
      keyName: 'Nazwa klucza',
      keyNamePh: 'np. Synchronizacja magazynu',
      scopes: 'Uprawnienia',
      scopeLabels: {
        'orders:read': 'Odczyt zamówień',
        'products:read': 'Odczyt produktów',
        'products:write': 'Aktualizacja stanu produktów',
        'customers:read': 'Odczyt klientów',
      },
      create: 'Utwórz klucz',
      creating: 'Tworzenie…',
      created: 'Klucz API utworzony',
      copyWarning: 'Skopiuj ten klucz teraz — nie zostanie ponownie wyświetlony.',
      done: 'Gotowe',
      revoke: 'Odbierz',
      revoked: 'Odebrano',
      confirmRevoke: 'Odebrać ten klucz API? Aplikacje, które go używają, przestaną działać.',
      empty: 'Brak kluczy API.',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'Połącz swój numer WhatsApp Business, aby otrzymywać i odpowiadać na wiadomości klientów.',
      phoneNumberId: 'ID numeru telefonu',
      accessToken: 'Token dostępu',
      displayPhone: 'Wyświetlany telefon (opcjonalnie)',
      connect: 'Połącz',
      connecting: 'Łączenie…',
      connected: 'Połączono',
      disconnect: 'Rozłącz',
      confirmDisconnect: 'Rozłączyć WhatsApp?',
      webhookHelp: 'Ustaw ten Callback URL i token weryfikacyjny w Meta App → WhatsApp → Konfiguracja:',
      webhookUrl: 'Callback URL',
      verifyToken: 'Token weryfikacyjny',
      inbox: 'Skrzynka',
      noMessages: 'Brak wiadomości.',
      selectThread: 'Wybierz rozmowę.',
      replyPlaceholder: 'Napisz wiadomość…',
      send: 'Wyślij',
      broadcast: {
        title: 'Wysyłka masowa',
        audienceInbox: 'Kontakty ze skrzynki',
        audienceCrm: 'Odbiorcy CRM (szablon)',
        message: 'Wiadomość',
        inboxHint: 'Dowolny tekst — dostarczany tylko do kontaktów w oknie obsługi klienta 24h.',
        templateName: 'Nazwa szablonu',
        templateLang: 'Język szablonu',
        crmHint: 'Użyj zatwierdzonego szablonu WhatsApp — wymagany do dotarcia do kontaktów poza oknem 24h.',
        send: 'Wyślij wysyłkę masową',
        sending: 'Wysyłanie…',
        empty: 'Brak wysyłek masowych.',
        sent: 'wysłano',
        failed: 'nieudane',
      },
      autoReply: {
        title: 'Automatyczne odpowiedzi',
        type: 'Typ',
        typeKeyword: 'Słowo kluczowe',
        typeGreeting: 'Powitanie (pierwsza wiadomość)',
        typeAway: 'Nieobecność (poza godzinami)',
        keyword: 'Słowo kluczowe',
        from: 'Godziny od',
        to: 'Godziny do',
        reply: 'Tekst odpowiedzi',
        add: 'Dodaj regułę',
        empty: 'Brak reguł automatycznych odpowiedzi.',
        delete: 'Usuń',
      },
    },
    webhooks: {
      title: 'Webhooki',
      subtitle: 'Wysyłaj powiadomienia o zdarzeniach w czasie rzeczywistym do zewnętrznych usług',
      webhook: 'Webhook',
      webhookTooltip: 'Dodaj webhook',
      send: 'Wysyłaj zdarzenia do zewnętrznej strony',
      webhookUrl: 'URL webhooka (żądanie POST)',
      error: 'Wpisz poprawny link',
      save: 'Zapisz zmiany',
      enableWebhooks: 'Włącz webhooki',
      enableDescription: 'Żądania POST dla wybranych zdarzeń',
      endpointUrl: 'URL endpointu',
      endpointTooltip: 'Adres URL, który otrzyma żądania POST, gdy wystąpią wybrane zdarzenia',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Zdarzenia',
      selectAll: 'Zaznacz wszystkie',
      deselectAll: 'Odznacz wszystkie',
      filterPlaceholder: 'Filtruj zdarzenia...',
      all: 'Wszystkie',
      none: 'Żadne',
      active: 'Aktywny',
      inactive: 'Nieaktywny',
      categories: {
        submissions: 'Zgłoszenia',
        engagement: 'Zaangażowanie',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Subskrypcja nagłówka',
        SubmitHeaderMessage: 'Wiadomość z nagłówka',
        SubmitDataCollect: 'Zebrane dane',
        SubmitForm: 'Wysłanie formularza',
        SubmitShop: 'Zamówienie w sklepie',
        SubmitShopPreorder: 'Przedsprzedaż w sklepie',
        SubmitDigital: 'Produkt cyfrowy',
        SubmitAppointment: 'Wizyta',
        SubmitService: 'Zamówienie usługi',
        SubmitEvent: 'Rejestracja na wydarzenie',
        SubmitCourse: 'Zapis na kurs',
        SubmitDonation: 'Darowizna',
        SubmitMembership: 'Członkostwo',
        SubmitBlog: 'Zakup na blogu',
        SubmitCoupon: 'Użyto kuponu',
        SubmitTip: 'Napiwek',
        SubmitLink: 'Zakup linku',
        SubmitProductMessage: 'Pytanie o produkt',
        SubmitPodcast: 'Zakup podcastu',
        SubmitBooking: 'Rezerwacja',
        SubmitRental: 'Wynajem',
        SubmitSingleProduct: 'Pojedynczy produkt',
        SubmitDiscount: 'Zamówienie z rabatem',
        SubmitListing: 'Zapytanie o ofertę',
        SubmitUnlock: 'Odblokowanie treści',
        SubmitChatAi: 'Wiadomość czatu AI',
        ClickLink: 'Kliknięcie linku',
        ClickContact: 'Kliknięcie kontaktu',
        AddToCart: 'Dodanie do koszyka',
        AddToCartSingleProduct: 'Pojedynczy produkt do koszyka',
        AddToWishlist: 'Dodanie do listy życzeń',
        InitiateCheckout: 'Rozpoczęcie zamówienia',
        DownloadFile: 'Pobranie pliku',
        DownloadMusic: 'Pobranie muzyki',
        CopyCoupon: 'Kopiowanie kuponu',
        CopyDiscount: 'Kopiowanie rabatu',
        QR_ScanQrCode: 'Skan kodu QR',
        VisitPage: 'Odwiedzenie podstrony',
      },
    },
    sensitive: {
      title: 'Treści wrażliwe',
      subtitle: 'Pokaż ostrzeżenie o wrażliwych treściach przed wyświetleniem Twojej strony',
    },
    socialIntegration: {
      title: 'Integracje społecznościowe',
      subtitle: 'Zarządzaj integracjami z Instagramem, TikTokiem',
      connectInstagram: 'Połącz Instagram',
    },
    emailIntegration: {
      title: 'Integracje odbiorców',
      subtitle: 'Przekazuj adresy e-mail odwiedzających do MailChimp, Reply',
      emailCaption: 'Dodaj integrację, aby przekazywać adresy e-mail obserwujących do MailChimp',
      mailChimp: 'Integracje MailChimp',
      selzy: 'Integracje Selzy',
      selzyCaption: 'Dodaj klucz API, aby przekazywać adresy e-mail obserwujących do Selzy',
      sendPulse: 'Integracje SendPulse',
      sendPulseCaption: 'Dodaj klucz API, aby przekazywać adresy e-mail obserwujących do SendPulse',
      reply: 'Integracje Reply',
      replyCaption: 'Dodaj klucz API, aby przekazywać adresy e-mail obserwujących do',
      integrations: 'integracje',
    },
    calendarIntegration: {
      title: 'Integracje kalendarza',
      subtitle: 'Połącz swoje usługi kalendarza',
      calendly: 'Calendly',
      calendlyDescription: 'Połącz Calendly, aby synchronizować typy wydarzeń i dostępność',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Połącz Google Calendar, aby synchronizować wydarzenia i tworzyć linki Google Meet',
      zoom: 'Zoom',
      zoomDescription: 'Połącz Zoom, aby automatycznie tworzyć linki do spotkań',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Twórz linki Google Meet automatycznie (wymaga Google Calendar)',
    },
    storage: {
      title: 'Pamięć',
      subtitle: 'Zapisuj zamówienia odwiedzających w arkuszu Google',
      storageCaption: 'Dodaj integrację, aby zapisywać wszystkie zamówienia klientów w arkuszu Google',
      emailSignup: 'Zapis e-mail',
      emailSignupsCaption: 'Wybierz tabelę do zapisywania rejestracji e-mail',
      formSignups: 'Zapis formularza',
      forSignupsCaption: 'Wybierz tabelę do zapisywania rejestracji formularza',
      shopOrders: 'Zamówienia sklepu',
      shopOrderCaption: 'Wybierz tabelę do zapisywania zamówień sklepu',
      disconnect: 'Rozłącz arkusz',
      storageUsage: 'Wykorzystanie pamięci',
      of: 'z',
      uses: 'Ta aplikacja używa',
      space: 'Twojej darmowej przestrzeni dyskowej',
      view: 'zobacz szczegóły',
      noItems: 'Brak elementów',
      files: 'Pliki',
      images: 'Obrazy',
      videos: 'Wideo',
      audio: 'Audio',
      settings: 'ustawienia',
      free: 'darmowe',
      needMoreSpace: 'Potrzebujesz więcej miejsca?',
      unlockStorage: 'Odblokuj nieograniczoną pamięć, wideo 4K',
      upgradePlan: 'Ulepsz plan',
      addFile: 'Dodaj plik',
      uploading: 'Przesyłanie...',
      dragDrop: 'lub przeciągnij i upuść tutaj',
      noFilesYet: 'Brak plików',
      noImagesYet: 'Brak obrazów',
      noVideosYet: 'Brak wideo',
      noAudioYet: 'Brak audio',
      filesHint: 'Prześlij PDF-y, dokumenty i inne pliki do pobrania, aby dołączyć je do linków na swojej stronie.',
      imagesHint: 'Prześlij obrazy, aby używać ich na swojej stronie.',
      videosHint: 'Prześlij wideo, aby osadzić na swojej stronie.',
      audioHint: 'Prześlij utwory audio, aby udostępnić je na swojej stronie.',
    },
  },
  productStore: {
    title: 'Pokaż zakładkę Sklep na swojej stronie link-in-bio',
    subtitle: 'Twój sklep jest obecnie ukryty.',
  },
  sections: {
    splashScreen: {
      title: 'Ekran powitalny',
      subtitle: 'Pojawia się podczas ładowania strony',
    },
    promo: {
      title: 'Pasek promocyjny',
      subtitle: 'Wyróżnienie pozwalające zaprezentować promocje',
      masterPromoMessage:
        'Główny pasek promocyjny jest obecnie włączony. Aby utworzyć własny pasek promocyjny dla tej podstrony, musisz najpierw wyłączyć główny pasek promocyjny.',
      titlePlaceholder: 'Witamy na mojej stronie!',
      switcherIsMasterPromobar: 'Pokaż na wszystkich podstronach',
    },
    contact: {
      title: 'Kontakty',
      subtitle: 'Zapewnij sposób kontaktu z Tobą',
      caption: 'Dodaj przyciski komunikatorów dla szybkiego kontaktu z klientami jednym kliknięciem',
      tooltip: 'Kontakty pozwalają użytkownikom skontaktować się z Tobą bezpośrednio. Dodaj telefon, e-mail, komunikator lub lokalizację',
      addNewContact: 'Dodaj nowy kontakt',
      addContact: 'Dodaj kontakt',
      chooseContact: 'Wybierz kontakt',
      enterLink: 'Wpisz swój link kontaktowy',
      showDetails: 'Pokaż szczegóły',
      enterAnyContact: 'Wpisz dowolny kontakt',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Członkostwo',
      subtitle: 'Utwórz darmową lub płatną subskrypcję swoich treści',
      addNewTier: 'Dodaj nowy poziom',
      editTier: 'Edytuj poziom',
      name: 'Nazwa',
      nameCaption: 'Wpisz nazwę poziomu',
      price: 'Cena za miesiąc',
      priceCaption: 'Wpisz cenę poziomu',
      month: 'miesiąc',
      image: 'Obraz',
      imageCaption: 'Prześlij obraz dla poziomu',
    },
    pricing: {
      title: 'Cennik',
      subtitle: 'Utwórz menu z cenami',
      add: 'Dodaj nowy element',
      edit: 'Edytuj element',
      name: 'Nazwa',
      nameCaption: 'Wpisz nazwę elementu',
      duration: 'Atrybut',
      durationCaption: 'Wpisz czas, ilość lub czas trwania elementu',
      category: 'Kategoria',
      categoryCaption: 'Wpisz kategorię elementu',
      price: 'Cena',
      priceCaption: 'Wpisz cenę elementu',
      month: 'miesiąc',
      image: 'Obraz',
      imageCaption: 'Prześlij obraz dla elementu',
    },
    subscribe: {
      dataCollectTitle: 'Zbieranie danych',
      title: 'Subskrypcja',
      subtitle: 'Zbieraj e-maile lub numery telefonów odwiedzających',
      instructionsMessage: 'Dodaj pole zapisu e-mail do swojej podstrony, aby odwiedzający mogli łatwo się zapisać!',
      instructionsLink: 'Przekazuj e-maile do MailChimp, aby prowadzić kampanie marketingowe.',
      sectionHeaderCaption: 'Zapisz się do naszego newslettera',
      collecting: 'Zbieranie',
      collectingCaption: 'Wybierz typ wprowadzanych danych',
      addDataToCollect: 'Dodaj dane do zebrania',
      email: 'E-mail',
      enterEmail: 'Wpisz e-mail',
      thanksForEmail: 'Dziękujemy za Twój e-mail',
      phone: 'Telefon',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Dodaj zaktualizowane linki',
      placeholder: 'Placeholder',
      placeholderCaption: 'Wpisz tekst placeholdera',
      button: 'Przycisk',
      buttonCaption: 'Tekst zachęcający odwiedzającego do wpisania e-maila (rabat 10%, subskrybuj teraz, pobierz plik itp.)',
      submitButton: 'Przycisk wysyłania',
      enterButton: 'Przycisk wprowadzania',
      thanksMessage: 'Wiadomość z podziękowaniem',
      thanksMessageCaption: 'Wiadomość z podziękowaniem dla subskrybentów',
      resultAction: 'Akcja (po wysłaniu)',
      resultActionCaption: 'Akcja po wypełnieniu formularza',
      sendAnEmail: 'Wyślij e-mail',
      downloadFile: 'Pobierz plik',
      redirect: 'Przekierowanie',
      messageBody: 'Treść wiadomości',
      messageBodyCaption: 'Te dane zostaną wysłane na e-mail użytkownika jako prezent za jego e-mail (kupon, link do pobrania pliku itp.)',
      integration: 'Integracja',
      integrationCaption: 'Przekazuj adresy e-mail odwiedzających do MailChimp, Reply',
      storage: 'Pamięć',
      storageCaption: 'Zapisuj zamówienia odwiedzających w arkuszu Google',
      maxSize: 'Możesz dodać maksymalnie 3 kanały',
    },
    text: {
      title: 'Tekst',
      subtitle: 'Napisz cokolwiek o sobie/firmie',
      trimBio: 'Skróć tekst',
    },
    header: {
      title: 'Nagłówek',
      subtitle: 'Powiększone wyróżnione zdjęcie lub wideo na Twojej stronie',
      verifiedBadge: 'Odznaka weryfikacji',
      showProfilePic: 'Pokaż zdjęcie profilowe',
      profilePicRatio: 'Proporcje',
      profilePicRatioSquare: 'Kwadrat',
      profilePicRatioLandscape: 'Poziomo',
      profilePicRatioPortrait: 'Pionowo',
      verticalCropStep: 'zdjęcie pionowe',
      squareCropStep: 'kwadratowy awatar',
      namePlaceholder: 'Twoje imię',
      shortBioPlaceholder: 'Moje krótkie informacje',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Miasto',
      addSocial: '+ Dodaj profil społecznościowy',
      addCover: '+ Dodaj okładkę',
      addButton: '+ Dodaj przycisk',
      topButtons: 'Górne przyciski',
      bottomButtons: 'Dolne przyciski',
      buttonSubtitleLanguage: 'Przełącznik języka',
      buttonSubtitleContact: 'Zadzwoń / napisz',
      buttonSubtitleCart: 'Koszyk',
      buttonSubtitleCta: 'Wezwanie do działania',
      buttonSubtitleMessage: 'Wiadomość',
      buttonSubtitleSubscribe: 'Subskrybuj',
      buttonSubtitleQrcode: 'Kod QR',
      buttonSubtitleSearch: 'Wyszukiwanie produktów',
      buttonDisabledHint: 'Ukryte · wyłączone',
      addText: '+ Dodaj tekst',
      addLabel: '+ Dodaj etykietę',
      subtitleName: 'Dostosuj wygląd swojego imienia',
      subtitleShortBio: 'Dostosuj wygląd krótkiego bio',
      shortBioSize: 'Rozmiar krótkiego bio',
      subtitleShortBioSize: 'Możesz zmienić rozmiar krótkiego bio',
      subtitleLocation: 'Ustaw miasto/kraj, aby kierować odwiedzających do konkretnego miejsca',
      headerCoverWarningMessage: 'Twoja przeglądarka nie obsługuje znacznika wideo.',
      headerCoverTitle: 'Ustaw okładkę nad nagłówkiem',
      coverHeight: 'Wysokość okładki',
      subtitleCoverHeight: 'Możesz zmienić wysokość okładki',
      coverDarkness: 'Przyciemnienie okładki',
      subtitleCoverDarkness: 'Przeciągnij suwak, aby przyciemnić obraz okładki',
      nameSize: 'Rozmiar imienia',
      subtitleNameSize: 'Możesz zmienić rozmiar imienia',
      positionText: 'Pozycja imienia',
      subtitlePositionName: 'Przeciągnij suwak, aby ustawić pozycję imienia',
      positionContent: 'Pozycja treści',
      subtitlePositionContent: 'Ustaw pozycję dla bio, linku, lokalizacji',
      coverText: 'Tekst na okładce',
      subtitleCoverText: 'Dodaj tekst do swojej okładki',
      position: 'Pozycja',
      subtitlePosition: 'Przeciągnij suwak, aby ustawić pozycję przycisku',
      buttonCover: 'Przycisk na okładce',
      subtitleButtonCover: 'Dodaj przycisk do swojej okładki, wybierając akcję',
      subtitleFollow: 'Przycisk obserwowania pozwala użytkownikom śledzić Twoje nowości',
      buttonOpacity: 'Przeciągnij suwak, aby zmienić przezroczystość przycisku',
      subtitleCart: 'Ikona koszyka zapewniająca zakupy',
      subtitleDirect: 'Szybki przycisk kierujący odwiedzającego do komunikatorów',
      subtitleCTAButton: 'Przycisk (wezwanie do działania) motywujący użytkownika do kliknięcia',
      subtitleSocialLinks: 'Nadaj swoim sieciom społecznościowym wizualny wygląd',
      chooseSocialLink: 'Wybierz link społecznościowy',
      alignSocialLink: 'Wyrównanie linków społecznościowych',
      enterYourSocialLink: 'Wpisz swój link społecznościowy',
      blockShadow: 'Cień bloku',
      activeButtonPosition: 'Pozycja aktywnego przycisku',
      gradientColor: 'Kolor gradientu',
      bottomGradient: 'Dolny gradient',
      autoGradient: 'Automatycznie',
      customGradient: 'Własny',
      transparentGradient: 'Przezroczysty',
      gradientPositionLabel: 'Pozycja cienia',
      gradientPositionPhoto: 'Pod zdjęciem',
      gradientPositionHeader: 'Niżej w nagłówku',
      uploadLogo: 'Prześlij logo',
      customBackground: 'Własne tło',
      headingLabel: 'Etykieta nagłówka',
      customizeLabel: 'Dostosuj wygląd etykiety nagłówka',
      labelText: 'Tekst etykiety',
      enterLabelText: 'Wpisz tekst dla etykiety nagłówka',
      bottomBadge: 'Dolny odcień',
      addTint: 'Dodaj odcień',
      bottomBadgeText: 'Tekst (opcjonalnie)',
      bottomBadgePreset: 'Gotowy zestaw',
      bottomBadgeShape: 'Kształt',
      bottomBadgeSize: 'Wysokość',
      bottomBadgeAction: 'Akcja',
      bottomBadgeBgColor: 'Kolor tła',
      bottomBadgeTextColor: 'Kolor tekstu',
      bottomBadgeGradientFrom: 'Gradient od',
      bottomBadgeGradientTo: 'Gradient do',
      bottomBadgeGradientAngle: 'Kąt gradientu',
    },
  },
  billingHistory: {
    title: 'Historia rozliczeń',
    invoices: 'Faktury',
    messageText: 'Nie masz jeszcze historii płatności.',
  },
  migrate: {
    title: 'Masz LinkTree lub Taplink?',
    text: 'Wklej link i przenieś się do UniLink w jednym kliknięciu!',
    button: 'Migruj',
  },
  pages: {
    title: 'Podstrony',
    addPage: 'Dodaj podstronę',
    addNewPage: 'Dodaj nową podstronę',
    deleteTitle: 'Czy na pewno chcesz usunąć tę podstronę?',
    managePage: 'Zarządzaj zakładkami',
    empty: 'Ta podstrona nie ma jeszcze żadnego bloku.',
    dragAndDrop: 'Przeciągnij i upuść inne zakładki, aby zmienić ich kolejność',
    pageNavigation: 'Ustawienia nawigacji podstrony',
    goToDesign: 'Przejdź do ustawień designu',
    viewArchive: 'Zobacz archiwum',
    archivedBlocks: 'Zarchiwizowane bloki',
    noArchivedBlocks: 'Utrzymuj porządek na stronie, archiwizując bloki, których obecnie nie używasz.',
    archiveAllUnpublished: 'Zarchiwizuj wszystkie nieopublikowane bloki',
    restore: 'Przywróć',
    permanentDelete: 'Usuń trwale',
  },
  analytics: {
    lifeTimeAnalytics: 'Analityka od początku',
    impressions: 'Wyświetlenia',
    impressionsText: 'Wyniki wyświetleń dla wybranego okresu',
    clicks: 'Kliknięcia',
    clicksText: 'Wyniki zdarzeń „kliknięcie” dla wybranego okresu',
    signUps: 'Rejestracje',
    signUpsText: 'Wyniki zdarzeń „zamknięcie” dla wybranego okresu',
    totalInteractions: 'Łączne interakcje',
    totalInteractionsText: 'Łączna liczba kliknięć i rejestracji formularzy dla wybranego okresu',
    engagementRate: 'Wskaźnik zaangażowania',
    engagementRateText: 'Udział wyświetleń profilu, które doprowadziły do interakcji',
    visitor: 'Źródła odwiedzających',
    country: 'Kraj',
    countries: 'Kraje',
    linkClicks: 'Kliknięcia linków',
    content: 'Treść',
    views: 'Wyświetlenia',
    links: 'Linki',
    products: 'Produkty',
    blocks: 'Bloki',
    pages: 'Podstrony',
    clicksLower: 'kliknięcia',
    of: 'z',
    noContentData: 'Brak jeszcze danych dla wybranego okresu',
  },
  aiInsights: {
    title: 'Analizy AI',
    generate: 'Przeanalizuj mój profil',
    description: 'Uzyskaj rekomendacje oparte na AI, aby poprawić wyniki swojego profilu.',
    analyzing: 'Analizowanie Twojego profilu...',
    refresh: 'Odśwież',
    action: 'Akcja',
  },
  post: {
    subscriptionTypePlaceholder: `Dostępne dla subskrypcji 'type' i wyższych`,
    postButtonText: 'Opublikuj',
    newPostPlaceholder: 'Co masz na myśli',
    free: 'Darmowy',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'Nie masz jeszcze postów',
    editPost: 'Edytuj post',
  },
  preview: {
    buy: 'Kup',
    connect: 'Połącz',
  },
  activeButton: {
    initialText: 'Strona',
    inputPlaceholder: 'Szukaj akcji...',
    existing: 'Istniejący',
    redirect: 'Przekierowanie',
    scroll: 'Przewiń',
    title: 'Aktywny przycisk',
    modalTitle: 'Akcja aktywnego przycisku',
    subtitle: 'Przycisk motywujący użytkownika do podjęcia działania',
    next: 'Dalej',
    save: 'Zapisz',
    opensALinkFromLinksBlock: 'Otwiera link z bloku Linki',
    url: 'URL',
    opensAWebsite: 'Otwiera stronę',
    openInApp: 'Otwórz w aplikacji',
    addAction: 'Dodaj akcję',
    actionTitle: 'Akcja',
    actionCaption: 'Edytuj typ akcji',
    chooseOption: 'Wybierz opcję',
    tellPeople: 'Powiedz ludziom, jak korzystać z przycisku akcji',
    urlRedirect: 'Przekierowanie URL',
    customUrl: 'Własny URL',
    customUrlText: 'Otwiera stronę',
    links: 'Linki',
    linksText: 'Otwiera link z bloku Linki',
    downloadDocument: 'Pobierz dokument',
    sendEmail: 'Wyślij e-mail',
    opensEmailClient: 'Otwiera klienta e-mail',
    phoneCall: 'Połączenie telefoniczne',
    initiatesPhoneCall: 'Inicjuje połączenie telefoniczne',
    navigation: 'Nawigacja',
    openPage: 'Otwórz podstronę',
    opensInternalPage: 'Otwiera wewnętrzną podstronę',
    openPageText: 'Otwiera wewnętrzną podstronę',
    openProduct: 'Otwórz produkt',
    openProductText: 'Otwiera stronę produktu ze sklepu',
    openBlog: 'Otwórz blog',
    opensBlogPageFromStore: 'Otwiera podstronę bloga ze sklepu',
    openBlock: 'Otwórz blok',
    opensContentBlock: 'Otwiera blok treści',
    openItem: 'Otwórz element',
    opensItemPageFromStore: 'Otwiera stronę elementu ze sklepu',
    showNewModal: 'Pokaż nowe okno modalne',
    displayContentInModalWindow: 'Wyświetla treść w oknie modalnym',
    showProduct: 'Pokaż produkt',
    displayProductInModalWindow: 'Wyświetla produkt w oknie modalnym',
    showBlog: 'Pokaż blog',
    scrollToBlock: 'Przewiń do bloku',
    scrollToBlockText: 'Przewiń do wskazanego bloku podstrony',
    scrollToItem: 'Przewiń do elementu',
    action: 'Akcja',
    showBlock: 'Pokaż blok',
    showBlockText: 'Blok treści ze sklepu',
    showItem: 'Pokaż element',
    showItemText: 'Otwiera stronę elementu ze sklepu',
    linksCaption: 'Linki',
    linksTooltip: 'Wybierz link z bloku linków',
    pagesCaption: 'Podstrony',
    pagesTooltip: 'Wybierz podstronę z listy podstron',
    productsCaption: 'Produkty',
    productsTooltip: 'Wybierz produkt z listy',
    blocksCaption: 'Bloki',
    blocksTooltip: 'Wybierz blok z listy',
    itemsCaption: 'Elementy',
    itemsTooltip: 'Wybierz element z listy',
    showProductText: 'Wyświetl produkt w oknie modalnym na podstronie',
    more: 'Pokaż więcej',
    less: 'Pokaż mniej',
    showNewModalTitle: 'Dane nowego okna modalnego',
    uploadDocumentTitle: 'Kliknij, aby przesłać, lub przeciągnij i upuść',
    uploadProgressTitle: 'Przesyłanie...',
    haveNoModal: 'Nie masz okna modalnego',
    haveModal: 'Wybrałeś okno modalne',
    openNewModalHandler: 'Utwórz nowe okno modalne',
    linkGroupSubTitle: 'Wybierz blok',
    linkItemSubTitle: 'Wybierz link',
    urlItemSubTitle: 'URL strony',
    openInAppItemSubTitle: 'URL aplikacji',
    sendEmailItemSubTitle: 'Adres e-mail',
    phoneCallItemSubTitle: 'Numer telefonu',
    openPageGroupSubTitle: 'Wybierz podstronę',
    openPageItemSubTitle: 'Wybierz podstronę',
    openProductGroupSubTitle: 'Wybierz typ produktu',
    openProductItemSubTitle: 'Wybierz produkt',
    openBlogGroupSubTitle: 'Wybierz kanał bloga',
    openBlogItemSubTitle: 'Wybierz artykuł na blogu',
    openBlockGroupSubTitle: 'Wybierz podstronę',
    openBlockItemSubTitle: 'Wybierz blok',
    openItemGroupSubTitle: 'Wybierz blok',
    openItemItemSubTitle: 'Wybierz element',
    showProductGroupSubTitle: 'Wybierz typ produktu',
    showProductItemSubTitle: 'Wybierz produkt',
    showBlogGroupSubTitle: 'Wybierz kanał bloga',
    showBlogItemSubTitle: 'Wybierz artykuł na blogu',
    showBlockGroupSubTitle: 'Wybierz podstronę',
    showBlockItemSubTitle: 'Wybierz blok',
    showItemGroupSubTitle: 'Wybierz blok',
    showItemItemSubTitle: 'Wybierz element',
    scrollToBlockGroupSubTitle: 'Wybierz podstronę',
    scrollToBlockItemSubTitle: 'Wybierz blok',
    scrollToItemGroupSubTitle: 'Wybierz blok',
    scrollToItemItemSubTitle: 'Wybierz element',
    linkGroupPlaceholder: 'Wybierz blok...',
    linkItemPlaceholder: 'Wybierz link...',
    openPageItemPlaceholder: 'Wybierz podstronę...',
    openProductGroupPlaceholder: 'Wybierz typ produktu...',
    openProductItemPlaceholder: 'Wybierz produkt...',
    showProductGroupPlaceholder: 'Wybierz grupę produktów...',
    showProductItemPlaceholder: 'Wybierz produkt...',
    openBlogGroupPlaceholder: 'Wybierz kanał bloga...',
    openBlogItemPlaceholder: 'Wybierz artykuł na blogu...',
    openBlockGroupPlaceholder: 'Wybierz podstronę...',
    openBlockItemPlaceholder: 'Wybierz blok...',
    openItemGroupPlaceholder: 'Wybierz podstronę i blok...',
    openItemItemPlaceholder: 'Wybierz element...',
    showBlogGroupPlaceholder: 'Wybierz grupę bloga...',
    showBlogItemPlaceholder: 'Wybierz post na blogu...',
    showBlockGroupPlaceholder: 'Wybierz podstronę...',
    showBlockItemPlaceholder: 'Wybierz blok...',
    showItemGroupPlaceholder: 'Wybierz podstronę i blok...',
    showItemItemPlaceholder: 'Wybierz element...',
    scrollToBlockGroupPlaceholder: 'Wybierz podstronę...',
    scrollToBlockItemPlaceholder: 'Wybierz blok...',
    scrollToItemGroupPlaceholder: 'Wybierz podstronę i blok...',
    scrollToItemItemPlaceholder: 'Wybierz element...',
    linkReadable: 'Link',
    urlReadable: 'Url',
    openInAppReadable: 'Otwórz w aplikacji',
    downloadDocumentReadable: 'Pobierz dokument',
    sendEmailReadable: 'Wyślij e-mail',
    phoneCallReadable: 'Połączenie telefoniczne',
    openPageReadable: 'Otwórz podstronę',
    openProductReadable: 'Otwórz produkt',
    showNewModalReadable: 'Pokaż nowe okno modalne',
    showProductReadable: 'Pokaż produkt',
    openBlogReadable: 'Otwórz blog',
    openBlockReadable: 'Otwórz blok',
    openItemReadable: 'Otwórz element',
    showBlogReadable: 'Pokaż blog',
    showBlockReadable: 'Pokaż blok',
    showItemReadable: 'Pokaż element',
    scrollToBlockReadable: 'Przewiń do bloku',
    scrollToItemReadable: 'Przewiń do elementu',
  },
  design: {
    tabs: 'Zakładki',
    imageView: 'Widok obrazu',
    preview: 'Podgląd',
    buttonOpacity: 'Przezroczystość przycisku',
    buttonBorder: 'Obramowanie przycisku',
    buttonShadow: 'Cień przycisku',
    itemView: 'Widok elementu',
    itemViewTooltip: 'Wybierz widok elementu',
    itemLayout: 'Układ elementu',
    itemLayoutTooltip: 'Wybierz układ elementu',
    top: 'Góra',
    center: 'Środek',
    bottom: 'Dół',
    bottomLeft: 'Dół lewo',
    bottomHorizontal: 'Dół poziomo',
    under: 'Pod',
    title: 'Tytuł',
    titleButton: 'Tytuł i przycisk',
    displayOptions: 'Opcje wyświetlania',
    displayOptionsTooltip: 'Wybierz opcje wyświetlania',
    landscape: 'Poziomo',
    square: 'Kwadrat',
    portrait: 'Pionowo',
    desktopMode: 'Tryb komputerowy',
    mobile: 'Kompaktowy',
    desktop: 'Szeroki',
    responsive: 'Responsywny',
    custom: 'Własny',
    templates: 'Szablony',
    chooseTemplates: 'Wybierz swoje szablony',
    viewAll: 'Zobacz wszystkie',
    previousTheme: 'Pamiętaj, że poprzedni motyw zostanie trwale usunięty.',
    useThisTemplate: 'Użyj tego szablonu',
    notSupportedVideo: 'Twoja przeglądarka nie obsługuje znacznika wideo.',
    photosBy: 'Zdjęcia od',
    animationBy: 'Animacja od',
    searchTheSame: 'Wyszukaj ponownie tę samą frazę, aby uzyskać inne wyniki.',
    addImage: 'Dodaj obraz',
    addVideo: 'Dodaj wideo',
    orSelectFrom: 'lub wybierz z',
    noImagesYet: 'Brak obrazów',
    noVideosYet: 'Brak wideo',
    videoBy: 'Wideo od',
    hamburgerMenu: 'Menu hamburger',
    tabsOnTop: 'Zakładki na górze',
    tabsOnBottom: 'Zakładki na dole',
    borderType: 'Typ obramowania',
    subTitle: 'Wybierz kształt, typ obramowania, cień itp.',
    icon: 'Ikona',
    iconTooltip: 'Wybierz odpowiednią ikonę dla przycisku',
    background: 'Tło',
    color: 'Kolor',
    backgroundOpacity: 'Przezroczystość tła',
    backgroundOpacityTooltip: 'Przeciągnij suwak, aby ustawić przezroczystość tła',
    gradient: 'Gradient',
    color1: 'Kolor 1',
    color2: 'Kolor 2',
    direction: 'Kierunek',
    directionTooltip: 'Przeciągnij suwak, aby ustawić kierunek gradientu',
    offset: 'Przesunięcie',
    offsetTooltip: 'Przeciągnij suwak, aby ustawić przesunięcie gradientu',
    minHeight: 'Minimalna wysokość',
    minHeightTooltip: 'Przeciągnij suwak, aby zmienić minimalną wysokość przycisku',
    align: 'Wyrównanie',
    alignTooltip: 'Zmień pozycję przycisku',
    insert: 'Wstaw URL',
    upload: 'Prześlij wideo',
    search: 'Szukaj wideo',
    layout: 'Układ',
    layoutTooltip: 'Wybierz żądany układ',
    view: 'Widok',
    viewTooltip: 'Wybierz żądany widok',
    media: 'Media',
    mediaTooltip: 'Wybierz żądane media',
    none: 'Brak',
    small: 'Mały',
    medium: 'Średni',
    large: 'Duży',
    round: 'Okrągły',
    feed: 'Kanał',
    slider: 'Slider',
    text: 'Tekst',
    colorTooltip: 'Wybierz kolory',
    button: 'Przycisk',
    buttonTooltip: 'Wybierz kolory przycisku',
    chooseEmoji: 'Wybierz emoji',
    changeEmoji: 'Zmień swoje emoji',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Dodaj link',
      addVideo: 'Dodaj wideo',
      addProduct: 'Dodaj produkt',
      addPost: 'Dodaj post',
      addArticle: 'Dodaj artykuł',
      addPhoto: 'Dodaj zdjęcie',
      addMusic: 'Dodaj muzykę',
      addFiles: 'Dodaj pliki',
      addStory: 'Dodaj Story',
    },
    emoji: {
      search: 'Szukaj',
      clear: 'Wyczyść',
      notfound: 'Nie znaleziono emoji',
      skintext: 'Wybierz domyślny odcień skóry',
      categories: {
        search: 'Wyniki wyszukiwania',
        recent: 'Często używane',
        smileys: 'Uśmiechy i emocje',
        people: 'Ludzie i ciało',
        nature: 'Zwierzęta i natura',
        foods: 'Jedzenie i napoje',
        activity: 'Aktywność',
        places: 'Podróże i miejsca',
        objects: 'Przedmioty',
        symbols: 'Symbole',
        flags: 'Flagi',
        custom: 'Własne',
      },
      categorieslabel: 'Kategorie emoji',
      skintones: {
        1: 'Domyślny odcień skóry',
        2: 'Jasny odcień skóry',
        3: 'Średnio-jasny odcień skóry',
        4: 'Średni odcień skóry',
        5: 'Średnio-ciemny odcień skóry',
        6: 'Ciemny odcień skóry',
      },
    },
    blogPreviewModal: {
      title: 'Podgląd bloga',
      notify: 'Powiadom subskrybentów',
    },
    standAloneModal: {
      title: 'Podgląd linku',
      save: 'Zapisz',
      chooseLayout: 'Wybierz układ dla swojego linku',
      linkSettings: 'Ustawienia linku',
      linkSettingsSubtitle: 'Przekierowanie, wygląd',
      whenVisitorsClicks: 'Gdy odwiedzający kliknie ten link:',
      redirect: 'Przekierowanie',
      redirectText: 'Wyślij odwiedzających bezpośrednio na URL',
      highlight: 'Wyróżnienie',
      highlightText: 'Wyślij odwiedzających na Twój UniLink i wyróżnij',
      standalone: 'Samodzielny',
      standaloneText: 'Wyróżnij swój link YouTube i odtwórz treść bezpośrednio na',
      cover: 'Okładka',
      imageTab: 'Obraz',
      videoTab: 'Wideo',
      uploadImage: 'Prześlij obraz',
      whenVisitors: 'Gdy odwiedzający wybierze udostępniony link:',
      compact: 'Widok kompaktowy',
      fullView: 'Pełny widok',
      videoSound: 'Odtwarzaj wideo z dźwiękiem',
    },
    instagramModal: {
      title: 'Wyślij automatyczne DM na Instagramie',
      subtitle: 'Wyślij ten link jako wiadomość bezpośrednią, gdy ktoś skomentuje Twój post lub Reel na IG',
      promo: 'Wybierz, z którego konta IG chcesz wysyłać',
      connect: 'Połącz konto Instagram',
      added: 'Konto Instagram dodane',
      addNew: 'Dodaj nową automatyzację',
      igContent: 'Treść IG',
      trigger: 'Wyzwalacz',
      dmContent: 'DM',
      linkDestination: 'Cel linku',
      buttonTitle: 'Tytuł przycisku',
      buttonTitleTooltip: 'Wpisz tytuł przycisku',
      directMessage: 'Wiadomość bezpośrednia',
      directMessageTooltip: 'Wpisz wiadomość bezpośrednią',
      selectPosts: 'Wybierz post lub Reel, który wyzwoli automatyczne DM.',
      onePost: 'Jeden konkretny post lub Reel',
      allPosts: 'Wszystkie posty lub Reels',
      triggerText: 'Gdy komentarze zawierają to, Twoje DM zostanie wysłane.',
      addMessage: 'Dodaj wiadomość do automatycznego wysyłania z linkiem.',
      clickLink: 'Gdy ktoś kliknie link w Twoim DM:',
      anyComment: 'Dowolny komentarz',
      storiesAndDms: 'Stories i DM',
      anyMessage: 'Dowolna wiadomość',
      specificKeywords: 'Komentarze z konkretnymi słowami kluczowymi',
      sendLink: 'Wyślij ich na Twój UniLink i wyróżnij ',
      skipLink: 'Pomiń UniLink i wyślij ich bezpośrednio',
      keywordsTitle: 'Komentarze z konkretnymi słowami kluczowymi',
      keywordsText: 'Twoje DM zostaną wysłane, gdy komentarze zawierają lub wykluczają\nokreślone słowa kluczowe (bez rozróżniania wielkości liter):',
      keywordsPlaceholder: 'Wpisz słowo kluczowe',
      keywordsExclude: 'Wyklucz słowa kluczowe',
      keywordsExcludeText: 'Musi wykluczać którekolwiek z tych',
      replyComment: 'Odpowiedz na komentarz',
      replyCommentTooltip: 'Wpisz odpowiedź na komentarz',
    },
    blockEditProduct: {
      productPreview: 'Miniatura',
      productDetails: 'Szczegóły',
      settings: 'Ustawienia',
      design: 'Design',
    },
    editMenuItems: {
      overview: 'Przegląd',
      analytics: 'Analityka',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Wpisz token swojego bota',
      connect: 'Połącz',
      token: 'Token',
    },
    rewards: {
      title: 'Tytuł',
      titleTooltip: 'Wpisz tytuł odpowiedzi',
      text: 'Tekst',
      textTooltip: 'Wpisz tekst odpowiedzi',
      link: 'Link',
      linkTooltip: 'Wpisz link odpowiedzi',
      code: 'Kod',
      codeTooltip: 'Wpisz kod odpowiedzi',
      files: 'Pliki',
      filesTooltip: 'Wpisz pliki odpowiedzi',
      removeReward: 'Czy na pewno chcesz usunąć tę odpowiedź?',
    },
    addRewardModal: {
      addReward: 'Dodaj odpowiedź',
      textTitle: 'Tekst',
      textText: 'Daj dostęp do instrukcji lub dowolnego tekstu za pomocą edytora Rich Editor',
      fileTitle: 'Pliki',
      fileText: 'Daj dostęp do plików i zbieraj dane kontaktowe',
      linkTitle: 'Link',
      linkText: 'Daj dostęp do ekskluzywnych treści i zbieraj dane kontaktowe',
      codeTitle: 'Kod',
      codeText: 'Daj dostęp do ekskluzywnych promocji i zbieraj dane kontaktowe',
    },
    blockEmpty: {
      isNotAdded: 'nie jest dodany',
      itSeems: 'Wygląda na to, że Twój',
      itemsNot: 'elementy nie zostały jeszcze dodane. Dodaj swoje wideo teraz',
      add: 'Dodaj',
    },
    blockList: {
      add: 'Dodaj',
      item: 'element',
    },
    submitAction: {
      action: 'Akcja (po wysłaniu)',
      actionTooltip: 'Wybierz akcję po wysłaniu',
      upload: 'Prześlij załączniki',
      none: 'Brak',
      page: 'Pokaż stronę potwierdzenia',
      email: 'Wyślij e-mail z potwierdzeniem',
      redirect: 'Przekieruj na URL',
    },
    blockEditItem: {
      content: 'Treść',
      preview: 'Podgląd',
      settings: 'Ustawienia',
    },
    domainButton: {
      customizeDomain: 'Dostosuj swoją domenę.',
      upgradeToLink: 'Ulepsz do Link in Bio Pro i użyj własnej domeny.',
    },
    coverText: {
      text: 'Tekst',
      textTooltip: 'Wpisz tekst do swojej okładki',
      description: 'Opis',
      descriptionTooltip: 'Wpisz opis do swojej okładki',
      textColor: 'Kolor tekstu',
    },
    itemModal: {
      edit: 'Edytuj',
      addNew: 'Dodaj nowy',
      item: 'element',
      update: 'Aktualizuj',
      add: 'Dodaj',
    },
    viewDesign: {
      compact: 'Kompaktowy',
      card: 'Karta',
      button: 'Przycisk',
      list: 'Lista',
      hero: 'Hero',
      featured: 'Wyróżnione',
    },
    moveItemModal: {
      title: 'Przenieś element na inną podstronę',
      cancel: 'Anuluj',
      move: 'Przenieś',
      page: 'Podstrona',
      pageTooltip: 'Wybierz podstronę do przeniesienia elementu',
      blocks: 'Bloki',
      blocksTooltip: 'Wybierz blok do przeniesienia elementu',
      emptyBlocks: 'Na tej podstronie nie ma wymaganych bloków.',
    },
    limitModal: {
      title: 'Osiągnięto limit',
      text1: 'Osiągnąłeś limit swojej strony.',
      text2: 'Skontaktuj się z nami, aby ulepszyć plan.',
      close: 'Zamknij',
    },
    cropPicture: {
      title: 'Przytnij swój obraz',
      cancel: 'Anuluj',
      save: 'Zapisz',
    },
    uploadFile: {
      uploadProductImage: 'Prześlij obraz produktu',
      coverImage: 'Obraz okładki',
      uploadImages: 'Tutaj możesz przesyłać tylko obrazy',
    },
    userMediaLibrary: {
      addImage: 'Dodaj obraz',
      uploadImage: 'Prześlij obraz',
      orSelectFrom: 'lub prześlij',
      orSelectLink: 'lub wklej link',
      myMedia: 'Moje media',
      stockImages: 'Obrazy stockowe',
      gifs: 'GIF-y',
      icons: 'Ikony',
      noImagesYet: 'Brak obrazów',
      loadMore: 'Załaduj więcej',
    },
    itemMenu: {
      active: 'Aktywny',
      willBeAvailable: 'Element będzie dostępny pod adresem:',
      save: 'Zapisz',
      copied: 'Skopiowano',
      copyLink: 'Kopiuj link',
      delete: 'Usuń',
    },
    itemDesign: {
      linkColor: 'Kolor linku',
      gradient: 'Gradient',
      background: 'Tło',
      backgroundOpacity: 'Przezroczystość tła',
      backgroundOpacityTooltip: 'Przeciągnij suwak, aby ustawić przezroczystość tła',
      backgroundDarkness: 'Przyciemnienie tła',
      backgroundDarknessTooltip: 'Przeciągnij suwak, aby ustawić przyciemnienie tła',
      text: 'Tekst',
      color1: 'Kolor 1',
      color2: 'Kolor 2',
      direction: 'Kierunek',
      directionTooltip: 'Przeciągnij suwak, aby ustawić kierunek gradientu',
      offset: 'Przesunięcie',
      offsetTooltip: 'Przeciągnij suwak, aby ustawić przesunięcie gradientu',
      linkHeight: 'Wysokość linku',
      linkHeightTooltip: 'Przeciągnij suwak, aby zmienić wysokość przycisku',
      icon: 'Ikona',
      iconTooltip: 'Wybierz ikonę dla przycisku',
      imageShape: 'Kształt obrazu',
      imageShapeTooltip: 'Wybierz kształt obrazu dla linku',
    },
    menu: {
      linkInBio: 'Link in bio',
      linkInBioApps: 'Link in Bio',
      posts: 'Posty',
      audience: 'Odbiorcy',
      orders: 'Zamówienia',
      marketing: 'Marketing',
      emailMarketing: 'E-mail marketing',
      socialPlanner: 'Planer social media',
      shortLinks: 'Krótkie linki',
      businessCards: 'Wizytówki',
      emailSignatures: 'Podpisy e-mail',
      virtualBackgrounds: 'Wirtualne tła',
      recentProfiles: 'Ostatnie profile',
      standalonePage: 'Strona samodzielna',
      soloApps: 'App in Bio',
      bots: 'Boty',
      smartReply: 'Odpowiedzi na Instagramie',
      analytics: 'Analityka',
      settings: 'Ustawienia',
      shop: 'Zarabiaj',
      publish: 'Publikuj',
      studio: 'Studio',
      blog: 'Blog',
      qrCodes: 'Kody QR',
      singlePages: 'Aplikacje',
      forms: 'Formularze',
      form: 'Formularze',
      automations: 'Automatyzacje',
      community: 'Społeczność',
      messages: 'Skrzynka',
      agents: 'Agenci',
      apps: 'Aplikacje',
    },
    notificationsBlockSetting: {
      title: 'Powiadomienia',
      setUp: 'Skonfiguruj',
      notifications: 'powiadomienia',
      connect: 'Połącz',
      telegramText: 'Otrzymuj powiadomienie na Telegramie, gdy ktoś dokona',
      change: 'zmiany',
      email: 'E-mail',
      emailText: 'Otrzymuj e-mail, gdy ktoś dokona',
      webhook: 'Webhook',
      webhookTooltip: 'Dodaj webhook',
      activate: 'Aktywuj',
      webhookText: 'Wyślij zdarzenie do zewnętrznej strony, gdy ktoś dokona',
      webhookURL: 'URL webhooka (żądanie POST)',
      error: 'Wpisz poprawny link',
      save: 'Zapisz',
    },
    navigation: {
      content: 'Treść',
      pages: 'Podstrony',
      posts: 'Posty',
      shop: 'Sklep',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Analityka',
      settings: 'Ustawienia',
      apps: 'Aplikacje',
      store: 'Sklep',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Analityka',
      settings: 'Ustawienia',
      editTabs: 'Edytuj zakładki',
    },
    unlockModal: {
      title: 'Odblokuj funkcje Pro',
      text: 'Uzyskaj więcej ze swojego link-in-bio. Tylko 5 USD/miesiąc — odblokuj wszystko, co oferuje Pro:',
      checkBoxTitle1: 'Więcej bloków:',
      checkBoxText1: 'Dodaj formularze, sklepy, odliczania i odtwarzacze multimediów',
      checkBoxTitle2: 'Zaawansowana analityka:',
      checkBoxText2: 'Śledź kliknięcia, wyświetlenia i statystyki odbiorców',
      checkBoxTitle3: 'Własna domena:',
      checkBoxText3: 'Użyj własnej domeny dla profesjonalnego wyglądu',
      checkBoxTitle4: 'Wbudowany sklep:',
      checkBoxText4: 'Sprzedawaj produkty i zarządzaj zamówieniami z łatwością',
      checkBoxTitle5: 'Narzędzia SEO:',
      checkBoxText5: 'Wypozycjonuj się wyżej dzięki tagom meta, UTM i własnym slugom',
      checkBoxTitle6: 'Integracje:',
      checkBoxText6: 'Synchronizuj z Mailchimp, Zapier i innymi narzędziami',
      checkBoxTitle7: 'E-mail marketing:',
      checkBoxText7: 'Zbieraj leady i wysyłaj automatyczne kampanie',
      checkBoxTitle8: 'Priorytetowe wsparcie:',
      checkBoxText8: 'Uzyskaj szybszą pomoc, kiedy jej potrzebujesz',
      upgradeToPro: 'Ulepsz do Pro',
      viewAllPlans: 'Zobacz wszystkie plany',
    },
    profileSwitcher: {
      title: 'Wszystkie profile',
      button: 'Dodaj nowy profil',
    },
    account: {
      signOut: 'Wyloguj się',
      createNew: 'Utwórz nowy Link in Bio',
      tryPro: 'Wypróbuj Pro teraz!',
      tryProText: 'Uzyskaj zaawansowaną personalizację i głębsze statystyki odbiorców, aby zdobyć więcej odwiedzających!',
    },
    accountSettings: {
      title: 'Ustawienia konta',
    },
    billingHistory: {
      title: 'Historia rozliczeń',
    },
    pages: {
      home: 'Strona główna',
      newPage: 'Nowa podstrona',
      managePages: 'Zarządzaj podstronami',
    },
    blockItem: {
      actionRequired: 'wymagane działanie',
      hidden: 'Ukryty · nikt tego nie widzi',
    },
    blockContent: {
      untitled: 'Bez tytułu',
      clickToRename: 'Kliknij, aby zmienić podtytuł',
      saving: 'zapisywanie',
      saved: 'zapisano',
      deleteTitle: 'Czy na pewno chcesz usunąć ten blok?',
      cancel: 'Anuluj',
      yes: 'Tak',
    },
    addButtonModal: {
      title: 'Dodaj przycisk akcji',
      close: 'Zamknij',
      added: 'Dodano',
      add: 'Dodaj',
      messageTitle: 'Wiadomość',
      messageText: 'Przycisk wiadomości pozwala użytkownikom skontaktować się z Tobą przez komunikator',
      subscribeTitle: 'Subskrybuj',
      subscribeText: 'Przycisk subskrypcji pozwala użytkownikom zapisać się na listę e-mail lub komunikator',
      ctaTitle: 'Przycisk CTA',
      ctaText: 'CTA to wezwanie na stronie, które nakłania użytkownika do podjęcia określonego działania',
      cartTitle: 'Koszyk',
      cartText: 'Wyświetl ikonę koszyka, aby wskazać, że odwiedzający mogą dokonywać zakupów na Twojej stronie',
      contactTitle: 'Kontakt',
      contactText: 'Umożliw odwiedzającym szybki dostęp do Twoich danych kontaktowych',
      qrcodeTitle: 'Kod QR',
      qrcodeText: 'Wyświetl kod QR, aby odwiedzający mogli szybko zeskanować i udostępnić Twoją stronę',
      languageTitle: 'Język',
      languageText: 'Pozwól odwiedzającym zmienić język Twojej strony',
      searchTitle: 'Szukaj',
      searchText: 'Pozwól odwiedzającym wyszukiwać produkty sklepu bezpośrednio z nagłówka',
    },
    inputMask: {
      copyLink: 'Kopiuj link',
    },
    videoLibrary: {
      addVideo: 'Dodaj wideo',
      myVideos: 'Moje wideo',
      stockVideos: 'Wideo stockowe',
      pasteUrl: 'Wklej URL',
      uploadVideo: 'Prześlij wideo',
    },
    createBlockModal: {
      searchTitle: 'Wybierz blok do dodania do swojej podstrony',
      title: 'Dodaj do UniLink',
      contentTitle: 'Treść',
      contentText: 'Twórz i zarządzaj swoją podstroną',
      growTitle: 'Leady',
      growText: 'Zbieraj leady i zwiększaj zaangażowanie',
      monetizeTitle: 'Zarabiaj',
      monetizeText: 'Sprzedawaj produkty, treści i usługi',
      monetizationTitle: 'Zarabiaj i zbieraj pieniądze',
      monetizationText: 'Sprzedawaj produkty, usługi i zbieraj napiwki',
      socialTitle: 'Treści z mediów społecznościowych',
      socialText: 'Udostępniaj treści z mediów społecznościowych na swoim UniLink',
      toolsTitle: 'Narzędzia rozwoju',
      toolsText: 'Rozwijaj, zarządzaj i łącz się ze swoimi odbiorcami',
      search: 'Szukaj',
      all: 'Wszystkie',
      allCategories: 'Wszystkie kategorie',
      content: 'Treść',
      monetization: 'Monetyzacja',
      social: 'Społecznościowe',
      tools: 'Narzędzia',
      header: 'Nagłówek',
      headerText: 'Dodaj zdjęcie profilowe i bio',
      link: 'Linki',
      linkText: 'Wybierz układ linku',
      text: 'Tekst',
      textText: 'Wybierz układ tekstu',
      videos: 'Wideo',
      videosText: 'Wybierz typ wideo',
      image: 'Obraz',
      imageText: 'Dodaj bloki obrazów',
      music: 'Muzyka',
      musicText: 'Wybierz typ muzyki',
      socialFeeds: 'Kanały społecznościowe',
      socialFeedsText: 'Wybierz typ kanału społecznościowego',
      moreContent: 'Więcej',
      moreContentText: 'Dodaj więcej bloków treści',
      dataCollect: 'Zbieranie danych',
      dataCollectText: 'Wybierz typ zbierania danych',
      form: 'Formularz',
      formText: 'Wybierz typ formularza',
      conversionTools: 'Narzędzia zaangażowania',
      conversionToolsText: 'Dodaj bloki konwersji',
      products: 'Produkty',
      productsText: 'Dodaj bloki produktów',
      donation: 'Napiwki i darowizny',
      tipsAndDonations: 'Napiwki i darowizny',
      tipsDonationsText: 'Bloki napiwków i darowizn',
      event: 'Wydarzenie',
      eventText: 'Wybierz typ wydarzenia',
      quickAdd: 'Wszystkie bloki',
      quickAddText: 'Dodaj dowolny blok',
    },
    addBlockModal: {
      title: 'Dodaj do UniLink',
      dragToAdd: 'Przeciągnij, aby dodać',
      contentTitle: 'Udostępnij podstawową treść',
      contentText: 'Udostępnij treść bezpośrednio na swoim UniLink',
      monetizationTitle: 'Zarabiaj i zbieraj pieniądze',
      monetizationText: 'Sprzedawaj produkty, usługi i zbieraj napiwki',
      socialTitle: 'Treści z mediów społecznościowych',
      socialText: 'Udostępniaj treści z mediów społecznościowych na swoim UniLink',
      toolsTitle: 'Narzędzia rozwoju',
      toolsText: 'Rozwijaj, zarządzaj i łącz się ze swoimi odbiorcami',
      search: 'Szukaj',
      searchPlaceholder: 'Szukaj treści...',
      all: 'Wszystkie',
      allCategories: 'Wszystkie kategorie',
      content: 'Treść',
      monetization: 'Monetyzacja',
      social: 'Społecznościowe',
      tools: 'Narzędzia',
      suggestTitle: 'Zaproponuj swój blok',
      suggestText: 'Brakuje bloku? Powiedz nam, co chciałbyś zobaczyć',
      suggestModalTitle: 'Zaproponuj blok',
      suggestModalSubtitle: 'Opisz blok, jaki chciałbyś, aby miał UniLink. Czytamy każdy pomysł.',
      suggestPlaceholder: 'np. Blok rezerwacji z synchronizacją Google Calendar...',
      suggestSubmit: 'Wyślij propozycję',
      suggestSending: 'Wysyłanie...',
      suggestSuccessTitle: 'Propozycja wysłana!',
      suggestSuccess: 'Dziękujemy! Czytamy każdy pomysł i wykorzystujemy je do kształtowania planu rozwoju.',
      suggestError: 'Nie udało się wysłać. Spróbuj ponownie.',
    },
    tabNavigation: {
      tabView: 'Widok zakładek',
      tabViewTooltip: 'Wybierz widok zakładek dla nawigacji',
      colors: 'Kolory',
      colorsTooltip: 'Wybierz kolory postów i przycisków',
      tabs: 'Zakładki',
      tabsTooltip: 'Wybierz zakładki wyświetlane w nawigacji strony',
      content: 'Treść',
      posts: 'Posty',
      store: 'Sklep',
      shop: 'Sklep',
      tabsSettings: 'Ustawienia nawigacji zakładek',
    },
    hideLogo: {
      text: 'Pokaż logo UniLink w stopce swojej strony.',
      text2: 'Pokaż logo UniLink w stopce swojej strony.',
    },
    palettePreview: {
      custom: 'Własny kolor tła',
      hexColor: 'Kolor hex',
      hexColorTooltip: 'Wpisz kolor hex swojego podglądu',
    },
    backgroundVideo: {
      insert: 'Wstaw URL',
      upload: 'Prześlij wideo',
      search: 'Szukaj wideo',
    },
    periodDropdown: {
      today: 'Dzisiaj',
      yesterday: 'Wczoraj',
      last7days: 'Ostatnie 7 dni',
      last30days: 'Ostatnie 30 dni',
      allTime: 'Cały czas',
      custom: 'Własny',
    },
    subsections: {
      content: 'Treść',
      design: 'Design',
      settings: 'Ustawienia',
    },
    wrapperSettings: {
      lock: 'Ulepsz do planu PRO',
    },
    shareModal: {
      addSocials: 'Dodaj do social media',
      shareTo: 'Udostępnij do',
      qrCode: 'Kod QR',
      customizeUrl: 'Dostosuj URL',
      goToMy: 'Przejdź do mojego',
      print: 'Możesz wydrukować swój unikalny kod QR na',
      cards: 'wizytówkach i ulotkach',
      download: 'Pobierz',
      copy: 'Kopiuj',
      previewMobile: 'Podgląd na telefonie',
      scanMobilePreview: 'Zeskanuj kod QR telefonem, aby zobaczyć podgląd swojej strony',
      types: {
        socials: 'media społecznościowe',
        shareTo: 'udostępnij',
        qrCode: 'QR',
        title: 'Udostępnij swój UniLink',
        titleSocials: 'Dodaj UniLink do swoich mediów społecznościowych',
        titleShareTo: 'Udostępnij do...',
        titleQRCode: 'Kod QR',
        titlePreviewMobile: 'Podgląd na telefonie',
      },
      socialList: {
        instagramText: 'Dodaj swój UniLink do profilu Instagram. Po prostu skopiuj swój URL UniLink, przejdź do Edytuj profil i wklej go w polu Strona internetowa.',
        facebookText:
          'Dodaj swój UniLink do profilu Facebook. Po prostu skopiuj swój URL UniLink, przejdź do strony Informacje w swoim profilu, kliknij Kontakt i podstawowe informacje, następnie kliknij + Dodaj stronę internetową, wklej swój URL UniLink w polu adresu strony i kliknij Zapisz.',
        tikTokText:
          'Dodaj swój UniLink do profilu Facebook. Po prostu skopiuj swój URL UniLink, przejdź do strony Informacje w swoim profilu, kliknij Kontakt i podstawowe informacje, następnie kliknij + Dodaj stronę internetową, wklej swój URL UniLink w polu adresu strony i kliknij Zapisz.',
        twitchText:
          'Dodaj swój UniLink do swojego kanału Twitch. Po prostu skopiuj swój URL UniLink, przejdź do swojego kanału Twitch, kliknij O kanale, następnie kliknij Edytuj ustawienia o kanale i linki, przewiń do Linki społecznościowe, dodaj UniLink w pierwszym polu tekstowym, a swój URL UniLink wklej w drugim polu tekstowym, następnie kliknij Dodaj.',
        youTubeText:
          'Dodaj swój UniLink do swojego kanału YouTube. Po prostu skopiuj swój URL UniLink, przejdź do swojego kanału YouTube, kliknij Dostosuj kanał, następnie kliknij Podstawowe informacje, a w sekcji Linki dodaj tytuł linku i wklej swój URL UniLink w polu URL, następnie kliknij Publikuj.',
        linkedInText:
          'Dodaj swój UniLink do profilu LinkedIn. Po prostu skopiuj swój URL UniLink, przejdź do swojego profilu LinkedIn, kliknij ikonę ołówka, przewiń do Informacje kontaktowe, wklej swój URL UniLink w polu URL strony i kliknij Zastosuj.',
        pinterestText:
          'Dodaj swój UniLink do profilu Pinterest. Po prostu skopiuj swój URL UniLink, przejdź do ustawień Pinterest, wklej swój URL UniLink w polu URL strony i kliknij Zapisz.',
        twitterText:
          'Dodaj swój UniLink do profilu Twitter. Po prostu skopiuj swój URL UniLink, przejdź do swojego profilu, kliknij Edytuj profil i wklej swój URL UniLink w polu Strona internetowa.',
      },
      share: {
        shareFacebook: 'Udostępnij na Facebooku',
        shareLinkedIn: 'Udostępnij na LinkedIn',
        shareTwitter: 'Udostępnij na Twitterze',
        shareWhatsApp: 'Udostępnij przez WhatsApp',
        shareMessenger: 'Udostępnij przez Messenger',
        shareEmail: 'Udostępnij przez e-mail',
      },
    },
  },
  popupMenu: {
    edit: 'Edytuj podstronę',
    openInNewTab: 'Otwórz w nowej karcie',
    copyLink: 'Kopiuj URL',
    delete: 'Usuń',
    showThumbnail: 'Pokaż miniatury podstron w panelu',
    manageTabs: 'Zarządzaj zakładkami',
  },
  tabsDashboard: {
    labelAddNewTab: 'Nowa zakładka',
  },
  blocks: {
    header: {
      blockTitle: 'Nagłówek',
      blockText: 'Dostosuj swoje zdjęcie profilowe, dodaj krótkie bio i zaktualizuj ikony społecznościowe',
      blockShortText: 'Dostosuj swój profil',
      layout: 'Układ',
      layoutTooltip: 'Stwórz taki układ nagłówka, jaki chcesz',
      layoutAlign: 'Wyrównanie układu',
      layoutAlignTooltip: 'Wyrównaj tekst',
      bottomButtonsSettings: 'Dolne przyciski',
      bottomButtonsLayout: 'Układ',
      bottomButtonsRow: 'Obok siebie',
      bottomButtonsColumn: 'W kolumnie',
      profilePicture: 'Zdjęcie profilowe',
      profilePictureTooltip: 'Zmień zdjęcie profilowe',
      cropMismatch: 'To zdjęcie zostało przycięte dla innego układu.',
      adjustCrop: 'Dostosuj przycięcie',
      photoShapeLabel: 'Kształt zdjęcia',
      photoShapeTooltip: 'Wybierz, czy ten układ pokazuje kwadratowe zdjęcie, czy przycięcie pionowe.',
      photoShapeSquare: 'Kwadrat',
      photoShapeVertical: 'Pionowe',
      photoStyleProTitle: 'Odblokuj zaawansowane style zdjęć',
      photoStyleProDesc: 'Bez tła i Tekst za zdjęciem to funkcje PRO.',
      photoShapeCustom: 'Własne',
      sliderStyleLabel: 'Styl slidera',
      sliderStyleTooltip: 'Swipe pokazuje jedno zdjęcie na raz; Gallery pokazuje rząd miniatur — dotknij miniatury, aby zmienić główne zdjęcie.',
      sliderStyleSwipe: 'Swipe',
      sliderStyleGallery: 'Galeria',
      photoPositionLabel: 'Pozycja zdjęcia',
      photoPositionHint: 'Kadrowanie pionowe',
      verticalCropHint: 'Ten układ pokazuje oryginalne zdjęcie. Wybierz pionowy obszar, który chcesz wyświetlić.',
      verticalCropReady: 'Dostosuj pionowy obszar wyświetlany w tym układzie.',
      pickVerticalArea: 'Wybierz obszar pionowy',
      pictureSize: 'Rozmiar zdjęcia',
      pictureSizeTooltip: 'Możesz zmienić rozmiar zdjęcia',
      pictureHeight: 'Wysokość zdjęcia',
      pictureHeightCaption: 'Możesz zmienić wysokość zdjęcia',
      photoStyle: 'Styl zdjęcia',
      photoStyleTooltip: 'Pokaż zdjęcie w oryginale, z usuniętym tłem lub umieść tekst za obiektem.',
      avatarModeOriginal: 'Oryginał',
      avatarModeCutout: 'Bez tła',
      avatarModeLayered: 'Tekst za zdjęciem',
      overlayText: 'Tekst',
      overlayTextPlaceholder: 'Twoje imię (domyślnie)',
      overlayColor: 'Kolor tekstu',
      overlaySize: 'Rozmiar',
      overlayY: 'Pozycja pionowa',
      overlayEffect: 'Animacja',
      overlayEffectNone: 'Brak',
      overlayEffectShimmer: 'Migotanie',
      overlayEffectGlow: 'Poświata',
      overlayEffectGradient: 'Gradient',
      overlayEffectSparkle: 'Blask',
      overlayUsesName: 'W tym układzie tekst to Twoje imię profilowe — pojawia się za Tobą. Edytuj je w sekcji „Imię”.',
      cutoutGenerate: 'Generuj wycinek',
      cutoutRegenerate: 'Wygeneruj ponownie',
      cutoutUpload: 'Prześlij',
      cutoutOr: 'lub',
      cutoutGenerating: 'Generowanie...',
      cutoutUploading: 'Przesyłanie...',
      cutoutVideoHint: 'Usuwanie tła działa tylko ze zdjęciami, nie z wideo.',
      cutoutTimeout: 'Usuwanie tła trwa zbyt długo. Spróbuj ponownie.',
      preview: 'Podgląd',
      badge: 'Odznaka',
      badgeTooltip: 'Dodaj odznakę weryfikacji do nagłówka',
      profileBadges: 'Odznaki',
      profileBadgesTooltip: 'Wybierz do 3 odznak do pokazania przy imieniu',
      profileBadgesProLockHint: 'Ulepsz do PRO, aby użyć tej odznaki',
      profileBadgesAdd: 'Dodaj odznaki',
      profileBadgesManage: 'Zarządzaj odznakami',
      profileBadgesModalTitle: 'Dodaj odznaki do swojego profilu',
      profileBadgesModalSubtitle: 'Pokaż swoje osiągnięcia i wyróżnienia.',
      profileBadgesCustomCta: 'Prześlij własną odznakę',
      profileBadgesCustomDesc: 'Twoja własna odznaka',
      profileBadgesCustomName: 'Nazwa odznaki',
      profileBadgesCustomChoose: 'Wybierz obraz',
      profileBadgesCustomChange: 'Zmień obraz',
      profileBadgesCustomUploading: 'Przesyłanie…',
      profileBadgesCustomAdd: 'Dodaj odznakę',
      tags: 'Tagi',
      tagsTooltip: 'Pokaż tagi kategorii pod imieniem (maks. 5)',
      tagsAdd: 'Dodaj tagi',
      addTags: '+ Dodaj tagi',
      tagsEdit: 'Edytuj tagi',
      tagsCustomPlaceholder: 'Dodaj własny tag',
      tagsCustomAdd: 'Dodaj',
      tagsSuggested: 'Sugerowane kategorie',
      tagsSelected: 'Wybrane',
      tagsEmpty: 'Brak jeszcze tagów — wybierz z sugestii lub dodaj własny',
      tagsLimit: 'Maksymalnie 5 tagów',
      visibility: 'Widoczność',
      visibilityTooltip: 'Pokaż lub ukryj zdjęcie profilowe',
      cover: 'Okładka',
      coverTooltip: 'Dodaj obraz lub wideo do okładki nagłówka',
      addCover: 'Dodaj okładkę',
      image: 'Obraz',
      video: 'Wideo',
      positionCover: 'Pozycja tekstu i przycisku',
      positionCoverTooltip: 'Przeciągnij suwak, aby zmienić pozycję',
      buttons: 'Przyciski',
      block: 'Blok',
      videoProcessing: 'Przetwarzanie wideo',
      vibe: 'Vibe',
      vibeTooltip: 'Dodaj swój vibe',
      stories: 'Stories',
      storiesTooltip: 'Dodaj swoje Stories',
      addStory: 'Dodaj Story',
      storiesSubtitle: 'Dodaj obraz lub wideo do swoich Stories',
      subscribeMethod: 'Metoda subskrypcji',
      subscribeMethodTooltip: 'Wybierz metodę subskrypcji',
      subscribeLink: 'Link subskrypcji',
      subscribeLinkTooltip: 'Kopiuj swój link subskrypcji',
      minWidth: 'Minimalna szerokość',
      addVCard: 'Dodaj vCard',
      vCard: 'vCard',
      vCardTooltip: 'Możesz dodać informacje o sobie',
      buttonInline: 'Przycisk w linii nagłówka',
      buttonInsideContact: 'Przycisk wewnątrz przycisku Kontakt',
      showSaveContact: 'Pokaż zapis kontaktu',
      options: 'Opcje',
      showBusinessCard: 'Pokaż wizytówkę',
      showBusinessCardCaption: 'Dodaje tutaj przycisk „Zapisz kontakt”.',
      editBusinessCard: 'Edytuj wizytówkę',
      editContactDetails: 'Edytuj dane kontaktowe na wizytówkach',
      needAddContact: 'Musisz dodać przycisk Kontakt',
      socialGap: 'Odstęp',
      socialGapCaption: 'Możesz zmienić odstęp',
      socialSize: 'Rozmiar',
      socialSizeCaption: 'Możesz zmienić rozmiar',
      icons: 'Ikony',
      iconsTooltip: 'Dodaj ikonę do przycisku',
      ribbonLabel: 'Dekoracyjna wstążka',
      ribbonLabelTooltip: 'Dodaj kolorowy pasek pod hero nagłówka',
      addTint: 'Dodaj wstążkę',
      ribbonTitle: 'Wstążka',
      ribbonText: 'Tekst wstążki',
      ribbonTextPlaceholder: 'np. 20% rabatu do końca miesiąca',
      ribbonColor: 'Kolor wstążki',
      ribbonTheme: 'Styl',
      ribbonThemes: {
        none: 'Bez dekoracji',
        birthday: 'Urodziny',
        newyear: 'Nowy Rok',
        valentine: 'Walentynki',
        halloween: 'Halloween',
        summer: 'Lato',
      },
      ribbonEffect: 'Efekt',
      ribbonEffects: {
        none: 'Brak',
        gradient: 'Animowany gradient',
        shimmer: 'Migotanie',
        lights: 'Lampki',
      },
      ribbonPosition: 'Pozycja',
      ribbonPositions: {
        bottom: 'Pod nagłówkiem',
        underPhoto: 'Pod zdjęciem',
      },
      ribbonRemove: 'Usuń wstążkę',
      statusBadges: 'Aktywność',
      statusBadgesTooltip: 'Pokaż aktywność w czasie rzeczywistym na Twojej stronie',
      addStatus: 'Dodaj aktywność',
      statusDisabledHint: 'Ukryte · wyłączone',
      followersTitle: 'Obserwujący',
      followersCounter: 'Licznik obserwujących',
      followersTooltip: 'Wyświetl łączną liczbę obserwujących z połączonych kont społecznościowych',
    },
    text: {
      blockTitle: 'Tekst',
      blockText: 'Ogólny blok tekstowy do napisania czegokolwiek. Możesz formatować tekst za pomocą edytora WYSIWYG',
      blockShortText: 'Ogólny blok tekstowy',
      title: 'Tytuł',
      titleText: 'Dostosuj rozmiar swojego tytułu',
      orderOfElements: 'Kolejność elementów',
      orderOfElementsTooltip: 'Przeciągnij suwak, aby zmienić kolejność elementów',
      changeOrder: 'Zmień kolejność',
      text: 'Tekst',
      content: 'Treść',
      image: 'Obraz',
      button: 'Przycisk',
      addButtons: 'Dodaj więcej przycisków',
      displayedContent: 'Wyświetlana treść',
      displayedContentTooltip: 'Pokaż lub ukryj treść',
      buttonLayout: 'Układ przycisków',
      buttonLayoutTooltip: 'Wybierz pionowy lub poziomy układ przycisków',
    },
    timeline: {
      blockTitle: 'Oś czasu',
      blockText: 'Wyświetl pionową oś czasu z wydarzeniami. Każde wydarzenie może mieć datę/godzinę, tytuł, opis i opcjonalny obraz',
      blockShortText: 'Wyświetl oś czasu wydarzeń',
      editItem: 'Edytuj wydarzenie',
      title: 'Tytuł',
      titlePlaceholder: 'Tytuł wydarzenia',
      subtitle: 'Podtytuł',
      subtitlePlaceholder: 'Rola lub przynależność (opcjonalnie)',
      description: 'Opis',
      descriptionPlaceholder: 'Opis wydarzenia (opcjonalnie)',
      startTime: 'Godzina rozpoczęcia',
      endTime: 'Godzina zakończenia',
      startDate: 'Data rozpoczęcia',
      endDate: 'Data zakończenia',
      showEndDate: 'Pokaż datę zakończenia',
      showEndDateTooltip: 'Wyłącz dla trwających wydarzeń (np. „pracuję tu od 2023”)',
      includeTime: 'Uwzględnij godzinę',
      includeTimeTooltip: 'Jeśli wyłączone, pokazana zostanie tylko data bez godziny',
      image: 'Obraz',
      imagePlaceholder: 'Prześlij awatar lub ikonę',
      imageUploadFailed: 'Nie udało się przesłać obrazu. Użyj Moich mediów lub wklej link.',
      untitled: 'Bez tytułu',
      listLayout: 'Układ listy',
      lineColor: 'Kolor linii',
    },
    trust: {
      blockTitle: 'Zaufanie',
      blockShortText: 'Udostępnij swoje partnerstwa',
      blockText: 'Umieść wszystkie swoje połączenia w jednym miejscu.',
      titleText: 'Dostosuj rozmiar swojego tytułu',
      orderOfElements: 'Kolejność elementów',
      orderOfElementsTooltip: 'Przeciągnij suwak, aby zmienić kolejność elementów',
      changeOrder: 'Zmień kolejność',
      text: 'Tekst',
      content: 'Treść',
      image: 'Obraz',
      button: 'Przycisk',
      displayedContent: 'Wyświetlana treść',
      displayedContentTooltip: 'Pokaż lub ukryj treść',
      enterTrustLink: 'Wpisz URL partnera',
      enterTrustLinkTooltip: 'Wklej URL partnera',
      enterPartnerName: 'Wpisz nazwę partnera',
      enterPartnerUrl: 'https://www.twojpartner.com/',
      enterDescription: 'Wpisz opis (opcjonalnie)',
      partnerLogo: 'Logo partnera',
      uploadPartnerLogo: 'Prześlij logo partnera',
    },
    wall: {
      blockTitle: 'Tablica',
      blockShortText: 'Zbieraj wiadomości od odwiedzających',
      blockText: 'Wyświetl publiczną tablicę, na której odwiedzający mogą zostawiać wiadomości i wchodzić w interakcję z Twoją treścią',
    },
    'live-stream': {
      blockTitle: 'Transmisja na żywo',
      blockShortText: 'Transmituj na żywo na swojej stronie',
      blockText: 'Transmituj na żywo dla swoich odbiorców — natywnie przez naszą platformę lub osadź YouTube / Twitch',
    },
    workout: {
      blockTitle: 'Trening',
      blockShortText: 'Udostępniaj i sprzedawaj treningi',
      blockText: 'Opublikuj ustrukturyzowany trening — ćwiczenia z seriami, powtórzeniami i wideo demonstracyjnym. Sprzedaj go lub udostępnij za darmo',
    },
    videoFeedback: {
      blockTitle: 'Opinie wideo',
      blockShortText: 'Zbieraj wideo-referencje',
      blockText: 'Zbieraj krótkie wideo-referencje i opinie od swoich odbiorców',
    },
    'premium-inbox': {
      blockTitle: 'Skrzynka premium',
      blockShortText: 'Płatne wiadomości od fanów',
      blockText: 'Pozwól fanom wysyłać płatne wiadomości i prośby bezpośrednio do Twojej skrzynki premium',
    },
    'order-form': {
      blockTitle: 'Formularz zamówienia',
      blockShortText: 'Zbieraj zamówienia ze swojej strony',
      blockText: 'Zbieraj zamówienia bezpośrednio ze swojej strony za pomocą konfigurowalnego formularza zamówienia',
    },
    link: {
      blockTitle: 'Linki',
      blockText: 'Kieruj ruch do swojej strony, bloga, sklepu internetowego lub innych stron',
      blockShortText: 'Kieruj ruch na stronę',
      addLink: 'Dodaj link',
      addNewLink: 'Dodaj nowy link',
      restrictedTitle: 'Linki {platform} to funkcja PRO',
      restrictedText: 'Dodawanie linków {platform} jest dostępne w planie PRO. Ulepsz plan, aby dodać ten link do swojej strony.',
      upgradeToPro: 'Ulepsz do PRO',
      showMore: 'Pokaż więcej',
      showLess: 'Pokaż mniej',
      viewArchive: 'Zobacz archiwum',
      archivedLinks: 'Zarchiwizowane linki',
      noArchivedLinks: 'Utrzymuj porządek w linkach, archiwizując te, których obecnie nie używasz.',
      archiveAllUnpublished: 'Zarchiwizuj wszystkie nieopublikowane linki',
      addFormExisting: 'Dodaj z istniejących linków',
      addYourLink: 'Dodaj swój link do grupy',
      add: 'Dodaj',
      otherTypes: 'Typ akcji',
      link: 'Link',
      navigate: 'Przejdź',
      navigateTo: 'Przejdź do',
      scrollBlock: 'Przewiń do',
      copyText: 'Kopiuj tekst',
      navigatePage: 'Podstrona',
      navigateProduct: 'Produkt',
      navigateBlock: 'Blok',
      modal: 'Okno modalne',
      showModal: 'Pokaż okno modalne',
      modalBlock: 'Pokaż blok',
      modalItem: 'Pokaż element',
      modalCustom: 'Własne',
      document: 'Dokument',
      privat24: 'Privat24',
      phone: 'Połączenie telefoniczne',
      viber: 'Otwórz Viber',
      skype: 'Otwórz Skype',
      email: 'Wyślij e-mail',
      discount: 'Rabat',
      smartLink: 'Smart Link',
      mobileApp: 'Deep Link',
      enterURL: 'Wpisz URL',
      enterPrivat: 'Wpisz swoją kartę Privat Bank',
      enterPhone: 'Wpisz numer telefonu',
      enterViber: 'Wpisz numer Viber',
      enterSkype: 'Wpisz Skype',
      enterEmail: 'Wpisz e-mail',
      enterTitle: 'Wpisz tytuł',
      enterCopyText: 'Wpisz tekst do skopiowania',
      enterPromoCode: 'Wpisz kod promocyjny',
      group: 'Utwórz grupę',
      content: 'Treść',
      links: 'Linki',
      heading: 'Nagłówek',
      settings: 'Ustawienia',
      thumbnail: 'Miniatura',
      typeTooltip: '  Kliknięcie otworzy ten link',
      title: 'Tytuł',
      titleTooltip: 'Nazwa Twojego linku',
      description: 'Opis',
      descriptionTooltip: 'Opcjonalny opis cech linku, typów, kolorów, rozmiarów itp.',
      label: 'Etykieta',
      labelTooltip: 'Dodaj nazwę etykiety',
      button: 'Przycisk',
      buttonTooltip: 'Dodaj nazwę przycisku',
      buttonText: 'Tekst przycisku',
      buttonTextTooltip: 'Nazwa Twojego przycisku',
      buttonUrl: 'URL przycisku',
      buttonUrlTooltip: 'Wpisz URL przycisku',
      addLinkToGroup: 'Dodaj link do grupy',
      removeFromGroup: 'Usuń z grupy',
      deletePermanently: 'Usuń trwale',
      image: 'Obraz',
      buttonBg: 'Tło przycisku',
      postPreview: 'Podgląd posta',
      separatorType: 'Typ separatora',
      separatorTypeTooltip: 'Dodaj typ separatora do swojego przycisku',
      section: 'Sekcja',
      sectionTooltip: 'Sekcja linku',
      descriptionSeparator: 'Opis',
      descriptionSeparatorTooltip: 'Opcjonalny opis sekcji',
      sectionText: 'Tekst sekcji',
      linkInstant: 'Natychmiastowe przekierowanie linku',
      spotlight: 'Wyróżnij link',
      addEffect: 'Dodaj efekt specjalny',
      countdown: 'Odliczanie',
      countdownTimer: 'Zegar odliczania',
      countdownText: 'Dodaj odliczanie na żywo do momentu, gdy link stanie się klikalny',
      chooseDate: 'Wybierz datę',
      chooseDateTooltip: 'Wybierz datę dla swojego linku',
      chooseAction: 'Wybierz akcję',
      chooseActionTooltip: 'Wybierz akcję dla swojego linku',
      addCountdown: 'Dodaj odliczanie dla linku',
      scheduler: 'Harmonogram',
      schedule: 'Zaplanuj',
      scheduleText: 'Wybierz przyszłą datę i godzinę aktywacji swojego linku',
      activateOn: 'Aktywuj',
      activateOnTooltip: 'Wybierz datę',
      deactivateOn: 'Deaktywuj',
      deactivateOnTooltip: 'Wybierz datę',
      addSchedule: 'Dodaj harmonogram dla',
      scheduleError: 'Data zakończenia nie może być wcześniejsza niż data rozpoczęcia, a data rozpoczęcia nie może być w przeszłości.',
      scheduleErrorPast: 'Data aktywacji nie może być w przeszłości.',
      scheduleErrorPastDeactivate: 'Data deaktywacji nie może być w przeszłości.',
      scheduleErrorOrder: 'Data deaktywacji musi być po dacie aktywacji.',
      activatesIn: 'Aktywuje się za',
      deactivatesIn: 'Deaktywuje się za',
      lock: 'Blokada',
      lockText: 'Odwiedzający mogą uzyskać dostęp do tego linku tylko po spełnieniu jednego z kryteriów.',
      lockCode: 'Kod',
      lockCodeTitle: 'Kod odblokowujący ten link',
      lockCodeText: 'Odwiedzający musi wpisać 4-cyfrowy kod, aby odblokować ten link',
      lockSubscribe: 'Subskrybuj',
      lockSubscribeTitle: 'Odwiedzający musi zasubskrybować Twój UniLink, aby odblokować link.',
      lockSubscribeText: 'Blokada została pomyślnie skonfigurowana.',
      lockPayment: 'Płatność',
      lockPaymentText: 'Blokada została pomyślnie skonfigurowana.',
      price: 'Cena',
      priceTooltip: 'Dodaj cenę swojego produktu',
      lockAge: 'Data urodzenia (wiek)',
      lockAgeTitle: 'Ustaw minimalny wiek',
      lockAgeText: 'Odwiedzający musi mieć określony wiek, aby odblokować link swoją datą urodzenia',
      lockAgeAlert: 'Blokada została pomyślnie skonfigurowana.',
      lockSensitive: 'Treści wrażliwe',
      lockSensitiveText: 'Odwiedzający musi potwierdzić, że ten link może zawierać treści nieodpowiednie dla wszystkich odbiorców.',
      makeLink: 'Uczyń link płatnym',
      addLock: 'Dodaj blokadę dla linku',
      save: 'Zapisz',
      clear: 'Wyczyść',
      buttonColor: 'Kolor przycisku',
      labelColor: 'Kolor etykiety',
      background: 'Tło',
      imageHeight: 'Wysokość obrazu',
      imageHeightTooltip: 'Przeciągnij suwak, aby zmienić wysokość obrazu',
      buttonMinimum: 'Minimalna wysokość',
      buttonMinimumTooltip: 'Przeciągnij suwak, aby zmienić wysokość przycisku',
      textPosition: 'Pozycja tekstu',
      textPositionTooltip: 'Wybierz pionową pozycję tekstu',
      preview: 'podgląd',
      defaultDesign: 'Domyślny design',
      defaultDesignTooltip: 'Skonfiguruj domyślny design dla linków',
      defaultDesignTitle: 'Pamiętaj, że ten design zostanie zastosowany do wszystkich linków.',
      defaultDesignText: 'Możesz zmienić domyślny design linków',
      changeDefault: 'Zmień domyślny',
      applyDefault: 'Zastosuj domyślny',
      scheduled: 'Zaplanowano',
      scheduledVisible: 'Zaplanowany link jest teraz widoczny',
      scheduledHidden: 'Zaplanowany link jest teraz ukryty',
      linkClickable: 'Link klikalny za',
      linkDisable: 'Link wyłączy się za',
      lockedBy: 'Zablokowane przez',
      items: 'Elementy',
      doNotAnyLinks: 'Nie masz jeszcze żadnych linków',
      sublinks: 'Podlinki',
      layout: 'Układ',
      layoutTooltip: 'Wybierz żądany układ podlinków',
      hideGroupLink: 'Ukryj link grupy',
      rules: 'Reguły',
      rulesText: 'Zmień widoczność tego linku w zależności od tego, kto odwiedza Twoją stronę.',
      rulesEmpty: 'Brak jeszcze warunków. Dodaj warunek, aby kontrolować, kto widzi ten link.',
      rulesAddCondition: 'Dodaj warunek',
      rulesActive: 'Reguły widoczności',
      rulesIf: 'Jeśli',
      rulesThen: 'Wtedy',
      ruleTypeLocation: 'Lokalizacja',
      ruleTypeDevice: 'Urządzenie',
      ruleTypeTime: 'Dzień i godzina',
      ruleOperatorIs: 'jest',
      ruleOperatorIsNot: 'nie jest',
      ruleActionHide: 'Ukryj link',
      ruleActionShow: 'Pokaż link',
      ruleSelectLocations: 'Wybierz lokalizacje',
      ruleSearchLocations: 'Szukaj krajów…',
      ruleFrom: 'Od',
      ruleTo: 'Do',
      ruleAnyTime: 'Dowolny',
    },
    'data-collect': {
      blockTitle: 'Zbieranie danych',
      blockText: 'Zbieraj e-maile lub numery telefonów odwiedzających',
      blockShortText: 'Zbieraj e-maile',
      maxSize: 'Możesz dodać maksymalnie 3 kanały',
      customTerms: 'Własny regulamin',
      customTermsTooltip: 'Dodaj własny regulamin do swojego formularza',
      termsConditions: 'Regulamin',
      text: 'Tekst',
      subscribe: 'Subskrybuj',
      title: 'Tytuł',
      titleTooltip: 'Wpisz tytuł regulaminu',
      titleResultTooltip: 'Wpisz tytuł dla swojego wysłania',
      url: 'URL',
      urlTooltip: 'Wpisz URL',
      editItem: 'Edytuj element',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Wpisz tekst placeholdera',
      button: 'Przycisk',
      buttonTooltip: 'Tekst zachęcający odwiedzającego do wpisania e-maila (rabat 10%, subskrybuj teraz, pobierz plik itp.)',
      successMessage: 'Wiadomość o sukcesie',
      successMessageTooltip: 'Wiadomość o sukcesie dla subskrybentów',
      botURL: 'URL bota (opcjonalnie)',
      botURLTooltip: 'Wpisz URL swojego bota',
      botToken: 'Token bota',
      botTokenTooltip: 'Wpisz token swojego bota',
      rewards: 'Odpowiedzi',
      rewardsTooltip: 'Dodaj odpowiedzi dla subskrybentów',
      addReward: 'Dodaj odpowiedź',
      thankYou: 'Wiadomość z podziękowaniem',
      email: {
        none: 'Brak',
        display: 'Pokaż odpowiedź od razu',
        send: 'Wyślij odpowiedź na e-mail',
        redirect: 'Przekieruj na URL',
      },
      phone: {
        none: 'Brak',
        display: 'Pokaż odpowiedź od razu',
        send: 'Wyślij odpowiedź na telefon',
        redirect: 'Przekieruj na URL',
      },
      telegram: {
        none: 'Brak',
        display: 'Pokaż odpowiedź od razu',
        send: 'Wyślij odpowiedź w bocie Telegram',
        redirect: 'Przekieruj na URL',
      },
      whatsapp: {
        none: 'Brak',
        display: 'Pokaż odpowiedź od razu',
        send: 'Wyślij odpowiedź w bocie WhatsApp',
        redirect: 'Przekieruj na URL',
      },
      instagram: {
        none: 'Brak',
        display: 'Pokaż odpowiedź od razu',
        send: 'Wyślij odpowiedź w bocie Instagram',
        redirect: 'Przekieruj na URL',
      },
      messenger: {
        none: 'Brak',
        display: 'Pokaż odpowiedź od razu',
        send: 'Wyślij odpowiedź w bocie Messenger',
        redirect: 'Przekieruj na URL',
      },
      viber: {
        none: 'Brak',
        display: 'Pokaż odpowiedź od razu',
        send: 'Wyślij odpowiedź w bocie Viber',
        redirect: 'Przekieruj na URL',
      },
      connect: 'Połącz',
      toChangeReward: 'Aby zmienić typ odpowiedzi, musisz usunąć obecny',
      remove: 'Usuń',
      viewTypes: 'Typy widoku',
    },
    form: {
      blockTitle: 'Formularz',
      blockText: 'Pozwala zbierać informacje i dane od odbiorców',
      blockShortText: 'Zbieraj informacje',
      fields: 'Pola',
      fieldsTooltip: 'Dodaj pola do formularza',
      addCustomField: 'Dodaj niestandardowe pole',
      addItem: 'Dodaj element',
      editItem: 'Edytuj element',
      type: 'Typ',
      typeTooltip: 'Wybierz typ pola',
      string: 'Krótka odpowiedź',
      textarea: 'Długa odpowiedź',
      dropdown: 'Lista rozwijana',
      radio: 'Przycisk radiowy',
      checkbox: 'Checkbox',
      date: 'Data',
      time: 'Godzina',
      country: 'Kraj',
      fieldName: 'Nazwa pola',
      fieldNameTooltip: 'Wpisz nazwę pola',
      name: 'Nazwa',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Wpisz tekst placeholdera',
      required: 'Wymagane',
      requiredTooltip: 'Zaznacz, czy pole jest wymagane',
      value: 'Wartość',
      enterTitle: 'Wpisz tytuł',
      addValue: 'Dodaj wartość',
      delete: 'Usuń',
      update: 'Aktualizuj',
      add: 'Dodaj',
      confirmationPage: 'Akcja potwierdzenia',
      confirmationPageSubtitle: 'Wybierz akcję po wysłaniu formularza',
      successMessage: 'Wiadomość o sukcesie',
      successMessageTooltip: 'Wiadomość o sukcesie po wysłaniu formularza',
      thankYou: 'Wiadomość z podziękowaniem',
      submit: 'Wyślij',
    },
    contact: {
      blockTitle: 'Kontakty',
      blockText: 'Kontakty pozwalają użytkownikom skontaktować się z Tobą bezpośrednio. Dodaj telefon, e-mail, komunikator lub lokalizację',
      blockShortText: 'Kontakt z użytkownikami',
      addNewContact: 'Dodaj nowy kontakt',
      newContact: 'Nowy kontakt',
      friendlyName: 'Przyjazna nazwa',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Najczęściej zadawane pytania — lista odpowiedzi na typowe pytania użytkowników',
      blockShortText: 'Najczęstsze pytania',
      addNewItem: 'Dodaj nowy element',
      editItem: 'Edytuj element',
      title: 'Tytuł',
      titleTooltip: 'Wpisz tytuł',
      description: 'Opis',
      descriptionTooltip: 'Wpisz opis',
      update: 'Aktualizuj',
      add: 'Dodaj',
      howToFind: 'Jak nas znaleźć',
      view: 'Widok',
      viewTooltip: 'Wybierz sposób wyświetlania elementów FAQ',
      feed: 'Kanał',
      slider: 'Slider',
      emptyTitle: 'Nie masz jeszcze żadnych elementów',
      emptyText: 'Dodaj pierwsze pytanie, aby wypełnić ten blok.',
    },
    ama: {
      blockTitle: 'Zapytaj mnie o cokolwiek',
      blockShortText: 'Odpowiadaj na pytania fanów',
      blockText: 'Pozwól odbiorcom zadawać pytania i odpowiadaj na nie bezpośrednio na swojej stronie',
    },
    feature: {
      blockTitle: 'Cechy',
      blockText: 'Sekcja tekstowa z obrazem, aby pokazać użytkownikom, dlaczego Twoja firma jest najlepsza',
      blockShortText: 'Pokaż użytkownikom dlaczego',
      title: 'Tytuł',
      titleTooltip: 'Zmień tytuł elementu',
      description: 'Opis',
      descriptionTooltip: 'Zmień opis elementu',
    },
    highlight: {
      blockTitle: 'Wyróżnienia',
      blockText: 'Wyróżnij najważniejsze linki miniaturami (do 3)',
      blockShortText: 'Wyróżnij najważniejsze',
      title: 'Tytuł',
      titleTooltip: 'Zmień tytuł elementu',
      url: 'URL',
      urlTooltip: 'Zmień URL elementu',
    },
    banner: {
      blockTitle: 'Baner',
      blockText: 'Wyróżnij obraz, wideo lub swój najnowszy produkt. Możesz dodać przycisk CTA, aby kierować użytkowników do celu konwersji',
      blockShortText: 'Wyróżnij obraz, wideo',
      height: 'Wysokość',
      heightTooltip: 'Zmień wysokość banera',
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Karuzela obrazów pozwalająca zaprezentować treść i dodać różne funkcje',
      blockShortText: 'Karuzela obrazów',
      image: 'Obraz',
      imageTooltip: 'Obraz Twojej galerii',
      addText: 'Dodaj tekst',
      title: 'Tytuł',
      titleTooltip: 'Tytuł Twojego slajdu',
      titleSize: 'Rozmiar tytułu',
      titleSizeTooltip: 'Wybierz rozmiar dla lepszej czytelności',
      description: 'Opis',
      descriptionTooltip: 'Opis Twojego slajdu',
      textColor: 'Kolor tekstu',
      addButton: 'Dodaj przycisk',
      url: 'URL',
      urlTooltip: 'URL Twojego obrazu',
      button: 'Przycisk',
      buttonTooltip: 'Tytuł Twojego przycisku',
      buttonText: 'Tekst przycisku',
      buttonColor: 'Kolor przycisku',
      height: 'Wysokość',
      heightTooltip: 'Zmień wysokość slajdów',
      view: 'Widok',
      viewTooltip: 'Wybierz widok slidera',
      auto: 'Automatycznie',
      square: 'Kwadrat',
      rectangle: 'Prostokąt',
      single: 'Pojedynczy',
      multi: 'Wiele',
    },
    gallery: {
      blockTitle: 'Galeria',
      blockText: 'Karuzela obrazów pozwalająca zaprezentować treść',
      blockShortText: 'Karuzela obrazów',
      image: 'Obraz',
      imageTooltip: 'Obraz elementu Twojej galerii',
      layout: 'Układ',
      layoutTooltip: 'Wybierz układ galerii',
      feed: 'Kanał',
      slider: 'Slider',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Utwórz blog ze swoich postów',
      blockShortText: 'Utwórz blog',
      writeYourStory: 'Napisz swoją historię',
      shortDescription: 'Krótki opis',
      shortDescriptionTooltip: 'Opcjonalny opis Twojego bloga',
      description: 'Opis',
    },
    map: {
      blockTitle: 'Mapa',
      blockText: 'Dodaj mapę Google, aby pomóc użytkownikom znaleźć Twoją lokalną firmę',
      blockShortText: 'Dodaj mapę Google',
      buttonText: 'Tekst przycisku',
      buttonTextTooltip: 'Przycisk pojawia się, gdy wybrany jest drugi widok',
      text: 'Tekst',
      addAddress: 'Dodaj kolejny adres',
      address: 'Adres',
      addressTooltip: 'Wklej adres np. z map Google',
      googleMap: 'Mapa Google (kod osadzania)',
      googleMapTooltip: 'Wklej kod osadzania z map Google',
      howToFind: 'Jak znaleźć kod osadzania',
      incorrectCode: 'Nieprawidłowy kod osadzania.',
      moreInfo: 'Więcej informacji',
      code: 'Kod',
      addressSettings: 'Ustawienia adresu',
      addressContent: 'Dodaj URL, tytuł i tekst przycisku lub ikonę',
      title: 'Tytuł',
      titleTooltip: 'Nazwa Twojego adresu',
      url: 'URL',
      urlTooltip: 'Wklej URL adresu np. z map Google',
      directionText: 'Tekst kierunku',
      directionTextTooltip: 'Tekst wezwania do działania dla użytkowników',
    },
    footer: {
      blockTitle: 'Stopka',
      blockText: 'Sekcja treści na samym dole podstrony. Możesz dodać dane kontaktowe, ikony społecznościowe i formularz zapisu e-mail',
      blockShortText: 'Sekcja dolnej treści',
      addBlock: 'Dodaj blok',
      blockType: 'Typ bloku',
      blockTypeTooltip: 'Wybierz typ bloku',
      addBlockTitle: 'Tytuł bloku',
      addBlockTitleTooltip: 'Wybierz tytuł bloku',
      faq: 'FAQ',
      'data-collect': 'Zbieranie danych',
      contact: 'Kontakt',
      pages: 'Podstrony',
      payments: 'Płatności',
      social: 'Społecznościowe',
      cancel: 'Anuluj',
      add: 'Dodaj',
      None: 'Brak',
      text: 'Tekst',
      link: 'Linki',
      image: 'Obraz',
      divider: 'Separator',
      linkViewLabel: 'Układ',
      linkViewTooltip: 'Sposób ułożenia linków',
      linkViewSingle: 'W kolumnie',
      linkViewRow: 'W rzędzie',
      linkItemsLabel: 'Linki',
      linkItemsTooltip: 'Dodaj do 5 linków (np. Polityka prywatności, Regulamin)',
      linkLabelPlaceholder: 'Etykieta',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ Dodaj link',
      alignLabel: 'Wyrównanie',
      alignTooltip: 'Wyrównanie poziome',
      alignLeft: 'Lewo',
      alignCenter: 'Środek',
      alignRight: 'Prawo',
      imageLabel: 'Obraz',
      imageTooltip: 'Prześlij logo lub obraz',
      imageLinkLabel: 'Link (opcjonalnie)',
      imageLinkTooltip: 'Uczyń obraz klikalnym',
      dividerLabel: 'Typ separatora',
      dividerTooltip: 'Linia lub pusta przestrzeń',
      dividerLine: 'Linia',
      dividerSpace: 'Przestrzeń',
      picker: {
        subtitle: 'Wybierz element do dodania do stopki',
        configureSubtitle: 'Skonfiguruj i dodaj go do swojej stopki',
        back: 'Wstecz',
        saveButton: 'Zapisz',
        availableTitle: 'Dostępne do dodania',
        addedTitle: 'Już dodane',
        addedLabel: 'Dodano',
        addButton: 'Dodaj blok',
        linkTitle: 'Linki',
        linkSub: 'Przyciski do dowolnego URL',
        socialTitle: 'Społecznościowe',
        socialSub: 'Ikony profili społecznościowych',
        textTitle: 'Tekst',
        textSub: 'Nagłówek lub akapit',
        pagesTitle: 'Podstrony',
        pagesSub: 'Link do zagnieżdżonych podstron',
        paymentsTitle: 'Płatności',
        paymentsSub: 'Akceptowane metody płatności',
        imageTitle: 'Obraz',
        imageSub: 'Logo lub zdjęcie',
        dividerTitle: 'Separator',
        dividerSub: 'Linia lub odstęp',
        faqTitle: 'FAQ',
        faqSub: 'Najczęściej zadawane pytania',
        dataCollectTitle: 'Zbieranie danych',
        dataCollectSub: 'Formularz zapisu e-mail',
        contactTitle: 'Kontakt',
        contactSub: 'Dane kontaktowe',
        importMode: 'Importuj z bloku',
        manualMode: 'Dodaj ręcznie',
        noContactsToImport: 'Brak kontaktów do zaimportowania — dodaj je ręcznie.',
        noSocialsToImport: 'Brak ikon społecznościowych do zaimportowania — dodaj je ręcznie.',
        manualItemsLabel: 'Elementy',
        manualItemsTooltip: 'Wybierz typ i wpisz jego wartość.',
        contactValuePlaceholder: '@nazwa_użytkownika / e-mail / telefon',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ Dodaj więcej',
      },
      faqText: 'Możesz edytować najczęściej zadawane pytania w bloku FAQ. Możesz przejść do niego, klikając tutaj',
      socialText: 'Możesz edytować ikony społecznościowe w bloku Nagłówek. Możesz przejść do niego, klikając tutaj',
      dataCollectText: 'Możesz edytować zbieranie danych w bloku Zbieranie danych. Możesz przejść do niego, klikając tutaj',
      contactText: 'Możesz edytować kontakt w bloku Kontakt. Możesz przejść do niego, klikając tutaj',
      contactDesign: {
        editSource: 'Edytuj same kontakty w bloku Kontakt —',
        variantLabel: 'Styl',
        variantList: 'Lista',
        variantButton: 'Przycisk',
        shapeLabel: 'Kształt',
        shape_square: 'Kwadrat',
        shape_rounded: 'Zaokrąglony',
        shape_pill: 'Pigułka',
        widthLabel: 'Szerokość',
        widthFull: 'Pełna',
        widthHalf: 'Połowa',
        widthHalfStacked: 'Pół kolumny',
        borderLabel: 'Obramowanie',
        borderOn: 'Włączone',
        borderOff: 'Wyłączone',
        borderColorLabel: 'Kolor obramowania',
      },
      pagesText: 'Możesz dodać nowe podstrony na stronie',
      paymentsText: 'Metody płatności zostaną wyświetlone',
      showOnAllpages: 'Pokaż na wszystkich podstronach',
      layout: 'Układ',
      splitImage: 'Boczny obraz',
      footerText: 'Stopka ze strony głównej jest obecnie włączona.',
      editSocialIcons: 'Możesz edytować ikony społecznościowe w sekcji Nagłówek. Możesz przejść do niej, klikając tutaj',
      editSubscribe: 'Możesz edytować subskrypcję w sekcji Subskrypcja. Możesz przejść do niej, klikając tutaj',
      editContacts: 'Możesz edytować kontakty w sekcji Kontakty. Możesz przejść do niej, klikając tutaj',
      editFrequently: 'Możesz edytować najczęściej zadawane pytania w sekcji FAQ. Możesz przejść do niej, klikając tutaj',
    },
    'chat-ai': {
      blockTitle: 'Czat AI',
      blockShortText: 'Rozmawiaj z AI',
      blockText: 'Rozmawiaj z AI',
      suggestionsTitle: 'Sugestie',
      suggestionsSubtitle: 'Szybkie podpowiedzi',
    },
    custom: {
      blockTitle: 'Własny',
      blockShortText: 'Blok oparty na AI',
      blockText: 'Opisz mini-aplikację interaktywną, a AI ją dla Ciebie wygeneruje',
    },
    shop: {
      blockTitle: 'Sklep',
      blockText: 'Dodaj listę swoich produktów',
      blockShortText: 'Dodaj swoje produkty',
      view: 'Widok',
      cardLayout: 'Układ karty',
      cardLayoutTooltip: 'Showcase renderuje każdy produkt jako szczegółową kartę sprzedażową, jedna w rzędzie',
      standardCards: 'Standardowy',
      showcaseCards: 'Showcase',
      products: 'Produkty',
      categories: 'Kategorie',
      featured: 'Wyróżnione',
    },
    digital: {
      blockTitle: 'Produkty cyfrowe',
      blockText: 'Sprzedaj plik do pobrania: PDF-y, arkusze kalkulacyjne, szablony, ekskluzywne treści',
      blockShortText: 'Sprzedaj plik cyfrowy',
    },
    podcast: {
      blockTitle: 'Podcasty',
      blockText: 'Promuj swoje podcasty',
      blockShortText: 'Promuj swoje podcasty',
    },
    'page-list': {
      blockTitle: 'Lista podstron',
      blockText: 'Utwórz swoją listę podstron',
      description: 'Opis',
      blockShortText: 'Utwórz swoją listę podstron',
      addNewPageItem: 'Dodaj link do podstrony',
    },
    appointment: {
      blockTitle: 'Wizyty',
      blockText: 'Pozwól odwiedzającym rezerwować termin w Twoim kalendarzu',
      blockShortText: 'Pozwól odwiedzającym rezerwować',
    },
    service: {
      blockTitle: 'Usługi',
      blockText: 'Otrzymasz powiadomienie e-mail, gdy zostanie wysłane zapytanie',
      blockShortText: 'Otrzymuj e-mail',
    },
    requests: {
      blockTitle: 'Usługi',
      blockText: 'Otrzymasz powiadomienie e-mail, gdy zostanie wysłane zapytanie',
      blockShortText: 'Otrzymuj e-mail',
    },
    tips: {
      blockTitle: 'Napiwki',
      blockText: 'UniLink sprawia, że wspieranie jest łatwe i przyjemne. W kilku dotknięciach Twoi fani mogą dokonać płatności i zostawić wiadomość',
      blockShortText: 'Sprawia, że wspieranie jest przyjemne',
    },
    tip: {
      blockTitle: 'Napiwki',
      blockText: 'UniLink sprawia, że wspieranie jest łatwe i przyjemne. W kilku dotknięciach Twoi fani mogą dokonać płatności i zostawić wiadomość',
      blockShortText: 'Sprawia, że wspieranie jest przyjemne',
    },
    donation: {
      blockTitle: 'Darowizny',
      blockText: 'UniLink sprawia, że wspieranie jest łatwe i przyjemne. W kilku dotknięciach Twoi fani mogą dokonać płatności i zostawić wiadomość',
      blockShortText: 'Sprawia, że wspieranie jest przyjemne',
    },
    course: {
      blockTitle: 'Kurs lub poradnik',
      blockText: 'Pozwól odwiedzającym rezerwować termin w Twoim kalendarzu',
      blockShortText: 'Pozwól odwiedzającym rezerwować',
    },
    event: {
      blockTitle: 'Wydarzenia lub bilety',
      blockText: 'Pozwól odbiorcom odwiedzać Twoje wydarzenia',
      blockShortText: 'Pozwól odbiorcom odwiedzać',
    },
    menu: {
      blockTitle: 'Menu',
      blockText: 'Utwórz unikalne menu z cenami',
      blockShortText: 'Utwórz unikalne menu',
    },
    recipe: {
      blockTitle: 'Przepis',
      blockText: 'Udostępnij przepis ze składnikami, krokami i zdjęciami',
      blockShortText: 'Udostępnij przepis',
    },
    booking: {
      blockTitle: 'Rezerwacja',
      blockText: 'Pozwól odwiedzającym rezerwować Twoje przestrzenie',
      blockShortText: 'Pozwól odwiedzającym rezerwować',
      name: 'Nazwa',
      nameCaption: 'Wpisz nazwę przestrzeni',
      description: 'Opis',
      descriptionCaption: 'Krótki opis tej przestrzeni',
      rentalType: 'Typ wynajmu',
      rentalTypeCaption: 'Na przykład: mieszkanie, samochód, biuro',
      duration: 'Czas trwania',
      durationCaption: 'Na przykład: za dzień, za tydzień, za miesiąc',
      price: 'Cena',
      priceCaption: 'Cena podstawowa tej przestrzeni',
      oldPrice: 'Stara cena',
      oldPriceCaption: 'Opcjonalna poprzednia cena',
      rating: 'Ocena',
      ratingCaption: 'Średnia ocena (opcjonalnie)',
      label: 'Etykieta',
      labelCaption: 'Krótka odznaka jak HOT lub NEW',
      image: 'Obraz',
      imageCaption: 'Prześlij zdjęcie okładki dla tej przestrzeni',
      location: 'Lokalizacja',
      locationCaption: 'Miasto, okolica lub adres',
      capacity: 'Pojemność (goście)',
      capacityCaption: 'Maksymalna liczba gości',
      rooms: 'Pokoje i powierzchnia',
      roomsCaption: 'Sypialnie, łazienki i powierzchnia',
      bedrooms: 'Sypialnie',
      bathrooms: 'Łazienki',
      areaSqM: 'Powierzchnia (m²)',
      minStay: 'Minimalny pobyt (dni)',
      minStayCaption: 'Minimalna liczba dni rezerwacji',
      requiresDeposit: 'Wymaga zadatku',
      depositAmount: 'Kwota zadatku',
      depositAmountCaption: 'Zadatek z góry na potwierdzenie rezerwacji',
      noSmoking: 'Zakaz palenia',
      noPets: 'Zakaz zwierząt',
      amenitiesWifi: 'Wi-Fi',
      amenitiesParking: 'Parking',
      amenitiesKitchen: 'Kuchnia',
      amenitiesHeating: 'Ogrzewanie',
      amenitiesAC: 'Klimatyzacja',
      amenitiesPool: 'Basen',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Toalety',
      validationNameRequired: 'Nazwa jest wymagana',
      validationPriceRequired: 'Cena musi być liczbą nieujemną',
      validationDepositRequired: 'Kwota zadatku jest wymagana, gdy zadatek jest włączony',
      validationCapacityNumber: 'Pojemność musi być liczbą nieujemną',
      validationOldPriceNumber: 'Stara cena musi być liczbą nieujemną',
      brand: 'Marka',
      brandCaption: 'Marka samochodu, np. Tesla',
      model: 'Model',
      modelCaption: 'Model samochodu, np. Model 3',
      year: 'Rok',
      yearCaption: 'Rok produkcji',
      color: 'Kolor',
      colorCaption: 'Kolor zewnętrzny, np. czarny',
      fuelType: 'Typ paliwa',
      fuelTypeCaption: 'Benzyna, diesel, elektryczny, hybrydowy itp.',
      transmission: 'Skrzynia biegów',
      transmissionCaption: 'Automatyczna lub manualna',
      seatCount: 'Liczba miejsc',
      seatCountCaption: 'Liczba miejsc w samochodzie',
      edit: 'Edytuj element',
      add: 'Dodaj element',
    },
    membership: {
      blockTitle: 'Członkostwo',
      blockText: 'Utwórz darmową lub płatną subskrypcję swoich treści',
      blockShortText: 'Utwórz subskrypcję',
    },
    pricing: {
      blockTitle: 'Cennik',
      blockText: 'Utwórz unikalne menu z cenami',
      blockShortText: 'Utwórz unikalne menu',
      name: 'Nazwa',
      nameTooltip: 'Wpisz nazwę swojego produktu',
      pricingPlanName: 'Nazwa planu cenowego',
      pricingPlanNameTooltip: 'Wpisz nazwę swojego planu cenowego',
      description: 'Opis',
      descriptionTooltip: 'Wpisz opis swojego produktu',
      pricingPlanDescriptionTooltip: 'Wpisz opis swojego planu cenowego',
      priceValue: 'Wartość ceny',
      priceUnit: 'Jednostka ceny',
      label: 'Etykieta',
      labelTooltip: 'Wpisz etykietę swojego planu cenowego',
      orderButtonText: 'Tekst przycisku zamówienia',
      orderButtonTextDescriptionTooltip: 'Wpisz tekst przycisku zamówienia swojego planu cenowego',
      orderButtonLink: 'Link przycisku zamówienia',
      orderButtonLinkDescriptionTooltip: 'Wpisz link przycisku zamówienia swojego planu cenowego',
      subtitle: 'Podtytuł',
      subtitleTooltip: 'Wpisz podtytuł swojego produktu',
      price: 'Cena',
      priceTooltip: 'Wpisz cenę swojego produktu',
      pricingTiers: 'Poziomy cenowe',
      pricingTiersTooltip: 'Wpisz poziomy cenowe swojego produktu',
      addPriceValue: 'Dodaj więcej cen',
      group: 'Grupa',
      groupTooltip: 'Wybierz grupę swojego produktu',
      image: 'Obraz',
      imageTooltip: 'Prześlij obraz swojego produktu',
      unit: 'Jednostka ceny',
      unitTooltip: 'Wpisz jednostkę swojej ceny',
      addUnitTitle: 'Jednostki ceny',
      addPriceUnitValue: 'Dodaj więcej jednostek ceny',
      addUnitButtonText: 'Zapisz',
      button: 'Przycisk',
      buttonTooltip: 'Dodaj przycisk dla swojego produktu',
      buttonAddText: '+ Dodaj przycisk',
      buttonModalTextField: 'Tekst przycisku',
      buttonModalTextFieldTooltip: 'Wpisz tekst przycisku',
      buttonModalURLField: 'URL przycisku',
      buttonModalURLFieldTooltip: 'Wpisz URL przycisku',
      buttonModalTitle: 'Dodaj przycisk',
      groups: {
        title: 'Grupy',
        subtitle: 'Dodawaj, edytuj i usuwaj grupy',
        groups: 'Grupy',
        groupsTooltip: 'Dodawaj, edytuj i usuwaj grupy',
        addNewGroup: 'Dodaj nową grupę',
        newGroup: 'Nowa grupa',
        titleGroup: 'Tytuł',
        titleGroupTooltip: 'Wpisz tytuł swojej grupy',
        descriptionGroup: 'Opis',
        descriptionGroupTooltip: 'Wpisz opis swojej grupy',
      },
    },
    menuBlock: {
      title: 'Menu',
      subtitle: 'Utwórz menu z pozycjami i cenami',
      add: 'Dodaj nową pozycję',
      edit: 'Edytuj pozycję',
      name: 'Nazwa',
      nameCaption: 'Wpisz nazwę pozycji',
      description: 'Opis',
      descriptionCaption: 'Wpisz krótki opis',
      ingredients: 'Składniki',
      ingredientsCaption: 'Wypisz składniki lub skład',
      price: 'Cena',
      priceCaption: 'Wpisz cenę',
      weight: 'Waga (g)',
      weightCaption: 'Wpisz wagę w gramach',
      calories: 'Kalorie (kcal)',
      caloriesCaption: 'Wpisz kalorie w kcal',
      label: 'Etykieta',
      labelCaption: 'Wpisz tekst etykiety',
      labelColor: 'Kolor etykiety',
      labelColorCaption: 'Wybierz kolor tła etykiety',
      image: 'Obraz',
      imageCaption: 'Prześlij obraz dla swojej pozycji',
      available: 'Dostępne do zamówienia',
      visible: 'Widoczne na podstronie',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Wyświetl NFT z platformy OpenSea lub swojego osobistego portfela',
      blockShortText: 'Wyświetl NFT',
    },
    wallet: {
      wallet: 'Portfel',
      blockTitle: 'Portfel bankowy/krypto',
      blockText: 'Wyświetl swoją kartę kredytową lub portfel Bitcoin, aby ułatwić użytkownikom skopiowanie go do przelewu środków',
      blockShortText: 'Wyświetl swoje portfele',
      title: 'Tytuł',
      titleTooltip: 'Tytuł Twojego portfela',
      walletNumber: 'Numer portfela',
      walletNumberTooltip: 'Wklej numer swojego portfela',
      icon: 'Ikona',
      iconTooltip: 'Ustaw ikonę dla swojego portfela',
      card: 'Karta',
      bank: 'Bank',
      crypto: 'Krypto',
      transfer: 'Przelew',
      paymentLink: 'Link płatności',
      cardNumber: 'Numer karty',
      cardNumberTooltip: 'Wklej numer swojej karty',
      cardHolder: 'Posiadacz karty',
      cardHolderTooltip: 'Wpisz posiadacza swojej karty',
      bankAccountDetails: 'Dane konta bankowego',
      bankAccountDetailsTooltip: 'Wpisz dane swojego konta bankowego',
      walletAddress: 'Adres portfela',
      walletAddressTooltip: 'Wpisz adres swojego portfela',
      network: 'Sieć',
      networkTooltip: 'Wpisz swoją sieć',
      publicKey: 'Klucz publiczny',
      publicKeyTooltip: 'Wpisz swój klucz publiczny',
      providerName: 'Nazwa dostawcy',
      providerNameTooltip: 'Wpisz nazwę swojego dostawcy',
      link: 'Link',
      linkTooltip: 'Wpisz swój link',
      serviceName: 'Nazwa usługi',
      serviceNameTooltip: 'Wpisz nazwę swojej usługi',
      email: 'E-mail',
      emailTooltip: 'Wpisz swój e-mail',
      phone: 'Telefon',
      phoneTooltip: 'Wpisz swój telefon',
      username: 'Nazwa użytkownika',
      usernameTooltip: 'Wpisz swoją nazwę użytkownika',
      fullName: 'Imię i nazwisko',
      fullNameTooltip: 'Wpisz swoje imię i nazwisko',
      referenceNumber: 'Numer referencyjny',
      referenceNumberTooltip: 'Wpisz swój numer referencyjny',
      country: 'Kraj',
      countryTooltip: 'Wpisz swój kraj',
      transferProvider: 'Dostawca przelewów',
      transferProviderTooltip: 'Wpisz swojego dostawcę przelewów',
      cryptoCurrency: 'Kryptowaluta',
      cryptoCurrencyTooltip: 'Wpisz swoją kryptowalutę',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Wyróżnij najlepsze media i wideo z Instagrama lub sprzedawaj produkty za pomocą kanału Instagram z możliwością zakupów',
      blockShortText: 'Twoje najlepsze media z Instagrama',
      blockConnectTitle: 'Instagram nie jest połączony',
      blockConnectText: 'Wygląda na to, że Twoje produkty z Instagrama nie zostały jeszcze zaimportowane. Połącz swoje konto teraz',
      blockConnectButton: 'Dodaj Instagram',
      emptyList: 'Nie masz jeszcze żadnych mediów z Instagrama.',
      addInstagramUsername: 'Dodaj nazwę użytkownika Instagram',
      username: 'Nazwa użytkownika',
      downloadTakes: 'Pobieranie trwa do 2 minut',
      displayPost: 'Wyświetl post na swojej stronie',
      view: 'Widok',
      redirect: 'Przekierowanie URL',
      text: 'Tekst i przycisk',
      actionType: 'Typ akcji',
      url: 'URL',
      openInNewTab: 'Otwórz w nowej karcie',
      delete: 'Usuń',
      cancel: 'Anuluj',
      save: 'Zapisz',
      editMedia: 'Edytuj media',
      title: 'Tytuł',
      automation: 'Automatyzacja',
      automationText: 'Zautomatyzuj swoje konto za pomocą funkcji Autopilot',
      autopilot: 'Autopilot',
      autopilotTooltip: 'Prześlij post z przykładowym podpisem, a tagi/linki produktów zostaną wygenerowane automatycznie',
      switchTitle: 'Automatycznie wykrywaj tytuł, cenę, linki',
      sampleCaption: 'Przykładowy podpis: #49.99 #ŁadnaSukienka https://google.com',
      integrations: 'Integracje',
      integrationsText: 'Dodaj Instagram do swojej strony',
      connectInstagram: 'Połącz Instagram',
      connectInstagramText: 'Połącz swoje konto Instagram, aby wyświetlić wybrane posty lub Reels.',
      selectAccount: 'Wybierz konto',
      connectNewInstagram: 'Połącz nowe konto Instagram',
      continue: 'Kontynuuj',
      disconnectInstagram: 'Rozłącz Instagram',
      addTag: 'Dodaj tag',
      tagClickHint: 'Kliknij na obraz, aby umieścić tag',
      tagPositionSet: 'Pozycja ustawiona. Wypełnij poniższe szczegóły.',
      tagTypeLink: 'Link',
      tagTypeProduct: 'Produkt',
      tagLabel: 'Etykieta',
      tagSelectProduct: 'Wybierz produkt',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Wyróżnij najlepsze wideo z TikToka lub sprzedawaj produkty za pomocą kanału TikTok z możliwością zakupów',
      blockShortText: 'Twoje najlepsze wideo z TikToka',
      addTikTok: 'Dodaj konto TikTok',
      individualVideo: 'Pojedyncze wideo',
      videoCollection: 'Kolekcja wideo',
      add: 'Dodaj',
      blockConnectTitle: 'TikTok nie jest połączony',
      blockConnectText: 'Wygląda na to, że Twoje produkty z TikToka nie zostały jeszcze zaimportowane. Połącz swoje konto teraz',
      blockConnectButton: 'Połącz TikTok',
      enterUsername: 'Wpisz nazwę użytkownika',
      enterVideo: 'Wpisz URL wideo TikTok',
      emptyList: 'Nie masz jeszcze żadnych mediów z TikToka.',
      editMedia: 'Edytuj media',
      addTikTokVideo: 'Dodaj wideo TikTok',
      displayPost: 'Wyświetl post na swojej stronie',
      delete: 'Usuń',
      cancel: 'Anuluj',
      save: 'Zapisz',
      integrations: 'Integracje',
      integrationsText: 'Dodaj TikTok do swojej strony',
      connectTikTok: 'Połącz TikTok',
      disconnectTikTok: 'Rozłącz TikTok',
      individualText: `Nie możesz połączyć konta TikTok z tym typem bloku ('indywidualny').`,
      individualText2: 'Zamiast tego dodaj pojedyncze wideo TikTok.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Wyróżnij wideo lub transmisję YouTube na swojej stronie. Otaguj produkty na wideo YouTube',
      blockShortText: 'Wyróżnij wideo YouTube',
      enterYouTubeLink: 'Wpisz URL YouTube',
      enterYouTubeLinkTooltip: 'Wklej URL YouTube',
    },
    overview: {
      blockTitle: 'Przegląd',
      blockText: 'Wyróżnij wideo lub transmisję na swojej stronie. Otaguj produkty na wideo',
      blockShortText: 'Otaguj produkty na wideo',
    },
    video: {
      blockTitle: 'Wideo',
      blockText: 'Wyróżnij wideo lub transmisję na swojej stronie. Otaguj produkty na wideo',
      blockShortText: 'Wyróżnij wideo',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Wyświetl swoje Tweety na stronie UniLink, aby zwiększyć zaangażowanie',
      blockShortText: 'Wyświetl swoje Tweety',
      twitterURL: 'URL Twittera',
      twitterURLTooltip: 'Dodaj URL z Twittera, aby wygenerować kod osadzania',
      enterTwitterURL: 'Wpisz URL Twittera',
    },
    music: {
      blockTitle: 'Muzyka',
      blockText: 'Osadź utwór, playlistę Spotify, SoundCloud lub prześlij własny plik audio',
      blockShortText: 'Dodaj swoją muzykę',
      brand: 'Marka',
      brandTooltip: 'Wybierz typ dodawania muzyki',
      url: 'URL',
      embed: 'Kod osadzania',
      custom: 'Własny',
      musicUrl: 'URL muzyki',
      musicUrlTooltip: 'Wpisz URL muzyki',
      embedCodeTitle: 'Kod osadzania',
      embedCodeTooltip: 'Wklej kod osadzania swojego utworu z wybranej platformy muzycznej',
      audioFile: 'Plik audio',
      uploadAudios: 'Tutaj możesz przesyłać tylko audio',
      title: 'Tytuł',
      titleTooltip: 'Wpisz tytuł swojej muzyki',
      artist: 'Artysta',
      artistTooltip: 'Wpisz artystę swojej muzyki',
      audioFileTitle: 'Plik audio',
      audioFileTooltip: 'Nazwa Twojego pliku audio',
      coverImage: 'Obraz okładki',
      coverImageTooltip: 'Prześlij obraz dla swojej muzyki',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Osadź wideo lub transmisję Twitch na swojej stronie',
      blockShortText: 'Osadź wideo Twitch',
      twitchURL: 'URL Twitch',
      twitchURLTooltip: 'Wklej URL kanału lub nazwę kanału',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Wyświetl mój kanał Twitch',
      displayChat: 'Wyświetl mój kanał Twitch oraz czat',
    },
    splash: {
      blockTitle: 'Ekran powitalny',
      blockText: 'Baner na pełny ekran z tekstem i przyciskiem pojawia się przed załadowaniem strony, aby promować produkt lub wydarzenie',
      blockShortText: 'Baner na pełny ekran',
    },
    promo: {
      blockTitle: 'Pasek promocyjny',
      blockText: 'Wyróżnienie pozwalające zaprezentować promocje',
      blockShortText: 'Wyróżnij swoje promocje',
    },
    welcome: {
      blockTitle: 'Wiadomość powitalna',
      blockText: 'Napisz wiadomości powitalne, które zachęcają odwiedzających do rozpoczęcia rozmowy. Pojawia się na dole strony, aby powitać odwiedzających i zaoferować pomoc',
      blockShortText: 'Napisz wiadomości powitalne',
    },
    review: {
      blockTitle: 'Opinie',
      blockText: 'Opinie pomagają klientom dowiedzieć się więcej o produkcie i zdecydować, czy jest to odpowiedni produkt dla nich',
      blockShortText: 'Opinie pomagają klientom',
      name: 'Imię',
      nameTooltip: 'Wpisz imię recenzenta',
      comment: 'Komentarz',
      commentTooltip: 'Wpisz komentarz recenzenta',
      date: 'Data',
      dateTooltip: 'Wpisz datę recenzenta',
      rate: 'Ocena',
      rateTooltip: 'Ustaw ocenę opinii',
      image: 'Obraz',
      imageTooltip: 'Prześlij zdjęcie recenzenta',
    },
    coupon: {
      blockTitle: 'Kupony',
      blockText: 'Kupon online to kod rabatowy lub numer, który można zrealizować na stronie',
      blockShortText: 'Kupon online oznacza',
    },
    timer: {
      blockTitle: 'Zegar',
      blockText: 'Zegar odliczania to wirtualny zegar na stronie, który odlicza od określonej liczby lub daty, aby wskazać początek lub koniec wydarzenia lub oferty',
      blockShortText: 'Zegar odliczania',
    },
    outfit: {
      blockTitle: 'Stylizacje',
      blockText: 'Utwórz własną listę produktów',
      blockShortText: 'Utwórz listę produktów',
    },
    spacer: {
      blockTitle: 'Odstęp',
      blockText: 'Dodaj pustą przestrzeń pionową do swojej strony',
      blockShortText: 'Dodaj pustą przestrzeń',
    },
    html: {
      blockTitle: 'Kod HTML',
      blockText: `Możesz wkleić własny kod HTML na podstronę UniLink. HTML to standardowy język znaczników do tworzenia stron internetowych. Pozwala na iframe'y, sekcje, akapity i linki.`,
      blockShortText: 'Wklej własny HTML',
      markupCode: 'Kod znaczników',
      markupCodeTooltip: 'Wklej kod znaczników swojego HTML',
      strippedWarning: 'Usunięto ze względów bezpieczeństwa przy wyświetlaniu:',
    },
    unlock: {
      blockTitle: 'Odblokuj',
      blockText: 'Możesz dodać swoją odblokowywalną treść na podstronę UniLink.',
      blockShortText: 'Wklej swój odblokowywalny plik',
    },
    file: {
      blockTitle: 'Plik',
      blockText:
        'Ten blok pozwala przesyłać i udostępniać pliki, takie jak dokumenty, obrazy lub audio. Odwiedzający mogą łatwo je przeglądać lub pobierać bezpośrednio ze strony.',
      blockShortText: 'Prześlij i udostępnij swoje pliki.',
      addNewItem: 'Dodaj nowy plik',
      editFile: 'Edytuj plik',
      fileName: 'Wpisz nazwę pliku',
    },
    stat: {
      blockTitle: 'Statystyki',
      blockText:
        'Ten blok pozwala wyświetlić kluczowe informacje o Twojej stronie, takie jak wyświetlenia, odwiedzający czy zaangażowanie. Pomaga monitorować odbiorców i zrozumieć wyniki strony.',
      blockShortText: 'Dodaj statystyki do swojej strony.',
      addNewItem: 'Dodaj nową statystykę',
      editItem: 'Edytuj statystykę',
      statName: 'Wpisz nazwę statystyki',
      statValue: 'Wpisz wartość statystyki',
      statDescription: 'Wpisz opis statystyki',
      statItemFields: 'Wybierz pola do wyświetlenia.',
      feed: 'Kanał',
      slider: 'Slider',
      titleSize: 'Rozmiar tytułu',
      subtitleTitleSize: 'Możesz zmienić rozmiar tytułu',
    },
    listing: {
      blockTitle: 'Oferta',
      blockText: 'Wyświetl oferty nieruchomości lub przedmiotów z obrazami, szczegółami i cenami.',
      blockShortText: 'Dodaj oferty do swojej strony.',
    },
    rental: {
      blockTitle: 'Wynajem',
      blockText: 'Wypisz nieruchomości lub przedmioty do wynajęcia z dostępnością i cenami za okres.',
      blockShortText: 'Dodaj wynajmy do swojej strony.',
    },
    'single-product': {
      blockTitle: 'Pojedynczy produkt',
      blockText: 'Wyróżnij pojedynczy produkt z obrazem, opisem i przyciskiem zakupu.',
      blockShortText: 'Wyróżnij produkt.',
    },
    team: {
      blockTitle: 'Zespół',
      blockText: 'Przedstaw członków swojego zespołu ze zdjęciami, imionami, rolami i linkami społecznościowymi.',
      blockShortText: 'Pokaż swój zespół.',
    },
    timetable: {
      blockTitle: 'Harmonogram',
      blockText: 'Wyświetl tygodniowy harmonogram z zajęciami, wydarzeniami lub sesjami.',
      blockShortText: 'Dodaj tygodniowy harmonogram.',
    },
  },
  themeTokens: {
    title: 'Styl motywu',
    subtitle: 'Typografia, zaokrąglenia i odstępy',
    typography: 'Typografia',
    corners: 'Zaokrąglenia',
    density: 'Gęstość',
  },
  advancedDesign: {
    title: 'Zaawansowane',
    subtitle: 'Dostosuj każdą część',
    slot_title: 'Tytuł',
    slot_description: 'Opis',
    slot_label: 'Etykieta nad tytułem',
    fontSize: 'Rozmiar czcionki',
    fontWeight: 'Grubość',
    textTransform: 'Wielkość liter',
    textAlign: 'Wyrównanie',
    color: 'Kolor',
  },
  layoutPicker: {
    title: 'Układ',
    tooltip: 'Wybierz sposób ułożenia elementów',
    layout_list: 'Lista',
    layout_grid: 'Siatka',
    layout_cards: 'Karty',
  },
  importDesign: {
    title: 'Importuj design',
    subtitle: 'Odtwórz design ze zrzutu ekranu',
    upload: 'Prześlij zrzut ekranu',
    extracting: 'Analizowanie…',
    apply: 'Zastosuj do podstrony',
    applying: 'Stosowanie…',
    blocksCount: '+{n} bloków',
    applied: 'Design zastosowany — dodano {n} bloków',
  },
};
